import {
    ChampionshipReigns,
    Championships,
    Companies,
    CompanyAlerts,
    CompanyLogs,
    db,
    Events, Facilities, FeudItems,
    GimmickMatches, loadDb,
    MatchContracts,
    Matches, Negotiations, Powerups,
    Relationships, Rosters,
    SegmentItems,
    StaffMembers,
    Superstars,
    TagTeams
} from "../models/models.js";
import {
    addCompanyChampionships,
    addCompanyCompanyAlerts,
    addCompanyCompanyLogs, addCompanyEvents, addCompanyFacilities, addCompanyFeudItems,
    addCompanyGimmickMatches,
    addCompanyMessages,
    addCompanyNewsItems,
    addCompanyObjectives, addCompanyPowerups,
    addCompanyRelationships, addCompanyRosters,
    addCompanySegmentItems,
    addCompanyStaff, addCompanyTournaments, Company,
    getCompanyChampionships,
    getCompanyCompanyLogs, getCompanyDraft,
    getCompanyEvents,
    getCompanyFacilities, getCompanyFeudItems,
    getCompanyGame,
    getCompanyGimmickMatches,
    getCompanyMessages, getCompanyNewsItems,
    getCompanyObjectives,
    getCompanyPowerups,
    getCompanyRosters,
    getCompanySegmentItems,
    getCompanyStaff,
    getCompanyStoryChoices,
    getCompanyTournaments,
    removeCompanyChampionships,
    removeCompanyGimmickMatches,
    removeCompanySegmentItems,
    removeCompanyStaff
} from "../models/company.js";
import {
    addChildEvent,
    Event,
    getEventMatches,
    getEventSegments,
    getEventStreaks,
    getParentEvent
} from "../models/event.js";
import {
    addRosterFactions, addRosterFeuds,
    addRosterStaff,
    addRosterSuperstars,
    addRosterTagTeams,
    getRosterBrands,
    getRosterCompany,
    getRosterFactions,
    getRosterFeuds,
    getRosterStaff,
    getRosterSuperstars,
    getRosterTagTeams,
    removeRosterStaff, Roster
} from "../models/roster.js";
import {
    checkEventWithinDatetime,
    getDatetimeForEvent, getEventHype,
    getLatestMonthlyEvent, getNielsenRatingFromViewership,
    getStreakData
} from "./events.js";
import {
    championshipPrestigeXps,
    commaSeparate, decimalRound, eventPrestigeXps,
    facilitiesData,
    facilityLevelCosts, fanLevels, gameLimits, generateName,
    getArrayMaxByProperty,
    getCurrentGame,
    getMonthsDifference,
    getRandomChoice,
    getRandomInt,
    getRandomSample,
    getRandomUniform,
    getRealMonth,
    getRosterMemberPronoun, getTalentCompany,
    getUniqueObjects,
    getUniqueObjectsByName,
    limitValueBetweenRange,
    myround,
    objectInArray,
    reputationXpLevels,
    roleToFacilityData,
    romanizeNumber,
    staffRoles,
    toTitleCase
} from "./helpers.js";
import {
    addSuperstarsToManager,
    checkAcquireTrait,
    checkSuperstarBrandAvailability,
    checkSuperstarSegmentAvailability,
    formatSuperstarTrait,
    getEmptySuperstarGraphic,
    getRosterMemberSuperstars,
    getSuperstarChampionshipsAll,
    getSuperstarChampionshipsFromCompanyChampionships,
    getSuperstarGenderFromPronoun,
    processSuperstarLeavingCompany, removeSuperstarFactionRelationships,
    removeSuperstarManagerRelationships,
    removeSuperstarsFromManager,
    removeTraitFromSuperstar,
    retireSuperstar, vacateChampionships
} from "./superstars.js";
import {checkAreChampionshipsEqual, compareChampionships, getUniqueChampionships} from "./championships.js";
import {addGameCompanies, getGameCompanies, getGameYearlyRankings, setGameCurrentCompany} from "../models/game.js";
import {globals, globalUser} from "./globals.js";
import {
    getGameActiveCompanies,
    getGameCurrentUserCompany,
    getGameMainUserCompany, getUserControlledCompanies,
    saveGameDataToLocalStorage
} from "./games.js";
import {getObjectiveProperties} from "../models/objective.js";
import {
    addSuperstarChampionshipReigns,
    addSuperstarChampionships,
    addSuperstarRelationships,
    getSuperstarCurrentGimmick,
    getSuperstarFeuds,
    getSuperstarManagedSuperstars,
    getSuperstarMatches, getSuperstarNegotiations,
    getSuperstarOriginalRoster,
    getSuperstarStaffObject,
    getSuperstarTagTeams,
    removeSuperstarChampionships
} from "../models/superstar.js";
import {formatCompanyNameBackend, getChampionshipDisplayName, objectEquals} from "../ui/ui-helpers.js";
import {getStaffSuperstarObject} from "../models/staff.js";
import {
    createBuyoutCompleteDoctorMessage,
    createBuyoutCompleteMessage,
    createBuyoutCompleteTrainer,
    createBuyoutJoinedCompanyMessage,
    createCompetitorBuyoutAvailableMessage,
    createCompetitorBuyoutNoLongerAvailableMessage,
    createContractsChangeMessage, createCustomStartingCompanyCompetitorMessage,
    createFacilityUpgradeAvailableMessage,
    createFormingNewCompanyCurrentOwnerMessage,
    createFormingNewCompanyNewOwnerMessage,
    createIntroduceFacilitiesMessage,
    createIntroduceStaffMembersMessage, createJoinedCompanySuperstarMessage, createNewCompanyCurrentOwnerTalentMessage,
    createNewCompanyDoctorMessage, createNewCompanyInterestedTalentMessage, createNewCompanyJoinedTalentMessage,
    createNewCompanyOwnerDetailsMessage,
    createNewCompanyOwnerTalentMessage,
    createNewCompanyProducerMessage,
    createNewCompanyScoutMessage,
    createNewCompanyStaffMemberMessage,
    createNewCompanyTalentManagerMessage,
    createNewCompanyTrainerMessage,
    createNewCompetitorMessage,
    createObjectiveCompletedMessage,
    createObjectivesReviewMessage,
    createPartTimersAppearancesSignedForMessage,
    createPartTimersMessage,
    createPowerupsAwardedMessage,
    createRetirementMessage,
    createStaffFiredMessage,
    createStaffHiredMessage,
    createStaffLevelUpMessage,
    createTraitLostMessage
} from "./messages.js";
import {getTournamentEvent, getTournamentMatches, getTournamentWinnerSuperstar} from "../models/tournament.js";
import {getMatchGimmickMatch, getMatchParticipants, getMatchTournament} from "../models/match.js";
import {getTagTeamSuperstars, removeTagTeamSuperstars} from "../models/tagTeam.js";
import {getFactionSuperstars} from "../models/faction.js";
import {
    addChampionshipChampionshipReigns,
    Championship,
    getChampionshipChampionshipReigns,
    getChampionshipCurrentReign,
    getChampionshipMatchContract,
    getChampionshipSuperstar
} from "../models/championship.js";
import {getTagTeamPopularity, removeTagTeam} from "./tagTeams.js";
import {getFeudParticipantsNames} from "./feuds.js";
import {getSegmentHistoryData, getSegmentItemData} from "./segments.js";
import {getMatchHistoryData} from "./matches.js";
import {
    ChampionshipReign,
    getChampionshipReignChampionship,
    getChampionshipReignMatches,
    getChampionshipReignSuperstar
} from "../models/championshipReign.js";
import {GimmickMatch} from "../models/gimmickMatch.js";
import {SegmentItem} from "../models/segmentItem.js";
import {CompanyLog} from "../models/companyLog.js";
import {getBrandColorForEvent, getBrandIndexForWeeklyShow, removeObjectBrand, setObjectBrand} from "./brands.js";
import {Relationship} from "../models/relationship.js";
import {traitsData} from "../data/traits.js";
import {CompanyAlert} from "../models/companyAlert.js";
import {
    getPropertyChampionships,
    getPropertyGimmickMatches,
    getPropertyObjective,
    getPropertySuperstars
} from "../models/property.js";
import {checkTalentRequestAction} from "./talentRequests.js";
import {generateNewsItem} from "./news.js";
import {generateCompany, generateStaffMember, generateSuperstar} from "./generate.js";
import {
    getAnnualTournamentAllParticipantIds,
    getAnnualTournamentParticipantOrganizationName
} from "./annualTournament.js";
import {awardPowerup, getPowerupsToUnlock} from "./powerups.js";
import {generateCompanyObjectives} from "./objectives.js";
import {getScenarioCompanyInformation} from "./scenarios.js";
import {getFeudParticipants} from "../models/feud.js";
import {unlockSpecialSegment} from "./processMatch.js";
import {disbandFaction} from "./factions.js";
import {Facility} from "../models/facility.js";
import {getYearlyRankingData} from "./rankings.js";
import {loadUser} from "./user.js";
import {checkToGoToNextTutorialState} from "./tutorial.js";
import {FeudItem} from "../models/feudItem.js";
import {Powerup} from "../models/powerup.js";

async function getCompanyMainRosterSuperstars(company) {
    const mainRoster = await getCompanyRosterByType(company, 'main');
    return getRosterSuperstars(mainRoster);
}

async function getCompanyRosterByType(company, rosterType, companyRosters = null) {
    if (!companyRosters) {
        companyRosters = await getCompanyRosters(company);
    }
    return companyRosters.find(x => x.type === rosterType);
}

function getCompanyLatestEvent(company) {
    if (!company.gameId) {
        return;
    }
    return Events.find({'companyId': company.$loki}).reverse()[0];
}

async function getCurrentMonth(company, parentEvents = null) {  // Previously get_current_month
    let companyEvents = await getCompanyEvents(company);

    // Get parent event names
    if (!parentEvents) {
        parentEvents = companyEvents.slice(0, 12);
    }
    let parentEventNames = parentEvents.map(x => x.name);

    // Get latest monthly event
    let latestMonthlyEvent = getLatestMonthlyEvent(companyEvents);

    // Get name of latest monthly event
    let latestMonthlyEventName = latestMonthlyEvent.name;
    if (!parentEventNames.includes(latestMonthlyEvent.name)) {
        // If event name changed, use parent event name
        let latestMonthlyEventParent = await getParentEvent(latestMonthlyEvent);
        if (latestMonthlyEventParent) {
            latestMonthlyEventName = latestMonthlyEventParent.name
        }
    }

    // Get current month using index of latest monthly event name
    return parentEventNames.indexOf(latestMonthlyEventName);
}

async function getCompanyStartingMonth(startingEvents) {
    // Get starting month index by getting index of starting event in parent events
    let startingMonth;
    const firstEvent = startingEvents[startingEvents.length - 1];
    const parentEventNames = startingEvents.slice(0, 12).map(x => x.name);
    if (parentEventNames.indexOf(firstEvent.name) > 0) {
        startingMonth = parentEventNames.indexOf(firstEvent.name)
    }
    else {
        // If first event's name changed, use parent event
        const firstEventParentEvent = await getParentEvent(firstEvent);
        startingMonth = parentEventNames.indexOf(firstEventParentEvent.name)
    }
    return startingMonth;

}

async function getBuyoutData(companyToBuyout, userCompany) {
    let data = {};
    const companyToBuyoutSuperstars = await getCompanyMainRosterSuperstars(companyToBuyout);
    const [availableSuperstars, _] = await getBuyoutSuperstars(companyToBuyout, companyToBuyoutSuperstars, userCompany);
    const numberOfBuyoutSignings = getNumberOfBuyoutSignings(companyToBuyout);
    const companyToBuyoutChampionships = await getCompanyChampionships(companyToBuyout);

    data['companyName'] = companyToBuyout.name;
    data['companyUid'] = companyToBuyout.$loki;
    data['ownerName'] = userCompany.ownerName ? userCompany.ownerName : 'The owner';
    data['signingsAvailable'] = numberOfBuyoutSignings;

    // Get superstars, sort by popularity
    data['superstars'] = companyToBuyoutSuperstars.map(x => {
        return {
            'name': x.name, 'popularity': x.popularity, 'age': x.age,
            'uid': x.$loki, 'appearances': x.partTimer ? x.appearances : null,
            'retired': x.retired,
            'injured': x.injured > 0 ? x.injured : false,
            'championships': getSuperstarChampionshipsAll(x, companyToBuyoutChampionships),
            'available': objectInArray(x, availableSuperstars),
            'fullTimeManager': x.fullTimeManager
        }
    });
    data['superstars'].sort((a, b) => b.popularity - a.popularity);

    // Get unique championships, sort by rank
    let uniqueChampionships = getUniqueChampionships(companyToBuyoutChampionships);
    uniqueChampionships.sort(compareChampionships);
    data['championships'] = uniqueChampionships.map(x => {
        return {
            'name': x.name, 'rank': x.rank, 'tag': x.tagTeam, 'trio': x.trio,
            'prestige': x.prestige, 'uid': x.$loki
        }
    });
    data['championshipsAvailable'] = 3;

    return data;
}

async function getBuyoutSuperstars(companyToBuyout, rosterSuperstars, userCompany) {  // Previously get_buyout_superstars
    rosterSuperstars.sort((a, b) => a.$loki - b.$loki);
    const companyRandom = new Math.seedrandom(companyToBuyout.meta.created);

    // Get percentage of superstars that will be available
    const talentManager = getHighestLevelStaffMemberByRole((await getCompanyStaff(userCompany)), 'talent_manager');
    const talentManagerLevel = talentManager ? talentManager.level : 1;
    const percentageAvailableDict = {1: [0.4, 0.5], 2: [0.5, 0.6], 3: [0.6, 0.7], "default": [0.4, 0.5]};
    const percentageAvailableRange = percentageAvailableDict[talentManagerLevel] || percentageAvailableDict['default'];
    const percentageAvailableValue = getRandomUniform(percentageAvailableRange[0], percentageAvailableRange[1],
        companyRandom());

    // Get available / not available superstars
    const numberAvailable = Math.round(percentageAvailableValue * rosterSuperstars.length);
    const available = getRandomSample(rosterSuperstars, numberAvailable, companyRandom);
    const notAvailable = rosterSuperstars.filter(x => !objectInArray(x, available));

    return [available, notAvailable];
}

function getNumberOfBuyoutSignings(company) {  // Previously get_number_of_buyout_signings
    const companyRandom = new Math.seedrandom(company.meta.created);
    return getRandomInt(12, 18, companyRandom());
}

async function runningBuyoutCheck(company, game) {
    let check = false;

    const gameCompanies = await getGameActiveCompanies(game);
    const companyToBuyout = gameCompanies.find(x => x.operatingStatus.includes("Running Buyout"));
    if (companyToBuyout && globalUser.paid) {

        // Check if company doing buyout is selected for local multiplayer
        let localMultiplayerBuyoutCheck = true;
        if (game.settings['control_multiple_companies']) {
            localMultiplayerBuyoutCheck = false;
            const companyPerformingBuyoutName = companyToBuyout.operatingStatus.split(' ').slice(3).join(' ');
            if (company.name === companyPerformingBuyoutName) {
                localMultiplayerBuyoutCheck = true;
            }
            else {
                // If company doing buyout not found (e.g company name changed), run buyout for any user company
                const userControlledCompanies = gameCompanies.filter(x => x.userControlled);
                if (!userControlledCompanies.some(x => x.name === companyPerformingBuyoutName)) {
                    localMultiplayerBuyoutCheck = true;
                }
            }
        }

        if (localMultiplayerBuyoutCheck) {
            check = true;
        }
    }

    return [check, companyToBuyout];
}

async function getCompanyParentEvents(company) {
    return Events.chain().find({'companyId': company.$loki}).limit(12).data();
}

async function getViewCompaniesData() {  // get_competitors
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    // Get data for all active companies
    let data = {};
    const activeCompanies = await getGameActiveCompanies(currentGame);
    data['companies'] = activeCompanies.map(x => getViewCompanyData(x, userCompany));

    // Sort by fans
    data['companies'].sort((a, b) => b.fans - a.fans);
    data['formingNewCompany'] = userCompany.newCompanyData?.monthsToForm !== undefined;

    return data;
}

function getViewCompanyData(company, userCompany) {  // get_company_data
    let data = {};

    data['name'] = company.name;
    data['fans'] = company.fans;
    data['points'] = company.points;
    data['reputation'] = company.reputation;
    data['highestReputation'] = company.highestReputation;
    data['style'] = company.style;
    data['uid'] = company.$loki;
    data['availableForBuyout'] = company.operatingStatus === 'Buyout Available';
    data['overness'] = company.overness;
    data['hot'] = company.hot;
    data['stale'] = company.stale;
    data['ownerName'] = company.ownerName;
    data['playerName'] = company.playerName;
    data['isUserCompany'] = company.$loki === userCompany.$loki;
    data['isUserControlled'] = company.userControlled;

    return data
}

async function getActiveCompetitorsForCompany(company, game) {  // Previously get_competitors_for_company
    const activeCompanies = await getGameActiveCompanies(game);
    return activeCompanies.filter(x => x.$loki !== company.$loki);
}

function getCompanyRosterCapacity(company, game) {  // Previously get_company_roster_capacity
    const reputationCapacityData = {1: 20, 2: 25, 3: 35, 4: 45, 5: 60, 6: 75, 7: 95, 8: 115, 9: 140, 10: 180};

    // If maximum roster capacity selected, get max value
    if (company.userControlled && game.settings["maximum_roster_capacity"]) {
        return gameLimits.maxRosterSuperstars
    }
    // Otherwise get value from company's reputation
    else {
        return reputationCapacityData[company.reputation]
    }
}

async function getCompanySelectData() {
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    // Get data for active companies
    const activeCompanies = await getGameActiveCompanies(currentGame);
    let data = activeCompanies.map(x => {
        return {"name": x.name, "uid": x.$loki, "isCompetitor": x.$loki !== userCompany.$loki}
    });
    // Sort by user company first
    data.sort((a, b) => a.isCompetitor - b.isCompetitor);

    return data;
}

async function getMakeTradeOfferData() {  // get_trade_offer_competitors
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    // Get competitors sorted by highest reputation
    let data = {};
    const competitors = await getActiveCompetitorsForCompany(userCompany, currentGame);
    competitors.sort((a, b) => b.reputation - a.reputation);
    data["competitors"] = competitors.map(x => {
        return {"name": x.name, "uid": x.$loki}
    });
    data["userCompanyName"] = userCompany.name;

    return data;
}

function getHighestLevelStaffMemberByRole(staffMembers, role) {  // Previously get_highest_level_staff_member_by_role
    let staffMember = null;

    const availableStaffMembers = getAvailableStaffMembers(staffMembers);
    const roleStaffMembers = availableStaffMembers.filter(x => x.role === role);
    if (roleStaffMembers.length > 0) {
        staffMember = getArrayMaxByProperty(roleStaffMembers, 'level')
    }

    return staffMember;
}

function getRandomStaffMemberByRole(staffMembers, role) {  // get_random_staff_member_by_role
    let staffMember = null;

    const availableStaffMembers = getAvailableStaffMembers(staffMembers);
    const roleStaffMembers = availableStaffMembers.filter(x => x.role === role);
    if (roleStaffMembers.length > 0) {
        staffMember = getRandomChoice(roleStaffMembers)
    }

    return staffMember;
}

function getAvailableStaffMembers(staffMembers) {  // Previously get_available_staff_members
    return staffMembers.filter(x => x.unavailableMonths <= 0 && !x.retired);
}

function getAvailableStaffMembersByRole(staffMembers, role) {  // Previously get_available_staff_members_for_company
    return getAvailableStaffMembers(staffMembers).filter(x => x.role === role);
}

async function getViewObjectivesData() {  // _get_objectives
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    // Get data for current objectives
    let data = {};
    const objectives = (await getCompanyObjectives(userCompany)).filter(x => !x.past);
    data['objectives'] = await Promise.all(
        objectives.map(x => getObjectiveData(x))
    );

    // Check tutorial action
    if (userCompany.storyName === 'tutorial') {
        data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['goals']);
        db.saveDatabase();
    }

    return data;
}

async function getObjectiveData(objective) {  // Previously get_objective
    let data = {};
    const objectiveProperty = (await getObjectiveProperties(objective))[0];

    data['name'] = objective.name;
    data['completed'] = objective.completed;
    data['failed'] = objective.failed;
    data['helpText'] = objective.helpText;
    data['value'] = objectiveProperty.value;
    data['activationValue'] = objectiveProperty.activationValue;

    return data
}

async function reviewObjectives(company, game) {  // review_objectives
    let data = {};
    let companyObjectives = await getCompanyObjectives(company);
    let unlockedPowerups = [];
    let awardedPowerups = [];

    if (!company.yearlyReviewRun && getCompanyMonth(company, game) === 0 && getCompanyYear(company, game) > 0 && !company.storyName) {

        // Review last year's objectives (current objectives)
        let lastYearsObjectives = companyObjectives.filter(x => !x.past);
        let completedObjectives = lastYearsObjectives.filter(x => x.completed && !x.past);
        let failedObjectives = lastYearsObjectives.filter(x => !x.completed && !x.past);
        data['numberOfCompletedObjectives'] = completedObjectives.length;

        if (completedObjectives.length === lastYearsObjectives.length) {
            // Add points
            let points = myround(Math.pow(game.year, 0.45) * 200, 10);
            if (points > 500) {
                points = 500;
            }
            company.points += points;
            data['bonus'] = points;

            // Generate and add special gimmick match for entertainment companies
            let newMatch = await generateSpecialGimmickMatch();
            await addCompanyGimmickMatches(company, [newMatch]);
            data['newMatch'] = newMatch.name;

            // Unlock as many powerups as objectives completed
            let powerups = await getCompanyPowerups(company);
            if (powerups.length) {
                for (let x of Array(completedObjectives.length).keys()) {
                    await awardOrUnlockPowerup(powerups)
                }
            }
        }
        else if (completedObjectives.length === lastYearsObjectives.length - 1) {
            // Unlock powerup
            let powerups = await getCompanyPowerups(company);
            if (powerups.length) {
                await awardOrUnlockPowerup(powerups)
            }
        }
        else if (failedObjectives.length === lastYearsObjectives.length) {
            // Remove points
            let points = myround(Math.pow(game.year, 0.7) * 100, 10);
            if (points > 500) {
                points = 500;
            }
            company.points -= points;
            if (company.points < 0) {
                company.points = 0;
            }
            data['punishment'] = points;
        }

        company.yearlyReviewRun = true;

        // Set last year's objectives as past
        for (let x of lastYearsObjectives) {
            x.past = true;
        }

        // Generate new objectives
        let newObjectives = await generateCompanyObjectives(company, game);
        await addCompanyObjectives(company, newObjectives);

        // Add messages
        let reviewMessage = await createObjectivesReviewMessage(data, company, game);
        if (reviewMessage) {
            await addCompanyMessages(company, [reviewMessage]);
        }
        if (unlockedPowerups.length > 0 || awardedPowerups.length > 0) {
            let powerupsMessage = await createPowerupsAwardedMessage(unlockedPowerups, awardedPowerups, company, game);
            await addCompanyMessages(company, [powerupsMessage]);
        }
    }

    async function awardOrUnlockPowerup(p) {
        // Unlock powerup
        let powerupsToUnlock = getPowerupsToUnlock(p);
        if (powerupsToUnlock.length) {
            let unlockedPowerup = awardPowerup(powerupsToUnlock, true, true);
            unlockedPowerups.push({
                name: unlockedPowerup.name, level: unlockedPowerup.level,
                storyName: unlockedPowerup.storyName
            });
        }
        // Award an unlocked powerup if all unlocked
        else {
            let powerupsToAward = p.filter(x => x.unlocked);
            let unlockedPowerup = awardPowerup(powerupsToAward, false, true);
            awardedPowerups.push({
                name: unlockedPowerup.name, level: unlockedPowerup.level,
                storyName: unlockedPowerup.storyName
            });
        }
    }

    return data;
}

async function generateSpecialGimmickMatch() {  // generate_special_gimmick_match
    let match = GimmickMatch();
    await GimmickMatches.insert(match);
    match.name = generateGimmickMatchName();
    match.ratingBoost = myround(getRandomUniform(1.2, 1.325), 0.01);
    match.popularityIncrease = myround(getRandomUniform(2, 3), 0.01);
    match.popularityDecrease = myround(getRandomUniform(0.6, 0.35), 0.01);
    match.injuryRate = myround(getRandomUniform(1.15, 1.225), 0.01);
    match.available = true;
    match.special = true;

    // Add cost
    let scaledCost = Math.pow(((1 - match.ratingBoost) * 10), 2) * 30;
    let deviation = getRandomInt(Math.floor(scaledCost * -0.2), 0);
    let cost = Math.round(scaledCost + deviation);
    if (cost <= 0) {
        cost = 5;
    }
    cost = myround(cost * 0.6, 10);
    match.cost = cost;

    // Add random weapons
    match.addRandomWeapons = true;

    return match;
}

async function getViewManagementActivityData() {  // _get_management_activity

    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const companyLogs = (await getCompanyCompanyLogs(userCompany)).reverse();
    const startingEvents = Events.chain().limit(13).data();
    const startingMonth  = await getCompanyStartingMonth(startingEvents);
    const mainRosterSuperstars = await getRosterSuperstars(mainRoster);

    // Add data from company logs
    for (const key of ['signings', 'callups', 'releases', 'championshipsRebranded', 'eventsRebranded',
        'companyRebranded', 'superstarsSuspended', 'tradeDeals', 'brandsCreated', 'brandsRemoved']) {
        const keyTypes = {
            'signings': 'signing',
            'callups': 'callup',
            'releases': 'release',
            'championshipsRebranded': 'rebrand-championship',
            'eventsRebranded': 'rebrand-event',
            'companyRebranded': 'rebrand-company',
            'superstarsSuspended': 'suspension',
            'tradeDeals': 'trade-deal',
            'brandsCreated': 'brand-created',
            'brandsRemoved': 'brand-removed'
        };
        const keyType = keyTypes[key];
        const keyCompanyLogs = companyLogs.filter(x => x.type === keyType);
        data[key] = keyCompanyLogs.map(x => {
            return {'name': x.text, 'value': x.value, 'date': `${getRealMonth(x.month, startingMonth)} ${x.year}`}
        });
    }

    // Get on trade superstars
    const onTradeSuperstars = mainRosterSuperstars.filter(x => x.activeEffect === 'traded');
    data['onTradeTalent'] = await Promise.all(onTradeSuperstars.map(async y => {
        const originalRoster = await getSuperstarOriginalRoster(y);
        let companyName = '';
        if (originalRoster) {
            companyName = (await getRosterCompany(originalRoster))?.name
        }
        return {'name': y.name, 'appearances': y.appearances, 'company': companyName}
    }));
    data['onTradeTalent'].sort((a, b) => a.appearances - b.appearances);

    return data;
}

async function getFanHistoryData(graphType, timePeriod, showBrandsSeparately) {  // Previously get_fan_history

    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const allCompanies = await getGameActiveCompanies(currentGame);
    let colors = [
        ["#d63d29", "#ab2e22", "#702015"],
        ["#4e77c2", "#395b96", "#25375c"],
        ["#c9a136", "#9e7f2b", "#63501b"],
        ["#8657d0", "#6a46a6", "#452d6b"],
        ["#50aeb5", "#3d858a", "#234c4f"],
        ["#8db021", "#6a8519", "#3b4a0e"],
        ["#cc7432", "#a1602b", "#663b1a"],
        ["#68a3d5", "#5088ab", "#375570"],
        ["#d04a91", "#a63c74", "#6b274b"],
        ["#9e99d4", "#7e7bab", "#524f6e"],
        ["#98b273", "#738754", "#414d32"],
        ["#cd90cd", "#a175a1", "#664766"],
        ["#408734", "#3c7830", "#295421"],
        ["#ce9e72", "#a18055", "#664e38"],
        ["#2f6f98", "#26597a", "#18384d"],
        ["#cf787e", "#a36262", "#693d40"],
        ["#b2a46b", "#877b51", "#595136"],
        ["#61bc8b", "#4d946e", "#2e5942"],
        ["#7c382c", "#632d23", "#4a211a"],
        ["#707734", "#525e23", "#41451e"],
        ["#a44d72", "#803c59", "#663047"]
    ];

    // Check if paid
    const tutorialGoalsState = userCompany.storyName === 'tutorial' && await getTutorialStateName(userCompany) === 'goals';
    if (!globalUser.paid && !tutorialGoalsState) {
        data['error'] = 'paid-only';
        return data;
    }

    // Get fan history data for each company's events
    const fanHistoryData = [];
    for (const company of allCompanies) {
        const roster = await getCompanyRosterByType(company, 'main');
        const rosterBrands = await getRosterBrands(roster);
        const companyIndex = allCompanies.indexOf(company);

        // Get events
        let events = await getCompanyEvents(company);
        if (graphType === 'buys') {
            events = events.filter(x => !x.weeklyShow)
        }
        else if (graphType === 'viewers') {
            events = events.filter(x => x.weeklyShow)
        }
        events = events.filter(x => x.rating !== null);

        // Get datetime of latest event
        let latestEventDatetime;
        if (events.length > 0) {
            latestEventDatetime = getDatetimeForEvent(events[events.length - 1], rosterBrands)
        }

        // Get data for brand events separately if selected
        if (rosterBrands.length > 0 && showBrandsSeparately) {
            for (const brand of rosterBrands) {
                const brandEvents = events.filter(x => x.name === brand.weeklyShowName || x.brandName === brand.name);
                const eventsData = getFanHistoryEventsData(brandEvents, rosterBrands, timePeriod, graphType, latestEventDatetime);
                const brandIndex = rosterBrands.indexOf(brand);
                const brandColor = brand.color || (colors[companyIndex] ? colors[companyIndex][brandIndex] : '#5d5d5d');
                fanHistoryData.push({'name': formatCompanyNameBackend(brand.name), 'data': eventsData, 'color': brandColor,
                    'companyXp': company.xp, 'companyId': company.$loki, 'userControlled': company.userControlled});
            }
        }
        // Get data for company events
        else {
            const eventsData = getFanHistoryEventsData(events, rosterBrands, timePeriod, graphType, latestEventDatetime);
            let color = colors[companyIndex] ? colors[companyIndex][0] : '#5d5d5d';
            fanHistoryData.push({'name': formatCompanyNameBackend(company.name), 'data': eventsData, 'color': color,
                'companyXp': company.xp, 'companyId': company.$loki, 'userControlled': company.userControlled});
        }
    }

    // Sort by company xp (except main user company)
    fanHistoryData.sort((a, b) => {
        if (a.companyId !== userCompany.$loki && b.companyId !== userCompany.$loki) {
           return b.companyXp - a.companyXp
        }
    });

    data['fanHistoryData'] = fanHistoryData;

    return data;
}

function getFanHistoryEventsData(events, rosterBrands, timePeriod, graphType, latestEventDatetime) {  // Previously get_fan_history_events_data
    const eventsData = [];
    for (const event of events) {

        // Get event name
        let eventName;
        if (event.weeklyShow) {
            eventName = event.name;
        }
        else {
            const brandName = (event.brandName) ? ` ${event.brandName}` : '';
            eventName = `${event.name} ${event.year}${brandName}`
        }

        // Check if event within time period
        const eventDatetime = getDatetimeForEvent(event, rosterBrands);
        if (checkEventWithinDatetime(eventDatetime, latestEventDatetime, timePeriod)) {
            // Add event date
            let yAxisValue;
            if (graphType === 'fans') {
                yAxisValue = event.totalFans;
            }
            else if (graphType === 'fan-change') {
                yAxisValue = event.fansGained;
            }
            else if (graphType === 'star-rating') {
                yAxisValue = event.rating;
            }
            else {
                yAxisValue = event.viewership;
            }
            eventsData.push({'x': eventDatetime, 'y': yAxisValue, 'description': eventName})
        }
    }

    return eventsData;
}

async function getViewCompanyStaffData() {  // Previously get_company_staff
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyStaffMembers = await getCompanyStaff(userCompany);

    // Get data for active and retired staff members
    const activeStaffMembers = companyStaffMembers.filter(x => !x.retired);
    const retiredStaffMembers = companyStaffMembers.filter(x => x.retired);
    data['activeStaffMembers'] = activeStaffMembers.map(x => getStaffMemberData(x));
    data['retiredStaffMembers'] = retiredStaffMembers.map(x => getStaffMemberData(x));

    // Get number hired/available for each staff role
    data['staffRoleNumbers'] = {};
    for (const staffRole of staffRoles) {
        const roleData = {};
        const companyRoles = activeStaffMembers.filter(x => x.role === staffRole);
        roleData['numberHired'] = companyRoles.length;

        const facilityName = roleToFacilityData[staffRole];
        const facility = (await getCompanyFacilities(userCompany)).find(x => x.name === facilityName);
        roleData['numberAvailable'] = getNumberOfStaffForFacility(facility);

        data['staffRoleNumbers'][staffRole] = roleData;
    }
    return data;
}

function getStaffMemberData(staffMember) {  // Previously get_staff_data
    let data = {};
    data['name'] = staffMember.name;
    data['role'] = staffMember.role;
    data['pronoun'] = getRosterMemberPronoun(staffMember);
    data['age'] = staffMember.age;
    data['graphic'] = getStaffMemberGraphic(staffMember);
    data['level'] = staffMember.level;
    data['xp'] = staffMember.xp;
    data['cost'] = staffMember.cost;
    data['currentTask'] = staffMember.currentTask;
    data['monthsLeftForTask'] = staffMember.monthsLeftForTask;
    data['retired'] = staffMember.retired;
    data['unavailableMonths'] = staffMember.unavailableMonths;
    data['uid'] = staffMember.$loki;
    data['superstarObjectPresent'] = staffMember.superstarObjectId !== null;
    return data;
}

function getStaffMemberGraphic(staffMember) {  // Previously get_staff_member_graphic
    let staffMemberGraphic = JSON.parse(JSON.stringify(staffMember.graphic));
    if (!staffMemberGraphic || Object.keys(staffMemberGraphic).length === 0) {
        staffMemberGraphic = getEmptySuperstarGraphic(staffMember)
    }
    return staffMemberGraphic;
}

function getNumberOfStaffForFacility(facility) {  // Previously get_number_of_staff_for_facility
    const data = {1: 1, 2: 2, 3: 3};
    const facilityLevel = facility ? facility.level : 1;
    return data[facilityLevel] || 1;
}

async function hireStaffMember(uid) { // _hire_staff_member
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainCompany = await getGameMainUserCompany(currentGame);
    const companyStaffMembers = (await getCompanyStaff(userCompany)).filter(x => !x.retired);
    const indieAvailableRoster = await getCompanyRosterByType(mainCompany, 'indieAvailable');

    // Find staff member to hire
    const staffMember = (await getRosterStaff(indieAvailableRoster)).find(x => x.$loki === uid);

    // Check if staff found
    if (!staffMember) {
        data['error'] = 'not-found';
        return data;
    }

    // Check paid
    if (!globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // Check if enough points
    if (userCompany.points < staffMember.cost) {
        data['error'] = 'points';
        return data;
    }

    // Check if facility level allows staff member level
    const role = staffMember.role;
    const facilityName = roleToFacilityData[role];
    let facility;
    if (facilityName) {
        facility = (await getCompanyFacilities(userCompany)).find(x => x.name === facilityName);
        if (facility && staffMember.level > facility.level) {
            data['error'] = 'facility-level';
            data['facilityName'] = facilityName;
            data['facilityLevel'] = facility.level;
            data['role'] = role;
            return data;
        }
    }

    // Check number of staff roles present
    if (!staffMember.retired) {
        const companyRoles = companyStaffMembers.filter(x => x.role === role);
        let numberOfCompanyRoles = companyRoles.length;
        for (const companyStaffMember of companyStaffMembers) {
            // Include superstars transitioning to staff
            if (companyStaffMember.taskData && companyStaffMember.taskData['role_name'] === role) {
                numberOfCompanyRoles += 1
            }
        }
        const numberOfRoles = getNumberOfStaffForFacility(facility);
        if (numberOfCompanyRoles >= numberOfRoles) {
            data['error'] = 'max-roles';
            data['role'] = role;
            data['facilityName'] = facilityName ? facilityName : '';
            data['numberOfRoles'] = numberOfRoles;
            return data;
        }
    }

    // Add staff member to user company
    await addCompanyStaff(userCompany, [staffMember]);
    await removeRosterStaff(indieAvailableRoster, [staffMember]);

    // Remove points
    userCompany.points -= staffMember.cost;

    // Add message
    if (!staffMember.retired) {
        let newMessage;
        if (facility && facility.staffNeverHired) {
            newMessage = await createNewCompanyStaffMemberMessage(staffMember, userCompany, currentGame);
            facility.staffNeverHired = false;
        }
        else {
            newMessage = await createStaffHiredMessage(staffMember, currentGame.monthCount, currentGame.year)
        }
        await addCompanyMessages(userCompany, [newMessage]);

        // Unlock special segment
        if (staffMember.level === 3 && staffMember.role === 'doctor') {
            const user = loadUser();
            await unlockSpecialSegment(userCompany, 'Timely Rescue', currentGame.monthCount, currentGame.year);
        }
    }

    db.saveDatabase();

    // Get data to return
    data['name'] = staffMember.name;
    data['points'] = userCompany.points;
    const unreadMessages = (await getCompanyMessages(userCompany)).filter(x => !x.read);
    data['unreadMessages'] = unreadMessages.length;

    return data;
}

async function fireStaffMember(uid) {  // Previously fire_staff_member
    let data = {};
    const currentGame = await getCurrentGame();
    const mainCompany = await getGameMainUserCompany(currentGame);
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyStaffMembers = (await getCompanyStaff(userCompany)).filter(x => !x.retired);
    const indieAvailableRoster = await getCompanyRosterByType(mainCompany, 'indieAvailable');

    // Find staff member to fire
    const staffMember = companyStaffMembers.find(x => x.$loki === uid);

    // Check if staff found
    if (!staffMember) {
        data['error'] = 'not-found';
        return data;
    }

    // Remove staff member from user company
    await removeCompanyStaff(userCompany, [staffMember]);
    await addRosterStaff(indieAvailableRoster, [staffMember]);

    // Remove task
    removeStaffTaskData(staffMember);

    // Add message
    const newMessage = await createStaffFiredMessage(staffMember, currentGame.monthCount, currentGame.year);
    await addCompanyMessages(userCompany, [newMessage]);

    db.saveDatabase();

    // Get data to return
    data['name'] = staffMember.name;
    const unreadMessages = (await getCompanyMessages(userCompany)).filter(x => !x.read);
    data['unreadMessages'] = unreadMessages.length;

    return data;
}

function removeStaffTaskData(staffMember) {  // Previously remove_staff_task_data
    staffMember.currentTask = null;
    staffMember.taskData = {};
    staffMember.monthsLeftForTask = null;
    return true;
}

async function getTutorialStateName(company) {
    const storyChoices = await getCompanyStoryChoices(company);
    return storyChoices[0].choice;
}

async function getViewCompanyFacilitiesData() {  // Previously get_company_facilities
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyFacilities = await getCompanyFacilities(userCompany);

    data['facilities'] = companyFacilities.map(x => getFacilityData(x));

    // Check tutorial action
    if (userCompany.storyName === 'tutorial') {
        data['nextTutorialState'] = await checkToGoToNextTutorialState(userCompany, ['view_staff_and_facilities']);
        db.saveDatabase();
    }

    return data;
}

function getFacilityData(facility) {  // Previously get_facility_data
    let data = {};
    const levelPhrases = {2: 'a Developed', 3: 'an Advanced'};

    data['name'] = facility.name;
    data['level'] = facility.level;
    data['actionsCompleted'] = facility.actionsCompleted;
    data['uid'] = facility.$loki;
    data['levelPhrase'] = levelPhrases[facility.level];

    // Get actions to next level
    const facilityData = facilitiesData[facility.name];
    const nextLevel = facility.level + 1;
    data['actionsToNextLevel'] = facilityData['actionsToNextLevel'][nextLevel];
    data['actionName'] = facilityData['actionName'];
    data['nextLevelInfo'] = facilityData['nextLevelInfo'][facility.level] || 'No information available';

    // Last level info
    if (facility.level === 1) {
        data['lastLevelInfo'] = facilityData['nextLevelInfo'][facility.level + 1] || ''
    }
    if (facility.level < 3) {
        data['nextLevelCost'] = facilityLevelCosts[nextLevel]
    }

    return data;
}

async function upgradeCompanyFacility(uid) {  // Previously upgrade_company_facility
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyFacilities = await getCompanyFacilities(userCompany);
    const companyFacility = companyFacilities.find(x => x.$loki === uid);

    // Check paid
    if (!globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // Check facility requirements
    const levelCheck = checkFacilityLevelActionsCompleted(companyFacility);
    if (!levelCheck) {
        if (companyFacility.level >= 3) {
            data['error'] = 'max-level'
        }
        else {
            data['error'] = 'requirements-failed'
        }
        return data;
    }

    // Check cost
    const cost = facilityLevelCosts[companyFacility.level + 1];
    if (userCompany.points < cost) {
        data['error'] = 'points';
        return data;
    }

    // Upgrade facility level
    companyFacility.level += 1;
    userCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['facility'] = getFacilityData(companyFacility);
    data['points'] = userCompany.points;

    return data;
}

function checkFacilityLevelActionsCompleted(facility) {  // Previously check_facility_level_actions_completed
    if (facility.level < 3) {
        const facilityData = facilitiesData[facility.name];
        const actionsToNextLevel = facilityData['actionsToNextLevel'][facility.level + 1];
        return facility.actionsCompleted >= actionsToNextLevel;
    }
    return false;
}

async function checkFacilityUpgrade(name, company) {  // check_facility_upgrade
    if (company.userControlled) {
        const facility = (await getCompanyFacilities(company)).find(x => x.name === name);
        if (facility) {
            const oldUpgradeCheck = checkFacilityLevelActionsCompleted(facility);
            facility.actionsCompleted += 1;
            const upgradeCheck = checkFacilityLevelActionsCompleted(facility);
            if (upgradeCheck && !oldUpgradeCheck) {
                const messageData = {'name': facility.name, 'level': facility.level + 1};
                const newMessage = await createFacilityUpgradeAvailableMessage(messageData, company);
                await addCompanyMessages(company, [newMessage]);

                const newCompanyAlert = await createCompanyAlert('facilityUpgradeAvailable', facility.name);
                await addCompanyCompanyAlerts(company, [newCompanyAlert]);
            }
        }
    }

    return true;
}

async function getViewIndieStaffData() {  // Previously get_available_indie_staff
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainCompany = await getGameMainUserCompany(currentGame);
    const indieAvailableRoster = await getCompanyRosterByType(mainCompany, 'indieAvailable');

    // Fixes hiring for free users upgrading since they don't have any level 1 staff to start off with
    if ((await getCompanyFacilities(userCompany)).filter(x => x.level === 1).length > 0) {
        for (const staffRole of staffRoles) {
            // If staff member not in user's game and level 1 not available on indies, generate
            if ((await getCompanyStaff(userCompany)).filter(y => y.role === staffRole).length <= 0 &&
                (await getRosterStaff(indieAvailableRoster)).filter(z => z.level === 1 && z.role === staffRole).length <= 0) {
                const staffMember = await generateStaffMember(staffRole, 1);
                await addRosterStaff(indieAvailableRoster, [staffMember]);
                db.saveDatabase();
            }
        }
    }

    return getRosterStaffData(indieAvailableRoster);
}

async function getRosterStaffData(roster) {  // Previously get_roster_staff
    let data = [];
    const staffMembers = await getRosterStaff(roster);
    staffMembers.sort((a, b) => a.retired - b.retired || a.role.localeCompare(b.role));
    for (const staffMember of staffMembers) {
        // Add cost if not present
        if (!staffMember.cost) {
            staffMember.cost = getStaffMemberCost(staffMember);
            db.saveDatabase();
        }
        data.push(getStaffMemberData(staffMember))
    }
    return data;
}

function getStaffMemberCost(staffMember) {  // Previously get_staff_member_cost
    const scaledPoints = Math.pow(staffMember.level * 50, 1.2);
    const deviation = Math.round(scaledPoints * 0.1);
    let totalPoints = scaledPoints + getRandomInt(-deviation, deviation);
    totalPoints = myround(totalPoints, 10);
    return totalPoints;
}

async function getEditStaffMemberData(uid) {  // Previously get_staff_member_data
    let data = {};

    // Get staff member
    const staffMember = StaffMembers.get(uid);

    // Get data to return
    data['name'] = staffMember.name;
    data['pronoun'] = getRosterMemberPronoun(staffMember);
    data['graphic'] = staffMember.graphic;

    return data;
}

async function changeStaffMemberName(uid, name) {  // Previously change_staff_member_name
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companyStaffMembers = await getCompanyStaff(userCompany);
    const cost = 50;

    // Get staff member
    const staffMember = companyStaffMembers.find(x => x.$loki === uid);

    // Check if staff found
    if (!staffMember) {
        data['error'] = 'staff-not-found';
        return data;
    }

    // Check points
    if (userCompany.points < cost) {
        data['error'] = 'points';
        return data;
    }

    // Check for same name
    if (name === staffMember.name) {
        data['error']  ='same-name';
        return data;
    }

    // Check for other staff with name
    if (companyStaffMembers.map(x => x.name).indexOf(name) >= 0) {
        data['error'] = 'name-exists';
        return data;
    }

    // Change name
    if (name) {
        staffMember.name = name;
    }

    // Remove points
    userCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['points'] = userCompany.points;
    data['name'] = staffMember.name;

    return data;
}

async function changeStaffMemberPronoun(uid, pronoun) {  // Previously change_staff_member_pronoun
    let data = {};

    // Get staff member
    const staffMember = StaffMembers.get(uid);

    // Check if staff found
    if (!staffMember) {
        data['error'] = 'staff-not-found';
        return data;
    }

    // Change gender
    staffMember.gender = getSuperstarGenderFromPronoun(pronoun);

    db.saveDatabase();

    return data;
}

async function changeStaffMemberGraphic(uid, graphic) {  // Previously change_staff_member_graphic
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const cost = 15;

    // Get staff member
    const staffMember = StaffMembers.get(uid);

    // Check if staff found
    if (!staffMember) {
        data['error'] = 'staff-not-found';
        return data;
    }

    // Check points
    if (userCompany.points < cost) {
        data['error'] = 'points';
        return data;
    }

    // Change graphic
    staffMember.graphic = JSON.parse(graphic);

    // Remove points
    userCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['points'] = userCompany.points;
    data['graphic'] = staffMember.graphic;

    return data;
}

async function cancelStaffMemberTask(uid) {  // Previously cancel_staff_member_task
    let data = {};

    // Get staff member
    const staffMember = StaffMembers.get(uid);

    // Check if staff found
    if (!staffMember) {
        data['error'] = 'staff-not-found';
        return data;
    }

    // Check for buyout task
    if (staffMember.currentTask.indexOf('Negotiating') >= 0) {
        data['error'] = 'negotiating-buyout';
        return data;
    }

    // Remove task
    removeStaffTaskData(staffMember);

    db.saveDatabase();

    return data;
}

async function getYearlyRankingsHistoryData(year) {  // Previously get_yearly_rankings_view
    let data = {};
    const currentGame = await getCurrentGame();
    const yearlyRankings = (await getGameYearlyRankings(currentGame)).reverse();

    // Check if yearly rankings present
    if (yearlyRankings.length <= 0) {
        data['error'] = 'no-rankings-present';
        return data;
    }

    // Check if paid
    if (!globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // Find yearly ranking by year
    let yearlyRanking;
    if (year) {
        yearlyRanking = yearlyRankings.find(x => x.year === year)
    }
    // Get latest if no year passed
    else {
        yearlyRanking = yearlyRankings[0]
    }

    // Check if yearly ranking found
    if (!yearlyRanking) {
        data['error'] = 'ranking-not-found';
        return data;
    }

    data['ranking'] = getYearlyRankingData(yearlyRanking, currentGame);
    data['years'] = yearlyRankings.map(x => x.year);

    return data;
}

async function getAnnualTournamentHistoryData(iteration) {  // Previously get_annual_tournament_history_view
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainCompany = await getGameMainUserCompany(currentGame);

    // Check if paid
    if (!globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // Get annual tournaments
    const annualTournaments = (await getCompanyTournaments(mainCompany))
        .filter(x => x.annualTournament && x.status === 'ended');
    if (annualTournaments.length <= 0) {
        data['error'] = 'no-annual-tournament-present';
        return data;
    }

    // Get annual tournament by iteration
    let annualTournament;
    if (iteration && iteration < annualTournaments.length) {
        annualTournament = annualTournaments[iteration - 1]
    }
    else {
        annualTournament = annualTournaments[annualTournaments.length - 1]
    }

    // Get data to return
    data['annualTournament'] = await getAnnualTournamentData(annualTournament, currentGame);
    // Get iterations from 1 to number of annual tournaments
    const iterations = Array.from({length: annualTournaments.length}, (_, i) => i + 1);
    data['iterations'] = iterations.map(x => x <= 30 ? romanizeNumber(x) : x);
    data['iteration'] = annualTournaments.indexOf(annualTournament) + 1;

    return data;
}

async function getAnnualTournamentData(annualTournament, game) {  // Previously get_annual_tournament_history_data
    let data = {};
    const event = await getTournamentEvent(annualTournament);

    // Get winner and organization
    const winner = await getTournamentWinnerSuperstar(annualTournament);
    const allCompanies = await getGameCompanies(game);
    const winnerOrganizationName = getAnnualTournamentParticipantOrganizationName(winner, annualTournament, allCompanies);

    data['name'] = annualTournament.name;
    data['bracket'] = await getTournamentBracket(annualTournament, game);
    data['winner'] = annualTournament.winnerName;
    data['winnerOrganizationName'] = winnerOrganizationName;
    data['uid'] = annualTournament.$loki;
    data['year'] = event ? event.year : null;

    return data;
}

async function getAnnualTournamentStatsData() {  // Previously get_annual_tournament_stats
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainCompany = await getGameMainUserCompany(currentGame);
    const allCompanies = await getGameCompanies(currentGame);
    const previousTournaments = (await getCompanyTournaments(mainCompany))
        .filter(x => x.annualTournament && x.status === 'ended');

    let winners = [];
    let winnerOrganizations = [];
    let allParticipantIds = [];
    let matches = [];

    for (const tournament of previousTournaments) {
        // Get winners
        const winner = await getTournamentWinnerSuperstar(tournament);
        if (winner) {
            winners.push(winner)
        }

        // Get winner organizations
        const winnerOrganization = await getAnnualTournamentParticipantOrganizationName(winner, tournament,
            allCompanies);
        if (winnerOrganization) {
            winnerOrganizations.push(winnerOrganization)
        }

        // Get entries
        const participantIds = getAnnualTournamentAllParticipantIds(tournament);
        allParticipantIds.push(...participantIds);

        // Get matches
        const tournamentMatches = await getTournamentMatches(tournament);
        matches.push(...tournamentMatches);
    }

    // Get top objects
    const uniqueWinners = getUniqueObjects(winners);
    let mostWins = uniqueWinners.map(x => {
        return {'name': x.name, 'number': winners.filter(y => y.$loki === x.$loki).length}  // Get count of object
    });
    mostWins.sort((a, b) => b.number - a.number);  // Get most common objects
    data['mostWins'] = mostWins.slice(0, 3);

    const uniqueWinnerOrganizations = [...new Set(winnerOrganizations)];
    let mostOrganizationWins = uniqueWinnerOrganizations.map(x => {
        return {'name': x, 'number': winnerOrganizations.filter(y => y === x).length}
    });
    mostOrganizationWins.sort((a, b) => b.number - a.number);
    data['mostOrganizationWins'] = mostOrganizationWins.slice(0, 3);

    const uniqueParticipantIds = [...new Set(allParticipantIds)];
    let mostEntries = uniqueParticipantIds.map(x => {
        return {'id': x, 'number': allParticipantIds.filter(y => y === x).length}
    });
    mostEntries.sort((a, b) => b.number - a.number);
    data['mostEntries'] = await Promise.all(
        // Get entry name from id
        mostEntries.slice(0, 3).map(async x => {
            return {'name': (Superstars.get(x['id']))?.name, 'number': x['number']}
        })
    );

    const sortedMatches = matches.filter(x => x.rating > 3).sort((a, b) => b.rating - a.rating);
    data['bestMatches'] = await Promise.all(
        sortedMatches.slice(0, 3).map(async x => await getAnnualTournamentMatchHistoryData(x))
    );

    return data;
}

async function getAnnualTournamentMatchHistoryData(match) {  // Previously get_annual_tournament_match_history_data
    let data = {};
    const matchTournament = await getMatchTournament(match);
    data['winner'] = match.winner;
    data['loser'] = match.loser;
    data['rating'] = match.rating;
    data['tournamentName'] = matchTournament.name;
    return data;
}

async function getTournamentBracket(tournament, game, startRound = 0) {  // Previously get_tournament_bracket
    let bracket = {};
    let tournamentMatches = await getTournamentMatches(tournament);
    const allCompanies = tournament.annualTournament ? await getGameActiveCompanies(game) : [];

    // Filter and sort tournament matches
    if (startRound) {
        tournamentMatches = tournamentMatches.filter(x => x.tournamentRound > startRound)
    }
    tournamentMatches.sort((a, b) => b.order - a.order);

    // Get number of rounds
    let numberOfRounds = 1;
    if (tournamentMatches.length > 0) {
        numberOfRounds = Math.floor(Math.log2(tournamentMatches.length * 2))
    }

    // Initialize bracket with rounds
    for (let x = 1 + startRound; x < numberOfRounds + 1 + startRound; x++) {
        bracket[x] = []
    }

    // Add matches
    for (const match of tournamentMatches) {
        let matchData = {};
        const matchParticipants = await getMatchParticipants(match);
        matchParticipants.sort((a, b) => a.tournamentSeed - b.tournamentSeed);

        // Get participants data (name, tournament seed, organization name)
        if (matchParticipants.length > 0) {
            matchData['participants'] = [];
            for (const matchParticipant of matchParticipants) {
                let participantData = [matchParticipant.name, matchParticipant.tournamentSeed];
                if (tournament.annualTournament) {
                    const participantOrganizationName = getAnnualTournamentParticipantOrganizationName(matchParticipant,
                        tournament, allCompanies);
                    participantData.push(participantOrganizationName)
                }
                matchData['participants'].push(participantData);
            }
        }
        else {
            matchData['participants'] = [[null, null], [null, null]]
        }

        matchData['winnerName'] = match.winner;

        // Add using match's round
        try {
            bracket[match.tournamentRound].push(matchData)
        }
        catch (error) {}
    }

    // Add winners using next round participants
    for (let round in bracket) {
        if (bracket.hasOwnProperty(round)) {
            round = parseInt(round);
            if (round < numberOfRounds) {
                for (const match of bracket[round]) {
                    let nextRoundWinners = [];
                    for (const x of bracket[round + 1]) {
                        for (const y of x['participants']) {
                            nextRoundWinners.push(y[0])
                        }
                    }

                    let matchWinnerArray = match['participants'].find(z => nextRoundWinners.indexOf(z[0]) >= 0);
                    match['winner'] = matchWinnerArray ? matchWinnerArray[0] : null;

                    // Add using winnerName if participants not found in next round (e.g in tournament substitution)
                    if (!match['winner']) {
                        matchWinnerArray = match['participants'].find(z => z[0] === match['winnerName']);
                        match['winner'] = matchWinnerArray ? matchWinnerArray[0] : null;
                    }
                }
            }
            else {
                try {
                    // Tournament winner
                    bracket[round][0]['winner'] = tournament.winnerName;
                }
                catch (error) {}
            }
        }
    }

    return bracket;
}

async function getTournamentTable(tournament) {  // Previously get_tournament_table
    let table = [];
    let tournamentMatches = await getTournamentMatches(tournament);
    tournamentMatches.sort((a, b) => b.order - a.order);

    // Get match participants once
    for (const match of tournamentMatches) {
        match.tempParticipants = await getMatchParticipants(match);
    }

    // Divide into groups
    let groupMatches = tournamentMatches.filter(x => x.tournamentGroup !== null);
    let groupsWithMatches = {};
    for (const groupMatch of groupMatches) {
        if (groupsWithMatches[groupMatch.tournamentGroup]) {
            groupsWithMatches[groupMatch.tournamentGroup].push(groupMatch)
        }
        else {
            groupsWithMatches[groupMatch.tournamentGroup] = [groupMatch]
        }
    }

    // Add matches
    for (const [group, matches] of Object.entries(groupsWithMatches)) {
        let groupData = [];

        // Add participants using first round matches
        let participants = [];
        let firstRoundMatches = matches.filter(x => x.tournamentRound === 1);
        for (const match of firstRoundMatches) {
            for (const matchParticipant of match.tempParticipants) {
                matchParticipant.tempPoints = null;
                participants.push([matchParticipant, []]);  // [participant, matches]
            }
        }

        // Add participant matches that have been played
        for (const match of matches) {
            if (match.rating !== null) {
                for (const participant of participants) {
                    if (objectInArray(participant[0], match.tempParticipants)) {
                        participant[1].push(match)
                    }
                }
            }
        }

        // Add participant data
        for (const participant of participants) {
            let participantData = {};
            participantData['name'] = participant[0].name;
            participantData['points'] = participant[0].tournamentPoints;
            participantData['history'] = [];

            // Add temp points for tied participants based on head to head record
            const tiedParticipants = participants.filter(x => x[0].tournamentPoints === participant[0].tournamentPoints)
                .map(x => x[0]);
            if (tiedParticipants.length > 1) {
                // Create sub table of max participants
                for (const tiedParticipant of tiedParticipants) {
                    if (tiedParticipant.tempPoints === null) {  // If temp points not already added
                        tiedParticipant.tempPoints = 0;
                        const opponents = tiedParticipants.filter(x => x.$loki !== tiedParticipant.$loki);
                        for (const match of matches) {
                            // Check if participant and an opponent are in match participants
                            if (objectInArray(tiedParticipant, match.tempParticipants) &&
                                opponents.some(x => objectInArray(x, match.tempParticipants))) {
                                if (['Double Pin', 'Time-limit Draw'].indexOf(match.finishName) >= 0) {
                                    tiedParticipant.tempPoints += 1
                                }
                                else if (match.winner === tiedParticipant.name) {
                                    tiedParticipant.tempPoints += 2
                                }
                            }
                        }
                    }
                }
            }
            participantData['tempPoints'] = participant[0].tempPoints;

            // Go through matches, add records
            for (const match of participant[1]) {
                let record;
                if (['Double Pin', 'Time-limit Draw'].indexOf(match.finishName) >= 0) {
                    record = 'D'
                }
                else if (match.winner === participant[0].name) {
                    record = 'W'
                }
                else {
                    record = 'L'
                }
                participantData['history'].push(record)
            }

            groupData.push(participantData);
        }

        // Sort by points
        groupData.sort((a, b) => b.points - a.points || b.tempPoints - a.tempPoints);

        table.push(groupData);
    }

    return table;
}

async function getViewStatsData(companyUid, brandName) {  // get_company_stats_view
    let data = {};
    const currentGame = await getCurrentGame();

    // Get selected company
    let selectedCompany;
    if (companyUid) {
        selectedCompany = await Companies.get(companyUid)
    }
    else {
        selectedCompany = await getGameCurrentUserCompany(currentGame)
    }

    // Check paid
    if (!globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterBrands = await getRosterBrands(mainRoster);
    let brand = null;
    if (brandName) {
        brand = rosterBrands.find(x => x.name === brandName);
    }

    return getCompanyStats(selectedCompany, mainRoster, currentGame.monthCount, currentGame.year, rosterBrands,
        brand);
}

async function getCompanyStats(company, roster, month, year, rosterBrands, brand) {  // get_company_stats
    let data = {};

    // Define arrays
    let averageMatchRatings = [];
    let winningStreaks = [];
    let losingStreaks = [];
    let nonWorldChampions = [];
    let notTurnedSuperstars = [];
    let winPercentages = [];
    let gimmicks = [];
    let streaks = [];
    let simultaneousFeuds = [];
    let superstarsInMainEvents = [];
    let superstarsInOpeningMatches = [];
    let superstarsInFiveStarMatches = [];
    let fotcLosses = [];

    // Get brand name and weekly show name
    const brandName = brand ? brand.name : null;
    const brandWeeklyShowName = brand ? brand.weeklyShowName : null;

    // Get company/brand objects
    let superstars = (await getRosterSuperstars(roster))
        .filter(x => x.activeEffect !== 'traded' && (!brandName || x.brandName === brandName));
    let tagTeams = [];
    for (const tagTeam of (await getRosterTagTeams(roster))) {
        const tagTeamSuperstars = await getTagTeamSuperstars(tagTeam);
        tagTeam.tempPopularity = await getTagTeamPopularity(tagTeam, tagTeamSuperstars);
        if (tagTeamSuperstars.every(x => x.activeEffect !== 'traded')) {
            if (!brandName || tagTeamSuperstars.every(x => x.brandName === brandName)) {
                tagTeams.push(tagTeam)
            }
        }
    }
    let factions = [];
    for (const faction of (await getRosterFactions(roster))) {
        const factionSuperstars = await getFactionSuperstars(faction);
        if (!brandName || factionSuperstars.every(x => x.brandName === brandName)) {
            factions.push(faction)
        }
    }
    let championships = getUniqueChampionships((await getCompanyChampionships(company, false)))
        .filter(x => !brandName || x.brandName === brandName);
    const companySegmentItems = await getCompanySegmentItems(company);
    const companyEvents = (await getCompanyEvents(company)).reverse();
    let monthlyEvents = companyEvents.filter(x => !x.weeklyShow && (!brandName || x.brandName === brandName));
    let weeklyEvents = companyEvents.filter(x => x.weeklyShow && (!brandName || x.name === brandWeeklyShowName));
    const companyLogs = (await getCompanyCompanyLogs(company)).reverse();
    const championshipReigns = (await Promise.all(championships.map(x => getChampionshipChampionshipReigns(x)))).flat();
    const reignsData = await Promise.all(championshipReigns.map(x => getChampionshipReignData(x, month, year, false)));
    const activeSuperstars = superstars.filter(x => !x.retired && !x.dead && !x.fullTimeManager);

    // Get matches, segments and streaks from events
    let allEventMatches = [];
    let allEventStreaks = [];
    let allEventSegments = [];
    let brandEventIds = monthlyEvents.concat(weeklyEvents).map(x => x.$loki);
    for (const event of companyEvents) {
        const eventMatches = await getEventMatches(event);
        event.tempMatches = eventMatches;  // For getting event matches later for all events
        event.tempMatches.sort((a, b) => a.order - b.order);
        if (brandEventIds.indexOf(event.$loki) >= 0) {
            // Add if belongs to brand filter (or no filter)
            allEventMatches.push(...eventMatches);
            const eventSegments = await getEventSegments(event);
            allEventSegments.push(...eventSegments);
            if (!event.weeklyShow) {
                const eventStreaks = (await getEventStreaks(event)).filter(x => !x.ended);
                allEventStreaks.push(...eventStreaks)
            }
        }
    }

    // Non brand stats
    if (!brandName) {
        // Signature event
        const signatureEvent = monthlyEvents.reduce((prev, current) => (prev.xp > current.xp) ? prev : current);
        data['signatureEvent'] = {'name': signatureEvent.name, 'prestige': signatureEvent.prestige};

        // Iconic feuds
        const endedFeuds = (await getRosterFeuds(roster)).filter(x => x.started && x.ended);
        const sortedFeudsByRating = endedFeuds.filter(x => x.rating > 3).sort((a, b) => b.rating - a.rating);
        data['iconicFeuds'] = await Promise.all(sortedFeudsByRating.slice(0, 3).map(async x => {
            return {'name': x.name, 'rating': x.rating,
                'participants': await getFeudParticipantsNames(x)}
        }));

        // Top signings
        const sortedSigningsByValue = companyLogs.filter(x => x.type === 'signing').sort((a, b) => b.value - a.value);
        data['topSignings'] = sortedSigningsByValue.slice(0, 3).map(x => {
            return {'name': x.text, 'value': x.value, 'month': x.month, 'year': x.year}
        });

        // Top moments
        const sortedMomentsByValue = companyLogs.filter(x => ['moment', 'turn'].indexOf(x.type) >= 0)
            .sort((a, b) => b.value - a.value);
        data['topMoments'] = sortedMomentsByValue.slice(0, 5).map(x => {
            let year = x.realYear || '';
            return {'name': x.text, 'value': x.value, 'event': `${x.eventName} ${year}`}
        });

        // Shocking turns
        const shockingTurns = companyLogs.filter(x => x.type === 'turn')
            .sort((a, b) => b.value - a.value);
        data['shockingTurns'] = shockingTurns.slice(0, 3).map(x => {
            let year = x.realYear || '';
            return {'name': x.text, 'event': `${x.eventName} ${year}`}
        });

        // Awards won
        const sortedAwardsWon = companyLogs.filter(x => x.type === 'award')
            .sort((a, b) => b.year - a.year || b.value - a.value);
        data['awardsWon'] = sortedAwardsWon.map(x => {
            return {'name': x.text, 'value': x.value, 'year': x.year}
        });
    }

    // Iconic matches
    const sortedMatchesByRating = allEventMatches.filter(x => x.rating > 3)
        .sort((a, b) => b.rating - a.rating);
    data['iconicMatches'] = await Promise.all(
        sortedMatchesByRating.slice(0, 3).map(x => getMatchHistoryData(x))
    );

    // Iconic segments
    const sortedSegmentsByRating = [];
    for (const segment of allEventSegments) {
        let segmentItem = companySegmentItems.find(x => x.$loki === segment.segmentItemId);
        if (!segmentItem) {
            // Get segment item directly if removed from company
            segmentItem = SegmentItems.get(segment.segmentItemId);
        }
        if (segmentItem && !segmentItem.special && segment.rating > 3) {
            sortedSegmentsByRating.push(segment)
        }
    }
    sortedSegmentsByRating.sort((a, b) => b.rating - a.rating);
    data['iconicSegments'] = await Promise.all(
        sortedSegmentsByRating.slice(0, 3).map(x => getSegmentHistoryData(x))
    );

    // Special segments
    const specialSegments = [];
    for (const segment of allEventSegments) {
        const segmentItem = companySegmentItems.find(x => x.$loki === segment.segmentItemId);
        if (segmentItem && segmentItem.special && segment.rating !== null) {
            specialSegments.push(segment)
        }
    }
    data['specialSegments'] = await Promise.all(
        specialSegments.slice(0, 5).map(x => getSegmentHistoryData(x))
    );

    // Iconic superstars
    const sortedSuperstarsByPopularity = [...activeSuperstars].sort((a, b) => b.popularity - a.popularity);
    data['iconicSuperstars'] = sortedSuperstarsByPopularity.slice(0, 3).map(x => x.name);

    // Top face/heel superstars
    const heels = sortedSuperstarsByPopularity.filter(x => x.alignment === 'heel');
    const faces = sortedSuperstarsByPopularity.filter(x => x.alignment === 'face');
    if (heels.length > 0) {
        data['topHeelSuperstar'] = heels[0].name;
    }
    if (faces.length > 0) {
        data['topFaceSuperstar'] = faces[0].name;
    }

    // Most over superstar
    const sortedSuperstarsByOverness = [...activeSuperstars].sort((a, b) => b.overness - a.overness);
    if (sortedSuperstarsByOverness.length > 0) {
        data['mostOverSuperstar'] = sortedSuperstarsByOverness[0].name
    }

    // Iconic tag teams
    const sortedTagTeamsByPopularity = [...tagTeams].sort((a, b) => b.tempPopularity - a.tempPopularity);
    data['iconicTagTeams'] = sortedTagTeamsByPopularity.slice(0, 2).map(x => x.name);

    // Iconic factions
    const sortedFactionsByXp = [...factions].sort((a, b) => b.xp - a.xp);
    data['iconicFactions'] = sortedFactionsByXp.slice(0, 2).map(x => x.name);

    // Top championship
    if (championships.length > 0) {
        const topChampionship = championships.filter(x => !x.retired)
            .reduce((prev, current) => (prev.xp > current.xp) ? prev : current);
        data['topChampionship'] = {'name': getChampionshipDisplayName(topChampionship),
            'prestige': topChampionship.prestige};
    }

    // Iconic events
    const sortedEventsByRating = monthlyEvents.filter(x => x.rating > 3).sort((a, b) => b.rating - a.rating);
    data['iconicEvents'] = sortedEventsByRating.slice(0, 3).map(x => {
        return {'name': x.name, 'rating': x.rating, 'year': x.year}
    });

    // Most bought event
    const sortedMonthlyEventsByViewership = monthlyEvents.filter(x => x.viewership)
        .sort((a, b) => b.viewership - a.viewership);
    if (sortedMonthlyEventsByViewership.length > 0) {
        const mostBoughtEvent = sortedMonthlyEventsByViewership[0];
        data['mostBoughtEvent'] = {'name': mostBoughtEvent.name, 'buys': mostBoughtEvent.viewership,
            'year': mostBoughtEvent.year};
    }

    // Highest viewership event
    const sortedWeeklyEventsByViewership = weeklyEvents.filter(x => x.viewership)
        .sort((a, b) => b.viewership - a.viewership);
    if (sortedWeeklyEventsByViewership.length > 0) {
        const highestViewershipEvent = sortedWeeklyEventsByViewership[0];
        const eventDateOptions = {year: 'numeric', month: 'short', day: 'numeric'};
        const eventDate = getDatetimeForEvent(highestViewershipEvent, rosterBrands).toLocaleDateString("en-US", eventDateOptions);
        data['highestViewershipEvent'] = {
            'name': highestViewershipEvent.name, 'viewership': highestViewershipEvent.viewership,
            'date': eventDate
        };
    }

    // Legends
    const sortedHallOfFamersByPopularity = superstars.filter(x => x.retired && x.hallOfFamer)
        .sort((a, b) => b.popularity - a.popularity);
    data['legends'] = sortedHallOfFamersByPopularity.slice(0, 3).map(x => x.name);

    // Get data from superstars
    for (const superstar of superstars) {

        // Get superstar's matches
        const superstarMatches = await getSuperstarMatches(superstar);

        // Get data from matches
        for (const superstarMatch of superstarMatches) {
            const matchEvent = companyEvents.find(x => x.$loki === superstarMatch.eventId);
            // Only check matches at company's events
            if (matchEvent) {
                let eventMatches = matchEvent.tempMatches;

                // Check if main event or opening match
                if (superstarMatch.$loki === eventMatches[0].$loki) {
                    superstarsInMainEvents.push(superstar.name)
                } else if (superstarMatch.$loki === eventMatches[eventMatches.length - 1].$loki) {
                    superstarsInOpeningMatches.push(superstar.name)
                }

                // Check if five star match
                if (superstarMatch.rating >= 5) {
                    superstarsInFiveStarMatches.push(superstar.name)
                }
            }
        }

        // Get average match rating
        if (superstarMatches.length > 10) {
            const filteredSuperstarMatches = superstarMatches.filter(x => x.rating !== null);
            const ratingsSum = filteredSuperstarMatches.map(x => x.rating).reduce((partialSum, a) => partialSum + a, 0);
            const averageRating = ratingsSum / filteredSuperstarMatches.length;
            averageMatchRatings.push({'name': superstar.name, 'rating': decimalRound(averageRating)})
        }

        // Add winning/losing streaks
        if (superstar.winsCounter > 0) {
            winningStreaks.push({'name': superstar.name, 'length': superstar.winsCounter})
        }
        if (superstar.lossesCounter > 0) {
            losingStreaks.push({'name': superstar.name, 'length': superstar.lossesCounter})
        }

        // Check if held main event championship
        if (!brandName) {
            let beenWorldChampion = false;
            const superstarReigns = championshipReigns.filter(x => x.superstarId === superstar.$loki);
            for (const reign of superstarReigns) {
                const reignChampionship = await getChampionshipReignChampionship(reign);
                if (reignChampionship && reignChampionship.rank === 'Main Eventer') {
                    beenWorldChampion = true;
                    break
                }
            }
            if (!beenWorldChampion) {
                nonWorldChampions.push({'name': superstar.name, 'popularity': superstar.popularity})
            }
        }

        // Check if not turned
        if (superstar.alignment && superstar.alignmentMonths >= (year * 12) + month) {
            notTurnedSuperstars.push({'name': superstar.name, 'popularity': superstar.popularity})
        }

        // Add win percentages
        if (superstarMatches.length > 0) {
            const totalMatches = superstar.wins + superstar.losses;
            let winPercentage = 0;
            if (totalMatches > 0) {
                winPercentage = Math.round(superstar.wins / totalMatches * 100);
            }
            winPercentages.push({'name': superstar.name, 'winPercentage': winPercentage})
        }

        // Get current gimmick
        const gimmick = await getSuperstarCurrentGimmick(superstar);
        if (gimmick && gimmick.startMonth) {
            gimmicks.push({'name': gimmick.name, 'effectiveness': gimmick.effectiveness,
            'superstarName': superstar.name, 'startMonths': (gimmick.startYear * 12) + gimmick.startMonth})
        }

        // Get streaks
        const superstarStreaks = allEventStreaks.filter(x => x.superstarId === superstar.$loki);
        streaks.push(...superstarStreaks);

        // Get overlapping feuds
        let feuds = (await getSuperstarFeuds(superstar)).filter(x => x.started);
        let numberOfOverlappingFeuds = getNumberOfOverlappingFeuds(feuds, month, year);
        if (numberOfOverlappingFeuds > 0) {
            simultaneousFeuds.push({'name': superstar.name, 'numberOfFeuds': numberOfOverlappingFeuds})
        }

        // FotC losses
        if (superstar.faceOfTheCompany) {
            let lossesTo = superstarMatches.filter(
                x => x.loser && x.loser.indexOf(superstar.name) >= 0
            ).map(y => y.winner);
            lossesTo = [...new Set(lossesTo)];
            // Add if beaten by 3 or fewer superstars
            if (lossesTo.length > 0 && lossesTo.length <= 3) {
                fotcLosses.push({'name': superstar.name, 'losses': lossesTo})
            }
        }
    }

    // Get top worker
    if (averageMatchRatings.length > 0) {
        data['topWorker'] = averageMatchRatings.sort((a, b) => b.rating - a.rating)[0];
    }

    // Get greatest non world champion
    if (nonWorldChampions.length > 0) {
        data['greatestNonWorldChampion'] = nonWorldChampions.sort((a, b) => b.popularity - a.popularity)[0];
    }

    // Get greatest to not turn
    if (notTurnedSuperstars.length > 0) {
        data['greatestToNotTurn'] = notTurnedSuperstars.sort((a, b) => b.popularity - a.popularity)[0];
    }

    // Top win percentage
    if (winPercentages.length > 0) {
        data['topWinPercentage'] = winPercentages.sort((a, b) => b.winPercentage - a.winPercentage)[0];
    }

    // Biggest streak
    if (streaks.length > 0) {
        const biggestStreak = streaks.sort((a, b) => b.length - a.length)[0];
        data['biggestStreak'] = await getStreakData(biggestStreak);
    }

    // Longest winning streak
    if (winningStreaks.length > 0) {
        data['longestWinningStreak'] = winningStreaks.sort((a, b) => b.length - a.length)[0];
    }

    // Longest losing streak
    if (losingStreaks.length > 0) {
        data['longestLosingStreak'] = losingStreaks.sort((a, b) => b.length - a.length)[0];
    }

    // Most simultaneous feuds
    if (simultaneousFeuds.length > 0) {
        data['mostSimultaneousFeuds'] = simultaneousFeuds.sort((a, b) => b.numberOfFeuds - a.numberOfFeuds)[0];
    }

    // Fotc losses
    if (fotcLosses.length > 0) {
        data['fotcLosses'] = fotcLosses.sort((a, b) => a.losses.length - b.losses.length)[0]
    }

    // Best/worst/longest gimmick
    if (gimmicks.length > 0) {
        const gimmicksSortedByEffectiveness = gimmicks.sort((a, b) => b.effectiveness - a.effectiveness);
        data['bestGimmick'] = gimmicksSortedByEffectiveness[0];
        // Don't make worst and best gimmick the same
        if (gimmicks.length > 1) {
            data['worstGimmick'] = gimmicksSortedByEffectiveness[gimmicksSortedByEffectiveness.length - 1]
        }
        data['longestGimmick'] = gimmicks.sort((a, b) => a.startMonths - b.startMonths)[0];
    }

    // Longest/shortest reign
    if (reignsData.length > 0) {
        const reignsSortedByLength = [...reignsData].sort((a, b) => b.length - a.length);
        data['longestReign'] = reignsSortedByLength[0];
        data['shortestReign'] = reignsSortedByLength[reignsSortedByLength.length - 1];
    }

    // Most 5 star matches
    if (superstarsInFiveStarMatches.length > 0) {
        const uniqueSuperstarsInFiveStarMatches = [...new Set(superstarsInFiveStarMatches)];
        let mostFiveStarMatches = uniqueSuperstarsInFiveStarMatches.map(x => {
            return {'name': x, 'number': superstarsInFiveStarMatches.filter(y => y === x).length}  // Get count of object
        });
        data['mostFiveStarMatches'] = mostFiveStarMatches.sort((a, b) => b.number - a.number)[0];
    }

    // Most main events
    if (superstarsInMainEvents.length > 0) {
        const uniqueSuperstarsInMainEvents = [...new Set(superstarsInMainEvents)];
        let mostMainEvents = uniqueSuperstarsInMainEvents.map(x => {
            return {'name': x, 'number': superstarsInMainEvents.filter(y => y === x).length}
        });
        data['mostMainEvents'] = mostMainEvents.sort((a, b) => b.number - a.number)[0];
    }

    // Most opening matches
    if (superstarsInOpeningMatches.length > 0) {
        const uniqueSuperstarsInOpeningMatches = [...new Set(superstarsInOpeningMatches)];
        let mostOpeningMatches = uniqueSuperstarsInOpeningMatches.map(x => {
            return {'name': x, 'number': superstarsInOpeningMatches.filter(y => y === x).length}
        });
        data['mostOpeningMatches'] = mostOpeningMatches.sort((a, b) => b.number - a.number)[0];
    }

    // Most championships held
    const reignChampions = reignsData.map(x => x['championName']);
    if (reignChampions.length > 0) {
        const uniqueChampions = [...new Set(reignChampions)];
        let mostChampionshipsHeld = uniqueChampions.map(x => {
            return {'name': x, 'number': reignChampions.filter(y => y === x).length}
        });
        data['mostChampionshipsHeld'] = mostChampionshipsHeld.sort((a, b) => b.number - a.number)[0];
    }

    // Most world championships held
    const reignWorldChampions = reignsData.filter(x => x['championshipRank'] === 'Main Eventer')
        .map(y => y['championName']);
    if (reignWorldChampions.length > 0) {
        const uniqueWorldChampions = [...new Set(reignWorldChampions)];
        let mostWorldChampionshipsHeld = uniqueWorldChampions.map(x => {
            return {'name': x, 'number': reignWorldChampions.filter(y => y === x).length}
        });
        data['mostWorldChampionshipsHeld'] = mostWorldChampionshipsHeld
            .sort((a, b) => b.number - a.number)[0];
    }

    // Get data to return
    data['companyName'] = company.name;
    data['brandName'] = brandName;
    data['brandNames'] = rosterBrands.map(x => x.name);
    data['inactive'] = company.operatingStatus === 'Inactive';

    return data;
}

async function getChampionshipReignData(championshipReign, month, year,
                                        getMatchesData = false, championship = null) {  // get_reign_data
    let data = {};
    if (!championship) {
        championship = await getChampionshipReignChampionship(championshipReign)
    }
    let matches = (await getChampionshipReignMatches(championshipReign)).reverse();

    // Get matches data
    if (getMatchesData) {
        data['matchesData'] = await Promise.all(matches.map(x => getMatchHistoryData(x)));
    }

    // Get number of defenses
    let numberOfDefenses;
    if (matches.length > 0 && matches[matches.length - 1].championshipsWon) {
        numberOfDefenses = matches.length - 1  // Lost in last defense
    }
    else {
        numberOfDefenses = matches.length
    }
    if (numberOfDefenses < 0) {
        numberOfDefenses = 0
    }
    data['numberOfDefenses'] = numberOfDefenses;

    // Get champion name
    if (matches.length > 0) {
        data['championName'] = matches.reverse()[0].winner  // Add name from first match
    }
    else {
        // For first champion without defenses, get holder_name
        if (championshipReign.holderName) {
            data['championName'] = championshipReign.holderName
        }
        else {
            let reignSuperstar = (await getChampionshipReignSuperstar(championshipReign));
            // Fix for current games without holder name, get champion name using reign.superstar
            if (championship.tagTeam || championship.trio) {
                let teams = (await getSuperstarTagTeams(reignSuperstar)).filter(x => !x.temporary);
                if (championship.trio) {
                    teams = teams.filter(x => x.trio)
                }
                data['championName'] = teams.length > 0 ? teams[0].name : 'Disbanded Team';
            }
            else {
                data['championName'] = reignSuperstar.name
            }
        }
    }

    // Get other data
    data['vacated'] = championshipReign.vacated;
    data['retired'] = championshipReign.retired;
    data['length'] = getChampionshipReignLength(championshipReign, month, year);
    data['championshipName'] = getChampionshipReignChampionshipName(championshipReign,
        matches, championship);
    data['championshipRank'] = championship.rank;

    return data;
}

function getChampionshipReignChampionshipName(championshipReign, matches, championship) {  // get_reign_championship_name
    let championshipName;
    if (matches.length > 0 && matches[matches.length - 1].championshipsWon) {
        championshipName = matches[matches.length - 1].championshipsWon
    }
    else {
        championshipName = getChampionshipDisplayName(championship)
    }
    return championshipName;
}

function getChampionshipReignLength(championshipReign, month, year) {  // get_championship_reign_length
    let length;
    if (championshipReign.endMonth !== null) {
        length = getMonthsDifference(championshipReign.endMonth, championshipReign.endYear,
            championshipReign.startMonth, championshipReign.startYear)
    }
    else {
        length = getMonthsDifference(month, year, championshipReign.startMonth,
            championshipReign.startYear)
    }
    if (length < 0) {
        length = 0
    }
    return length;
}

function getNumberOfOverlappingFeuds(feuds, month, year) {
    const numbersOfOverlappingFeuds = [];
    for (const feud of feuds) {
        // Get active feuds during current feud's time
        let endMonths;
        if (feud.ended) {
            endMonths = feud.endYear * 12 + feud.endMonth
        }
        else {
            endMonths = year * 12 + month
        }
        let startMonths = feud.startYear * 12 + feud.startMonth;
        const activeFeuds = feuds.filter(x => {
            return x.startYear * 12 + x.startMonth >= startMonths &&
            x.startYear * 12 + x.startMonth <= endMonths
        });
        numbersOfOverlappingFeuds.push(activeFeuds.length);
    }
    return Math.max.apply(Math, numbersOfOverlappingFeuds);
}

async function getViewTournamentsData() {  // get_company_tournaments_data
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);

    // Get unique, non annual tournaments
    let companyTournaments = (await getCompanyTournaments(selectedCompany)).filter(x => !x.annualTournament).reverse();
    let uniqueTournaments = getUniqueObjectsByName(companyTournaments);

    data['tournaments'] = [];
    for (const tournament of uniqueTournaments) {
        let tournamentData = getTournamentData(tournament);
        tournamentData['history'] = [];
        const heldTournaments = companyTournaments.filter(x => x.name === tournament.name);
        for (const heldTournament of heldTournaments) {
            const historyData = await getTournamentHistoryData(heldTournament, currentGame, selectedCompany.realYear);
            tournamentData['history'].push(historyData);
        }
        data['tournaments'].push(tournamentData);
    }

    return data;
}

function getTournamentData(tournament) {  // get_tournament_data
    let data = {};

    data['name'] = tournament.name;
    data['type'] = tournament.type;
    data['winnerName'] = tournament.winnerName;
    data['matchContractName'] = tournament.matchContractName;
    data['prestige'] = tournament.prestige;
    data['xp'] = tournament.xp;
    data['baseXp'] = eventPrestigeXps[tournament.prestige];
    data['cost'] = tournament.cost;
    data['xpToNextPrestige'] = tournament.prestige === 'C' ? 40 : 110;
    data['uid'] = tournament.$loki;

    return data;
}

async function getTournamentDisplayData(tournament, game) {  // get_tournament_display
    let data = {};
    data['type'] = tournament.type;
    data['stage'] = tournament.stage;
    data['startRound'] = tournament.stage !== 'elimination' ? 0 : tournament.rounds - tournament.knockoutRounds;
    data['participantsAdvancing'] = tournament.participantsAdvancing;
    if (tournament.type === 'elimination' || tournament.stage === 'elimination') {
        data['bracket'] = await getTournamentBracket(tournament, game, data['startRound'])
    }
    else if (tournament.type === 'round-robin') {
        data['table'] = await getTournamentTable(tournament)
    }
    return data;
}

async function getTournamentHistoryData(tournament, game, currentYear = null) {  // get_tournament_history_data
    let data = {};
    const event = await getTournamentEvent(tournament);

    data['event'] = event.name;
    data['eventYear'] = event.year || currentYear;
    data['winnerName'] = tournament.winnerName;
    data['awardName'] = tournament.awardName;

    if (tournament.type === 'elimination' || tournament.stage === 'elimination') {
        data['startRound'] = tournament.stage !== 'elimination' ? 0 : tournament.rounds - tournament.knockoutRounds;
        data['bracket'] = await getTournamentBracket(tournament, game, data['startRound']);
    }
    if (tournament.type === 'round-robin') {
        data['table'] = await getTournamentTable(tournament);
        data['participantsAdvancing'] = tournament.participantsAdvancing;
    }

    return data;
}

async function getViewGimmickMatchesData() {  // get_company_gimmick_matches
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);

    // Get data for gimmick matches
    const gimmickMatches = (await getCompanyGimmickMatches(selectedCompany)).reverse();
    gimmickMatches.sort((a, b) => a.cost - b.cost);
    data['gimmickMatches'] = gimmickMatches.map(x => getGimmickMatchData(x));

    return data;
}

function getGimmickMatchData(gimmickMatch) {  // get_gimmick_match
    // Copy data
    let data = JSON.parse(JSON.stringify(gimmickMatch));
    data['uid'] = gimmickMatch.$loki;
    if (gimmickMatch.ratingBoost < 1.13) {
        data['ratingBoost'] = 1
    }
    else if (gimmickMatch.ratingBoost < 1.2) {
        data['ratingBoost'] = 2
    }
    else if (gimmickMatch.ratingBoost < 1.3) {
        data['ratingBoost'] = 3
    }
    else {
        data['ratingBoost'] = 4
    }

    if (gimmickMatch.popularityIncrease < 1.6) {
        data['popularityBoost'] = 1
    }
    else if (gimmickMatch.popularityIncrease < 2) {
        data['popularityBoost'] = 2
    }
    else if (gimmickMatch.popularityIncrease < 2.5) {
        data['popularityBoost'] = 3
    }
    else {
        data['popularityBoost'] = 4
    }

    if (gimmickMatch.injuryRate < 1.1) {
        data['injuryRate'] = 1
    }
    else if (gimmickMatch.injuryRate < 1.15) {
        data['injuryRate'] = 2
    }
    else if (gimmickMatch.injuryRate < 1.2) {
        data['injuryRate'] = 3
    }
    else {
        data['injuryRate'] = 4
    }

    data['fatigueChange'] = getMatchGimmickFatigueIncrease(gimmickMatch);

    return data;
}

function getMatchGimmickFatigueIncrease(gimmickMatch) {  // get_match_gimmick_fatigue_increase
    let increase;
    if (gimmickMatch.injuryRate < 1.1) {
        increase = 4
    }
    else if (gimmickMatch.injuryRate < 1.15) {
        increase = 8
    }
    else if (gimmickMatch.injuryRate < 1.2) {
        increase = 12
    }
    else {
        increase = 16
    }
    return increase;
}

async function getRemoveGimmickMatchesData() {  // get_gimmick_matches_all
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);

    // Get data for gimmick matches
    const gimmickMatches = (await getCompanyGimmickMatches(selectedCompany)).map(x => x.name);
    gimmickMatches.sort();
    return gimmickMatches;
}

async function removeGimmickMatch(name) {  // remove_gimmick_match
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const gimmickMatches = await getCompanyGimmickMatches(selectedCompany);
    const gimmickMatch = gimmickMatches.find(x => x.name === name);

    if (!gimmickMatch) {
        data['error'] = 'not-found';
        return data;
    }

    data['name'] = gimmickMatch.name;

    // Remove gimmick match from company
    await removeCompanyGimmickMatches(selectedCompany, [gimmickMatch]);

    db.saveDatabase();

    return data;
}

async function addGimmickMatch(name, rules, ratingBoost, popularityBoost, injuryRate, consequence,
                               cashinContractName, cashinContractExpiry, matchContractName, graphicType,
                               addRandomWeapons) {  // add_gimmick_match
    let data = {};

    try {
        const currentGame = await getCurrentGame();
        const selectedCompany = await getGameCurrentUserCompany(currentGame);
        const gimmickMatches = await getCompanyGimmickMatches(selectedCompany);
        const cost = 100;

        // Check if enough points
        if (selectedCompany.points < cost) {
            data['error'] = 'not-enough-points';
            return data;
        }

        // Check for other gimmick match with same name
        if (gimmickMatches.map(x => x.name.toLowerCase()).indexOf(name.toLowerCase()) >= 0) {
            data['error'] = 'already-exists';
            return data;
        }

        // Don't allow Femme Fatale match in POW
        if (selectedCompany.storyName === 'passion' && name === 'Femme Fatale') {
            data['error'] = 'pow-femme-fatale';
            return data;
        }

        const newGimmickMatch = GimmickMatch();
        newGimmickMatch.name = name;
        if (rules) {
            newGimmickMatch.rules = rules;
        }

        // Add boosts and cost
        const ratingBoosts = {'0': 1.05, '1': 1.13, '2': 1.2, '3': 1.3};
        const popularityIncreases = {'0': 1.3, '1': 1.6, '2': 2, '3': 2.5};
        const popularityDecreases = {'0': 0.9, '1': 0.8, '2': 0.6, '3': 0.4};
        const injuryRates = {'0': 1.05, '1': 1.1, '2': 1.15, '3': 1.2};
        newGimmickMatch.ratingBoost = ratingBoosts[ratingBoost];
        newGimmickMatch.popularityIncrease = popularityIncreases[popularityBoost];
        newGimmickMatch.popularityDecrease = popularityDecreases[popularityBoost];
        newGimmickMatch.injuryRate = injuryRates[injuryRate];
        newGimmickMatch.cost = calculateGimmickMatchCost(newGimmickMatch);

        // Add consequence
        if (consequence) {
            // Set cash-in/match contract attributes
            if (consequence === 'cashin_contract') {
                if (selectedCompany.storyName === 'passion') {
                    data['error'] = 'pow-cashin';
                    return data;
                }
                if (cashinContractName) {
                    if (gimmickMatches.find(x => x.cashinContractName && x.cashinContractName === cashinContractName)) {
                        data['error'] = 'cashin-contract-exists';
                        return data;
                    }
                }
                newGimmickMatch.cashinContractName = cashinContractName ? cashinContractName : 'Contract';
                newGimmickMatch.monthsToExpire = cashinContractExpiry ? parseInt(cashinContractExpiry) : 12;
            } else if (consequence === 'match_contract') {
                newGimmickMatch.matchContractName = matchContractName ? matchContractName : 'Title Match';
                if (matchContractName) {
                    if (gimmickMatches.find(x => x.matchContractName && x.matchContractName === matchContractName)) {
                        data['error'] = 'match-contract-exists';
                        return data;
                    }
                }
            }
            newGimmickMatch.consequence = consequence;
        }

        // Add graphic type and 'add random weapon' options
        if (['ladder', 'ladder_black', 'ladder_grey', 'ladder_orange', 'cage_grey', 'cage_red',
            'cage_retro_blue', 'cage_retro_black', 'table', 'chair', 'tables_ladders_chairs',
            'ambulance', 'barbed_wire_ropes', 'casket', 'grave', 'parking_lot'].indexOf(graphicType) >= 0) {
            newGimmickMatch.graphicType = graphicType
        }
        if (addRandomWeapons === '1') {
            newGimmickMatch.addRandomWeapons = true;
        }

        GimmickMatches.insert(newGimmickMatch);

        // Remove points
        selectedCompany.points -= cost;

        // Add gimmick match to company
        await addCompanyGimmickMatches(selectedCompany, [newGimmickMatch]);

        // Check tutorial action
        if (selectedCompany.storyName === 'tutorial') {
            data['nextTutorialState'] = await checkToGoToNextTutorialState(selectedCompany, ['add_gimmick_match']);
        }

        db.saveDatabase();

        // Get data to return
        data['points'] = selectedCompany.points;
        data['name'] = newGimmickMatch.name;
    }
    finally {
        if (data['error']) {
            await loadDb(db.filename);
        }
    }

    return data;
}

function calculateGimmickMatchCost(gimmickMatch) {  // calculate_gimmick_match_cost
    let cost = 0;

    // Get cost from rating boost and add a small, random deviation
    let ratingCost = Math.pow((1 - gimmickMatch.ratingBoost) * 10, 2) * 30;
    cost += Math.round(ratingCost);

    // Get cost from popularity increase and add a small, random deviation
    let popularityCost = Math.pow((1 - gimmickMatch.popularityIncrease) * 2.04, 2) * 30;
    cost += Math.round(popularityCost);

    // Subtract cost from injury rate
    let injuryCost = Math.pow((1 - gimmickMatch.injuryRate) * 17, 2) * 5;
    cost -= Math.round(injuryCost);

    cost /= 3;
    cost = Math.round(Math.ceil(cost / 10) * 10);  // Round up to nearest 10

    if (cost <= 5) {
        cost = 5
    }

    return cost;
}

async function getViewSegmentsData() {  // get_company_custom_segment_items
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const segmentItems = (await getCompanySegmentItems(selectedCompany)).filter(x => x.custom).reverse();
    data['segmentItems'] = await Promise.all(segmentItems.map(x => getSegmentItemData(x)));
    return data;
}

async function getEditSegmentsData() {  // get_custom_segment_items
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const segmentItems = (await getCompanySegmentItems(selectedCompany)).filter(x => x.custom);
    return segmentItems.map(x => x.name);
}

async function removeSegmentItem(name) {  // remove_custom_segment_item
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const segmentItems = await getCompanySegmentItems(selectedCompany);
    const segmentItem = segmentItems.find(x => x.name === name);

    if (!segmentItem) {
        data['error'] = 'not-found';
        return data;
    }

    if (!segmentItem.custom) {
        data['error'] = 'not-custom';
        return data;
    }

    data['name'] = segmentItem.name;

    // Remove segment item from company
    await removeCompanySegmentItems(selectedCompany, [segmentItem]);

    db.saveDatabase();

    return data;
}

async function getEditSegmentData(name) {  // get_custom_segment_data
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const segmentItems = await getCompanySegmentItems(selectedCompany);
    const segmentItem = segmentItems.find(x => x.name === name);

    if (!segmentItem) {
        data['error'] = 'not-found';
        return data;
    }

    if (segmentItem.productionSegment) {
        data['error'] = 'production-segment';
        return data;
    }

    data = getCustomSegmentItemData(segmentItem);

    return data;
}

function getCustomSegmentItemData(segmentItem) {  // get_custom_segment_item_data
    let data = {};
    data['name'] = segmentItem.name;
    data['participants'] = segmentItem.maxParticipants;
    data['chooseWinner'] = segmentItem.chooseWinner;
    data['feudOnly'] = segmentItem.feudOnly;
    data['silly'] = segmentItem.silly;
    data['startText'] = segmentItem.text.start;
    data['actionText'] = segmentItem.text.action;
    data['startTagText'] = segmentItem.text.startTag;
    data['actionTagText'] = segmentItem.text.actionTag;
    return data;
}

async function addCustomSegmentItem(name, numberOfParticipants, startText, actionTexts, tagStartText,
        tagActionTexts, saveToGame, saveToCommunity, chooseWinner, feudOnly, silly) {  // add_custom_segment_item
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const segmentItems = await getCompanySegmentItems(selectedCompany);
    const cost = saveToGame ? 30 : 0;

    // Check paid
    if (!globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // Check if enough points
    if (selectedCompany.points < cost) {
        data['error'] = 'not-enough-points';
        return data;
    }

    // Check if segment item name exists
    if (segmentItems.map(x => x.name).indexOf(name) >= 0) {
        data['error'] = 'already-exists';
        return data;
    }

    // Get segment text
    let segmentText = {};
    segmentText['start'] = [startText];
    segmentText['action'] = actionTexts;
    if (tagStartText) {
        segmentText['startTag'] = [tagStartText]
    }
    if (tagActionTexts.length) {
        segmentText['actionTag'] = tagActionTexts
    }

    if (numberOfParticipants < 2) {
        // Don't add choose winner if less than 2 participants
        if (chooseWinner) {
            chooseWinner = false
        }

        // Don't add feud only if less than 2 participants
        if (feudOnly) {
            feudOnly = false;
        }
    }

    // Create segment item and add to company
    let newSegmentItem = createCustomSegmentItem(name, numberOfParticipants, segmentText, saveToGame, saveToCommunity,
        chooseWinner, feudOnly, silly);
    SegmentItems.insert(newSegmentItem);
    await addCompanySegmentItems(selectedCompany, [newSegmentItem]);

    // Add to community segments if online
    if (saveToCommunity && window.navigator.onLine) {
        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: globals.baseUrl + '/_add_template_segment_item',
            data: JSON.stringify({name: name, startText: startText, actionTexts: actionTexts,
                tagStartText: tagStartText, tagActionTexts: tagActionTexts, numberOfParticipants: numberOfParticipants,
                chooseWinner: chooseWinner, feudOnly: feudOnly, silly: silly}),
            success: async (data) => {
                if (data['added_template_segment_item']) {
                    notie.alert({
                        type: 4,
                        text: '<span class="display-block">{0} segment has been added to Community Segments</span>'.format(name)
                    });
                }
            }
        });
    }

    // Remove points
    selectedCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['points'] = selectedCompany.points;
    data['name'] = newSegmentItem.name;

    return data;
}

async function editCustomSegmentItem(name, previousName, numberOfParticipants, startText, actionTexts, tagStartText,
        tagActionTexts, chooseWinner, feudOnly, silly) {  // edit_custom_segment_item
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const segmentItems = await getCompanySegmentItems(selectedCompany);

    // Get segment item
    const segmentItem = segmentItems.find(x => x.name === previousName);
    if (!segmentItem) {
        data['error'] = 'not-found';
        return data;
    }

    // Check paid
    if (!globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // If changing name, check if segment item name exists
    if (name !== previousName && segmentItems.map(x => x.name).indexOf(name) >= 0) {
        data['error'] = 'already-exists';
        return data;
    }

    // Get segment text
    let segmentText = {};
    segmentText['start'] = [startText];
    segmentText['action'] = actionTexts;
    if (tagStartText) {
        segmentText['startTag'] = [tagStartText]
    }
    if (tagActionTexts.length) {
        segmentText['actionTag'] = tagActionTexts
    }

    if (numberOfParticipants < 2) {
        // Don't add choose winner if less than 2 participants
        if (chooseWinner) {
            chooseWinner = false
        }

        // Don't add feud only if less than 2 participants
        if (feudOnly) {
            feudOnly = false;
        }
    }

    // Edit segment item
    segmentItem.name = name;
    segmentItem.maxParticipants = numberOfParticipants;
    segmentItem.minParticipants = numberOfParticipants;
    segmentItem.chooseWinner = chooseWinner;
    segmentItem.feudOnly = feudOnly;
    segmentItem.silly = silly;
    segmentItem.text = segmentText;
    segmentItem.hypeBoost = feudOnly ? 1 : 0;
    segmentItem.popularityBoost = feudOnly ? 0 : 1;

    // Add to community segments if online
    if (segmentItem.saveToCommunity && window.navigator.onLine) {
        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: globals.baseUrl + '/_add_template_segment_item',
            data: JSON.stringify({name: name, startText: startText, actionTexts: actionTexts,
                tagStartText: tagStartText, tagActionTexts: tagActionTexts, numberOfParticipants: numberOfParticipants,
                chooseWinner: chooseWinner, feudOnly: feudOnly, silly: silly}),
            success: async (data) => {
                if (data['added_template_segment_item']) {
                    notie.alert({
                        type: 4,
                        text: '<span class="display-block">{0} segment has been added to Community Segments</span>'.format(name)
                    });
                }
            }
        });
    }

    db.saveDatabase();

    // Get data to return
    data['name'] = previousName;

    return data;
}

function createCustomSegmentItem(name, numberOfParticipants, text, saveToGame, saveToCommunity, chooseWinner,
                                 feudOnly, silly) {  // create_custom_segment_item
    const segmentItem = SegmentItem();

    segmentItem.name = name;
    segmentItem.maxParticipants = numberOfParticipants;
    segmentItem.minParticipants = numberOfParticipants;
    segmentItem.chooseWinner = chooseWinner;
    segmentItem.feudOnly = feudOnly;
    segmentItem.silly = silly;
    segmentItem.text = text;

    segmentItem.hypeBoost = feudOnly ? 1 : 0;
    segmentItem.popularityBoost = feudOnly ? 0 : 1;
    segmentItem.difficulty = 1;
    segmentItem.entertainment = 2;
    segmentItem.action = 1;
    segmentItem.unlocked = true;
    segmentItem.productionSegment = false;

    segmentItem.temporary = !saveToGame;
    segmentItem.custom = true;
    segmentItem.saveToCommunity = saveToCommunity;

    return segmentItem;
}

async function getViewTitlesData(companyUid) {  // get_company_championship_stats
    let data = {};
    const currentGame = await getCurrentGame();

    // Get selected company
    let selectedCompany;
    if (companyUid) {
        selectedCompany = await Companies.get(companyUid)
    }
    else {
        selectedCompany = await getGameCurrentUserCompany(currentGame)
    }

    // Get unique company championships and sort
    const companyChampionships = await getCompanyChampionships(selectedCompany, false);
    let uniqueChampionships = getUniqueChampionships(companyChampionships);
    uniqueChampionships.sort(compareChampionships);

    // Get data for championships
    const getStats = globalUser.paid;
    data['championships'] = await Promise.all(
        uniqueChampionships.map(x => getChampionshipData(x, getStats, currentGame))
    );

    // Get data to return
    data['inactive'] = selectedCompany.operatingStatus === 'Inactive';
    data['companyName'] = selectedCompany.name;

    return data;
}

async function getChampionshipData(championship, getStats = false, game) {  // get_championship_data
    let data = {};
    data['name'] = getChampionshipDisplayName(championship);
    data['rank'] = championship.rank;
    data['graphic'] = championship.graphic;
    data['brandName'] = championship.brandName;
    data['gimmickRestriction'] = championship.gimmickRestriction;
    data['prestigeData'] = getChampionshipPrestigeData(championship);
    data['retired'] = championship.retired;

    if (getStats) {
        const reigns = (await getChampionshipChampionshipReigns(championship)).reverse();
        data['reignsData'] = (await Promise.all(reigns.map(x => getChampionshipReignData(x, game.monthCount,
            game.year, true, championship))));

        // Get shortest and longest reigns
        data['longestReigns'] = [];
        if (reigns.length > 0) {
            const sortedReigns = [...data['reignsData']].sort((a, b) => b.length - a.length ||
            b.numberOfDefenses - a.numberOfDefenses);
            data['shortestReign'] = sortedReigns[sortedReigns.length - 1];
            data['longestReigns'] = sortedReigns.slice(0, 3);
        }

        // Calculate changes and average length of reigns
        data['changes'] = (reigns.length > 0) ? reigns.length - 1 : 0;
        if (data['changes'] > 0) {
            const reignsLengthSum = data['reignsData'].map(x => x.length).reduce((partialSum, a) => partialSum + a, 0);
            data['averageReignLength'] = Math.round(reignsLengthSum / data['reignsData'].length);
        }

        // Most reigns
        const reignChampions = data['reignsData'].map(x => x.championName);
        if (reignChampions.length > 0) {
            const uniqueReignChampions = [...new Set(reignChampions)];
            let mostReigns = uniqueReignChampions.map(x => {
                return {'name': x, 'number': reignChampions.filter(y => y === x).length}
            });
            data['mostReigns'] = mostReigns.sort((a, b) => b.number - a.number)[0];
        }

        // Get best and worst matches (except cash-ins)
        const championshipsMatches = data['reignsData'].map(x => x.matchesData).flat().filter(x => x.rating !== null);
        if (championshipsMatches.length > 0) {
            const maximumRating = Math.max(...championshipsMatches.map(o => o.rating));
            data['bestMatch'] = championshipsMatches.find(x => x.rating === maximumRating);
            const minimumRating = Math.min(...championshipsMatches.map(o => o.rating));
            data['worstMatch'] = championshipsMatches.find(x => x.rating === minimumRating);
        }

        // Get current reign
        data['currentReign'] = null;
        if (!championship.vacated && data['reignsData'].length > 0) {
            data['currentReign'] = data['reignsData'][0];
        }
    }

    return data;
}

function getChampionshipPrestigeData(championship) {  // get_championship_prestige_data
    let data = {};

    // Get prestige data
    const prestigeValues = Object.keys(championshipPrestigeXps);
    const prestigeItems = Object.entries(championshipPrestigeXps);

    // Get xp of next prestige (same prestige if max)
    const prestigeIndex = prestigeValues.indexOf(championship.prestige);
    let nextPrestigeData;
    if (prestigeIndex > 0) {
        nextPrestigeData = prestigeItems[prestigeIndex - 1]
    }
    else {
        nextPrestigeData = prestigeItems[prestigeIndex]
    }
    const nextPrestigeXp = nextPrestigeData[1];
    const currentPrestigeXp = championshipPrestigeXps[championship.prestige];

    // Get data to return
    data['prestige'] = championship.prestige;
    data['xp'] = championship.xp;
    data['nextPrestigeXp'] = nextPrestigeXp;
    data['maxPrestige'] = prestigeIndex <= 0;
    if (!data['maxPrestige']) {
        data['xpToNextPrestige'] = nextPrestigeXp - championship.xp;
        data['progressPercentage'] = (championship.xp - currentPrestigeXp) / (nextPrestigeXp - currentPrestigeXp) * 100
    }

    return data;
}

async function getCompanyBrandNames() {  // get_company_brand_names_view
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterBrands = await getRosterBrands(mainRoster);
    return rosterBrands.map(x => x.name);
}

async function getCompanySuperstarsData() {  // get_superstars_all
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const companyRosters = await getCompanyRosters(selectedCompany);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main', companyRosters);
    const trainingRoster = await getCompanyRosterByType(selectedCompany, 'training', companyRosters);
    const trainingAvailableRoster = await getCompanyRosterByType(selectedCompany, 'trainingAvailable', companyRosters);
    let rosterSuperstars = await getRosterSuperstars(mainRoster);
    let trainingSuperstars = (await getRosterSuperstars(trainingRoster))
        .concat(await getRosterSuperstars(trainingAvailableRoster));
    let allSuperstars = rosterSuperstars.concat(trainingSuperstars);

    let data = allSuperstars.map(x => {
        let name = x.name;
        if (objectInArray(x, trainingSuperstars)) {
            name += ' (Training)'
        }
        return {'name': name, 'uid': x.$loki, 'value': x.name}
    });
    data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

    return data;
}

async function getCompanyGimmickMatchesForChampionshipGimmick() {  // get_gimmick_matches_for_championship_gimmick
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    let gimmickMatches = await getCompanyGimmickMatches(selectedCompany);
    gimmickMatches = gimmickMatches.filter(x => x.available && !x.cashinContractName && !x.matchContractName);
    gimmickMatches.sort((a, b) => a.name.localeCompare(b.name));
    return gimmickMatches.map(x => x.name);
}

async function getCompanyChampionshipsData(getContracts = true) {  // get_company_championships_view
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterBrands = await getRosterBrands(mainRoster);
    let companyChampionships = await getCompanyChampionships(selectedCompany);

    // Filter out contracts
    if (!getContracts) {
        companyChampionships = companyChampionships.filter(x => !x.matchContract && !x.championshipContract);
    }

    // Get unique championships, sort
    companyChampionships = getUniqueChampionships(companyChampionships);
    companyChampionships.sort(compareChampionships);

    // Get data for championships
    data['championships'] = companyChampionships.map(x => {
        return {
            'name': getChampionshipDisplayName(x), 'gimmickRestriction': x.gimmickRestriction,
            'brandName': x.brandName, 'uid': x.$loki, 'graphic': x.graphic
        }
    });

    data['brandNames'] = rosterBrands.map(x => x.name);

    return data
}

async function addChampionship(name, rank, championUid, division, addGraphic, graphicData, gimmickRestrictionName,
                               gimmickMatchName, gimmickRestrictionMaxAge, gimmickRestrictionMixAge, brandName) {  // add_custom_championship
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const companyChampionships = await getCompanyChampionships(selectedCompany);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterBrands = await getRosterBrands(mainRoster);

    // Check for paid version if adding brand
    if (brandName && !globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // Check brand name
    if (brandName && rosterBrands.map(x => x.name).indexOf(brandName) < 0) {
        data['error'] = 'brand-not-found';
        return data;
    }

    // Get gimmick restriction
    let gimmickRestriction = null;
    if (gimmickRestrictionName === 'gimmick_match') {
        let gimmickRestrictionValue = null;
        if (gimmickMatchName !== 'Any') {
            const gimmickMatch = (await getCompanyGimmickMatches(selectedCompany))
                .find(x => x.name === gimmickMatchName);
            if (gimmickMatch) {
                gimmickRestrictionValue = gimmickMatch.name
            }
        }
        gimmickRestriction = {'type': gimmickRestrictionName, value: gimmickRestrictionValue}
    }
    else if (gimmickRestrictionName === 'weekly_show') {
        gimmickRestriction = {'type': gimmickRestrictionName, value: null};
    }
    else if (gimmickRestrictionName === 'maximum_age') {
        gimmickRestriction = {'type': gimmickRestrictionName, value: parseInt(gimmickRestrictionMaxAge)}
    }
    else if (gimmickRestrictionName === 'minimum_age') {
        gimmickRestriction = {'type': gimmickRestrictionName, value: parseInt(gimmickRestrictionMixAge)}
    }

    // Check production facility level requirement
    if (gimmickRestriction) {
        const productionFacility = (await getCompanyFacilities(selectedCompany)).find(x => x.name === 'Production');
        if (!(productionFacility && productionFacility.level >= 2)) {
            data['error'] = 'level-2-production-facility-required';
            return data;
        }
    }

    // Check points
    const cost = getChampionshipCost(rank, gimmickRestriction);
    if (selectedCompany.points < cost) {
        data['error'] = 'points';
        return data;
    }

    // Check if championship already exists
    if (companyChampionships.map(x => x.name.toLowerCase()).indexOf(name.toLowerCase()) >= 0) {
        data['error'] = 'already-exists';
        return data;
    }

    // Get champion to award championship to
    let champion = null;
    if (championUid) {
        if (division === 'singles') {
            champion = (await getRosterSuperstars(mainRoster)).find(x => x.$loki === championUid)
        }
        if (division === 'tag-team') {
            champion = (await getRosterTagTeams(mainRoster)).find(x => x.$loki === championUid)
        }
        if (division === 'trio') {
            champion = (await getRosterTagTeams(mainRoster)).filter(x => x.trio).find(x => x.$loki === championUid)
        }
        if (!champion) {
            data['error'] = 'champion-not-found';
            return data;
        }
    }

    // Get graphic
    let graphic = null;
    if (addGraphic) {
        graphic = JSON.parse(graphicData)
    }

    // Get number of championships to add based on division selected
    const divisionData = {'singles': 1, 'tag-team': 2, 'trio': 3};
    const numberOfChampionships = divisionData[division] || 1;

    // Create championships
    let championships = [];
    for (const x of Array(numberOfChampionships).keys()) {
        const newChampionship = Championship(name);
        newChampionship.rank = rank;
        if (division === 'tag-team') {
            newChampionship.tagTeam = true;
        }
        if (division === 'trio') {
            newChampionship.trio = true;
        }
        if (graphic) {
            newChampionship.graphic = graphic
        }
        if (gimmickRestriction) {
            newChampionship.gimmickRestriction = gimmickRestriction;
            newChampionship.xp = 40;
        }
        if (!championUid) {
            newChampionship.vacated = true
        }
        if (brandName) {
            setObjectBrand(newChampionship, brandName)
        }
        championships.push(newChampionship);

        // Save
        Championships.insert(newChampionship);

        // Add to company
        await addCompanyChampionships(selectedCompany, [newChampionship]);
    }

    // Add championships to champion if entered
    if (championUid) {
        const championSuperstars = await getRosterMemberSuperstars(champion);
        const popularityIncrease = getChampionshipPopularityIncrease(championships[0], true);
        for (const [i, c] of Object.entries(championships)) {
            // Add to superstars
            await addSuperstarChampionships(championSuperstars[i], [c]);

            // Update champion's popularity
            championSuperstars[i].popularity += popularityIncrease;

            // Add championship reign
            const newReign = ChampionshipReign(currentGame.monthCount, currentGame.year);
            ChampionshipReigns.insert(newReign);
            await addChampionshipChampionshipReigns(c, [newReign]);
            await addSuperstarChampionshipReigns(championSuperstars[i], [newReign]);
        }
    }

    // Change objective property
    const objectiveCompleted = await changeProperty({name: 'new championship', change: 1, company: selectedCompany});
    if (objectiveCompleted) {
        await processObjectiveCompleted(objectiveCompleted, selectedCompany);
        const unreadMessages = await getCompanyUnreadMessages(selectedCompany);
        data['unreadMessages'] = unreadMessages.length;
    }

    // Add company log
    const newCompanyLog = CompanyLog(currentGame.monthCount, selectedCompany.realYear);
    CompanyLogs.insert(newCompanyLog);
    newCompanyLog.text = championships[0].name;
    newCompanyLog.type = 'new-championship';
    newCompanyLog.realYear = currentGame.year;
    await addCompanyCompanyLogs(selectedCompany, [newCompanyLog]);

    // Remove points
    selectedCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['championshipName'] = getChampionshipDisplayName(championships[0]);
    data['points'] = selectedCompany.points;

    return data
}

async function rebrandChampionship(uid, name, appearanceOption, graphicData, gimmickRestrictionName,
        gimmickMatchName, gimmickRestrictionMaxAge, gimmickRestrictionMinAge, brandName) {  // rebrand_championship_view
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const companyChampionships = await getCompanyChampionships(selectedCompany);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterBrands = await getRosterBrands(mainRoster);
    const companyLogs = await getCompanyCompanyLogs(selectedCompany);
    let cost = 50;

    // Get championship
    let championship = companyChampionships.find(x => x.$loki === uid);
    let championships = companyChampionships.filter(x => checkAreChampionshipsEqual(x, championship));

    // Check if championship already exists
    if (companyChampionships.map(x => x.name.toLowerCase()).indexOf(name.toLowerCase()) >= 0) {
        data['error'] = 'already-exists';
        return data;
    }

    // Check for WoM
    if (selectedCompany.storyName === 'mars') {
        data['error'] = 'mars';
        return data;
    }

    // Check for POW
    if (selectedCompany.storyName === 'passion' && championship.name === 'POW') {
        data['error'] = 'pow-title';
        return data;
    }

    // Check for paid version if adding brand
    if (brandName && !globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // Check brand name
    if (brandName && rosterBrands.map(x => x.name).indexOf(brandName) < 0) {
        data['error'] = 'brand-not-found';
        return data;
    }

    // Get gimmick restriction
    let gimmickRestriction = null;
    if (gimmickRestrictionName === 'gimmick_match') {
        let gimmickRestrictionValue = null;
        if (gimmickMatchName !== 'Any') {
            const gimmickMatch = (await getCompanyGimmickMatches(selectedCompany))
                .find(x => x.name === gimmickMatchName);
            if (gimmickMatch) {
                gimmickRestrictionValue = gimmickMatch.name
            }
        }
        gimmickRestriction = {'type': gimmickRestrictionName, value: gimmickRestrictionValue}
    }
    else if (gimmickRestrictionName === 'weekly_show') {
        gimmickRestriction = {'type': gimmickRestrictionName, value: null};
    }
    else if (gimmickRestrictionName === 'maximum_age') {
        gimmickRestriction = {'type': gimmickRestrictionName, value: parseInt(gimmickRestrictionMaxAge)}
    }
    else if (gimmickRestrictionName === 'minimum_age') {
        gimmickRestriction = {'type': gimmickRestrictionName, value: parseInt(gimmickRestrictionMinAge)}
    }

    // Check production facility level requirement
    if (gimmickRestriction) {
        const productionFacility = (await getCompanyFacilities(selectedCompany)).find(x => x.name === 'Production');
        if (!(productionFacility && productionFacility.level >= 2)) {
            data['error'] = 'level-2-production-facility-required';
            return data;
        }
    }

    // Check points
    if (gimmickRestriction) {
        cost += 100
    }
    if (selectedCompany.points < cost) {
        data['error'] = 'points';
        return data;
    }

    // Get previous name
    const previousName = getChampionshipDisplayName(championship);
    const previousNameRaw = championship.name;

    // Process championships
    for (const c of championships) {
        if (name) {
            c.name = name
        }

        const previousGraphic = c.graphic;
        if (appearanceOption === 'change') {
            c.graphic = JSON.parse(graphicData)
        }
        else if (appearanceOption === 'remove') {
            c.graphic = null
        }

        if (gimmickRestriction) {
            c.gimmickRestriction = gimmickRestriction;
        }
        else {
            c.gimmickRestriction = null
        }

        if (brandName) {
            setObjectBrand(c, brandName)
        }
        else {
            removeObjectBrand(c)
        }

        // Lower prestige
        if (globalUser.paid) {
            const xpChange = -50;
            await processChampionshipXpChange(c, xpChange);
            data['rebrandXpChange'] = xpChange;
        }

        // Check customize title request
        if (!objectEquals(previousGraphic, c.graphic)) {
            const champion = await getChampionshipSuperstar(c);
            let requestData = {'championshipId': c.$loki};

            await checkTalentRequestAction({company: selectedCompany, requestType: 'customize_championship', talent: champion, data: requestData});
        }
    }

    // Add company log
    const newCompanyLog = CompanyLog(currentGame.monthCount, selectedCompany.realYear);
    CompanyLogs.insert(newCompanyLog);
    const newName = getChampionshipDisplayName(championship);
    newCompanyLog.text = `Rebranded ${previousName} to ${newName}`;
    newCompanyLog.type = 'rebrand-championship';
    newCompanyLog.realYear = currentGame.year;
    await addCompanyCompanyLogs(selectedCompany, [newCompanyLog]);

    // Update company logs
    await updateCompanyLogsForChampionshipNameChange(companyLogs, championship, previousNameRaw);

    // Remove points
    selectedCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['championshipName'] = getChampionshipDisplayName(championships[0]);
    data['points'] = selectedCompany.points;
    data['previousName'] = previousName;
    const unreadMessages = await getCompanyUnreadMessages(selectedCompany);
    data['unreadMessages'] = unreadMessages.length;

    return data
}

async function updateCompanyLogsForChampionshipNameChange(companyLogs, championship, previousName) {
    for (const companyLog of companyLogs) {
        if (companyLog.type === 'new-championship' && companyLog.text === previousName) {
            companyLog.text = championship.name;
        }
    }
}

async function updateCompanyLogsForTalentNameChange(companyLogs, talent, previousName) {
    for (const companyLog of companyLogs) {
        if (['signing', 'callup', 'new-superstar', 'new-trade-superstar'].indexOf(companyLog.type) >= 0 &&
            companyLog.text === previousName) {
            companyLog.text = talent.name;
        }
    }
}

async function vacateChampionship({uid} = {}) {  // vacate_championship
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const companyChampionships = await getCompanyChampionships(selectedCompany);
    const cost = 50;

    // Get championship
    let championship = companyChampionships.find(x => x.$loki === uid);
    if (!championship) {
        data['error'] = 'not-found';
        return data;
    }

    // Check for PoW
    if (selectedCompany.storyName === 'passion' && championship.name === 'POW') {
        const championshipSuperstar = await getChampionshipSuperstar(championship);
        if (championshipSuperstar && championshipSuperstar.injured <= 0) {
            data['error'] = 'pow-title';
            return data;
        }
    }

    // Check if already vacant
    if (championship.vacated) {
        data['error'] = 'already-vacant';
        return data;
    }

    // Get tag/trio championships
    let championships = [];
    championships.push(championship);
    if (championship.tagTeam || championship.trio) {
        championships = companyChampionships.filter(x => checkAreChampionshipsEqual(x, championship));
        data['tag'] = true;
    }

    // Check if already vacated
    const vacatedLog = (await getCompanyCompanyLogs(selectedCompany)).reverse()
        .find(x => x.type === 'vacated_without_reason' && x.text === championship.name);
    if (vacatedLog) {
        const monthsPassed = getMonthsDifference(currentGame.monthCount, currentGame.year,
            vacatedLog.month, vacatedLog.year);
        // Lower prestige if vacated within last 3 months
        if (monthsPassed < 3 && globalUser.paid) {
            const xpChange = -20;
            await processChampionshipXpChange(championship, xpChange, championships);
            data['vacatedTooOftenXpDecrease'] = xpChange;
        }
    }

    // Process championships
    for (const c of championships) {

        // Vacate championship and save
        c.vacated = true;

        // Remove championship from champion
        const champion = await getChampionshipSuperstar(c);
        await removeSuperstarChampionships(champion, [c]);

        // Update champion's popularity
        champion.popularity -= getChampionshipPopularityDecrease(c);

        // End current reign
        const oldReign = await getChampionshipCurrentReign(c);
        if (oldReign) {
            oldReign.endMonth = currentGame.monthCount;
            oldReign.endYear = currentGame.year;
            oldReign.vacated = true;
        }

        // Add vacated to company logs
        const newCompanyLog = CompanyLog(currentGame.monthCount, currentGame.year);
        CompanyLogs.insert(newCompanyLog);
        newCompanyLog.text = c.name;
        newCompanyLog.type = 'vacated_without_reason';
        await addCompanyCompanyLogs(selectedCompany, [newCompanyLog]);

        // Check talent request
        let requestData = {'championshipId': c.$loki};
        await checkTalentRequestAction({company: selectedCompany, requestType: 'vacate_championship', talent: champion,
            data: requestData});
    }

    // Remove points
    selectedCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['championshipName'] = getChampionshipDisplayName(championship);
    data['points'] = selectedCompany.points;

    return data
}

async function retireChampionship(uid) {  // delete_championship
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const companyChampionships = await getCompanyChampionships(selectedCompany);

    // Get championship
    let championship = companyChampionships.find(x => x.$loki === uid);
    if (!championship) {
        data['error'] = 'not-found';
        return data;
    }

    // Check for PoW
    if (selectedCompany.storyName === 'passion' && championship.name === 'POW') {
        data['error'] = 'pow-title';
        return data;
    }

    // Get tag/trio championships
    let championships = [];
    championships.push(championship);
    if (championship.tagTeam || championship.trio) {
        championships = companyChampionships.filter(x => checkAreChampionshipsEqual(x, championship));
        data['tag'] = true;
    }

    // Get points to add
    let pointsToAdd = getChampionshipCost(championship.rank, true, championship.gimmickRestriction);

    // Process championships
    data['championshipName'] = getChampionshipDisplayName(championship);
    for (const c of championships) {

        // Remove championship from champion
        const champion = await getChampionshipSuperstar(c);
        if (champion) {
            await removeSuperstarChampionships(champion, [c]);

            // Update champion's popularity
            champion.popularity -= getChampionshipPopularityDecrease(c);

            // End current reign
            const oldReign = await getChampionshipCurrentReign(c);
            if (oldReign) {
                oldReign.endMonth = currentGame.monthCount;
                oldReign.endYear = currentGame.year;
                oldReign.retired = true;
            }
        }

        // Remove match contract
        if (c.matchContract) {
            const matchContract = await getChampionshipMatchContract(c);
            if (matchContract) {
                MatchContracts.remove(matchContract)
            }
        }

        if (c.matchContract || c.championshipContract) {
            pointsToAdd = 0;
            await removeCompanyChampionships(selectedCompany, [c]);
        }

        c.retired = true;
    }

    // Add points
    selectedCompany.points += pointsToAdd;

    db.saveDatabase();

    // Get data to return
    data['points'] = selectedCompany.points;
    data['pointsReturned'] = pointsToAdd;

    return data
}

function getChampionshipCost(rank, remove = false, gimmickRestriction = null) {  // get_championship_cost
    const ranks = {'Main Eventer': 250, 'Upper Midcarder': 150, 'Lower Midcarder': 100, 'Jabroni': 50};
    const ranksRemove = {'Main Eventer': 150, 'Upper Midcarder': 100, 'Lower Midcarder': 50, 'Jabroni': 25};
    let points;
    if (remove) {
        points = ranksRemove[rank] || 150;
        if (gimmickRestriction && Object.keys(gimmickRestriction).length !== 0) {
            points += 75
        }
    }
    else {
        points = ranks[rank] || 100;
        if (gimmickRestriction) {
            points += 100
        }
    }

    return points;
}

function getChampionshipPopularityDecrease(championship, defense = false) {  // get_championship_decrease
    let values;
    if (defense) {
        values = {'S': 9, 'A': 6, 'B': 4, 'C': 1}
    }
    else {
        values = {'S': 21, 'A': 16, 'B': 10, 'C': 5}
    }
    return values[championship.prestige];
}

function getChampionshipPopularityIncrease(championship, defense = false) {  // get_championship_increase
    let values;
    if (defense) {
        values = {'S': 12, 'A': 8, 'B': 5, 'C': 3}
    }
    else {
        values = {'S': 28, 'A': 21, 'B': 14, 'C': 7}
    }
    return values[championship.prestige];
}

async function getCompanyUnreadMessages(company) {
    return (await getCompanyMessages(company)).filter(x => x.read === false)
}

async function processChampionshipXpChange(championship, xpChange, companyChampionships = null) {  // process_championship_xp_change
    let data = {};

    if (globalUser.paid) {
        // Update xp and prestige
        let allChampionships = companyChampionships ?  // Get all team titles if companyChampionships passed
            companyChampionships.filter(x => checkAreChampionshipsEqual(x, championship)) : [championship];
        let prestigeIncrease = false;
        let prestigeDecrease = false;
        for (const c of allChampionships) {
            updateChampionshipXp(c, xpChange);
            let prestigeChangeData = updateChampionshipPrestige(c);

            // Get prestige increase/decrease if true (so one team title doesn't overwrite other team title's value)
            if (prestigeChangeData['prestigeIncrease']) {
                prestigeIncrease = true
            }
            if (prestigeChangeData['prestigeDecrease']) {
                prestigeDecrease = true
            }
        }

        if (allChampionships.length > 0) {
            data = getChampionshipPrestigeData(allChampionships[0]);
            data['xpChange'] = xpChange;
            data['prestigeIncrease'] = prestigeIncrease;
            data['prestigeDecrease'] = prestigeDecrease;
            data['championshipName'] = getChampionshipDisplayName(allChampionships[0]);
            if (getChampionshipPrestigeValue(allChampionships[0].prestige) >
                getChampionshipPrestigeValue(allChampionships[0].highestPrestige)) {
                allChampionships[0].highestPrestige = allChampionships[0].prestige;
                data['firstPrestigeIncrease'] = true;
            }
        }
    }

    return data;
}

function getChampionshipPrestigeValue(prestige) {  // get_championship_prestige_value
    const prestigeValues = {'S': 4, 'A': 3, 'B': 2, 'C': 1};
    return prestigeValues[prestige] || 1;
}

function updateChampionshipXp(championship, xpChange) {  // update_championship_xp
    championship.xp += xpChange;
    championship.xpGainedThisYear += xpChange;
    if (championship.xp < 0) {
        championship.xp = 0
    }
    return championship.xp
}

function updateChampionshipPrestige(championship) {  // update_championship_prestige
    // Update a championships's prestige if it goes above or below the prestige's xp.
    // Prestige item is a tuple of the format (prestige, xp)

    let data = {};
    data['prestigeIncrease'] = false;
    data['prestigeDecrease'] = false;

    // Get prestige data
    const prestigeValues = Object.keys(championshipPrestigeXps);
    const prestigeItems = Object.entries(championshipPrestigeXps);

    if (prestigeValues.indexOf(championship.prestige) >= 0) {
        const prestigeIndex = prestigeValues.indexOf(championship.prestige);

        // Check for prestige increase if not max prestige
        if (prestigeIndex > 0) {
            let nextPrestigeData = prestigeItems[prestigeIndex - 1];
            // Set prestige to next prestige if over next prestige xp
            if (championship.xp >= nextPrestigeData[1]) {
                championship.prestige = nextPrestigeData[0];
                data['prestigeIncrease'] = true;
            }
        }

        // Check for prestige decrease if not min prestige
        if (prestigeIndex < (prestigeItems.length - 1)) {
            const currentPrestigeXp = championshipPrestigeXps[championship.prestige];
            // Set prestige to previous prestige if below current prestige xp
            if (championship.xp < currentPrestigeXp) {
                let previousPrestigeData = prestigeItems[prestigeIndex + 1];
                championship.prestige = previousPrestigeData[0];
                data['prestigeDecrease'] = true;
            }
        }
    }

    return data;
}

async function rebrandCompany(name) {  // rebrand_company_view
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const cost = 200;

    // Check points
    if (selectedCompany.points < cost) {
        data['error'] = 'points';
        return data;
    }

    // Check for story
    if (['mars', 'passion'].indexOf(selectedCompany.storyName) >= 0) {
        data['error'] = 'story';
        return data;
    }

    // Check if name exists
    const allCompanies = await getGameActiveCompanies(currentGame);
    if (allCompanies.map(x => x.name).indexOf(name) >= 0) {
        data['error'] = 'name-exists';
        return data;
    }

    // Change company name
    const previousName = selectedCompany.name;
    selectedCompany.name = name;

    // Add company log
    const newCompanyLog = CompanyLog(currentGame.monthCount, selectedCompany.realYear);
    CompanyLogs.insert(newCompanyLog);
    newCompanyLog.text = `Rebranded ${previousName} to ${name}`;
    newCompanyLog.type = 'rebrand-company';
    newCompanyLog.realYear = currentGame.year;
    await addCompanyCompanyLogs(selectedCompany, [newCompanyLog]);

    // Remove points
    selectedCompany.points -= cost;

    // Decrease company overness
    const overnessChange = -10;
    updateObjectOverness(selectedCompany, overnessChange);
    checkObjectHot(selectedCompany, overnessChange);
    checkObjectStale(selectedCompany, overnessChange);

    db.saveDatabase();

    // Get data to return
    data['previousName'] = previousName;
    data['newName'] = name;
    data['points'] = selectedCompany.points;
    data['playerName'] = selectedCompany.playerName;

    // Save to local storage
    await saveGameDataToLocalStorage(currentGame);

    return data;
}

function updateObjectOverness(object, overnessChange) {  // update_object_overness
    object.overness += overnessChange;
    object.overness = limitValueBetweenRange(object.overness, 0, 100);
    return object.overness
}

function checkObjectHot(object, overnessChange) {  // check_object_hot
    if (object.overness >= 80) {
        if (!object.hot) {
            object.hot = true;
            return 'hot';
        }
    }
    else {
        if (object.hot) {
            object.hot = false;
            return 'hotEnd';
        }
        else if (object.overness >= 70) {
            // Check if overness was below 70 before
            if ((object.overness - overnessChange) < 70) {
                return 'hotStart'
            }
        }
    }
    return null;
}

function checkObjectStale(object, overnessChange) {  // check_object_stale
    if (object.overness < 20) {
        if (!object.stale) {
            object.stale = true;
            return 'stale';
        }
    }
    else {
        if (object.stale) {
            object.stale = false;
            return 'staleEnd';
        }
        else if (object.overness <= 30) {
            // Check if overness was above 30 before
            if ((object.overness - overnessChange) > 30) {
                return 'staleStart'
            }
        }
    }
    return null;
}

function getCompanyOwnerName(company) {  // get_company_owner_name
    return company.ownerName ? company.ownerName : `Owner - ${company.name}`
}

async function addFormerCompanyRelationship(superstar, company) {  // add_former_company_relationship
    const relationship = Relationship();
    relationship.type = 'former_company';
    Relationships.insert(relationship);
    await addSuperstarRelationships(superstar, [relationship]);
    await addCompanyRelationships(company, [relationship]);
}

async function getAddStaffTaskData(talentUid, task) {  // get_add_staff_task_data
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);

    // Get staff role from task
    const roleData = {
        'scout': 'scout', 'recruit': 'scout',
        'train': 'trainer', 'transition': 'trainer', 'prepare': 'trainer', 'transition (talent)': 'trainer',
        'reassure': 'talent_manager',
        'rehab': 'doctor',
        'unlearn trait': 'all', 'transition (staff)': 'all'
    };
    const staffRole = roleData[task];

    // Get staff members based on role
    let availableStaffMembers = getAvailableStaffMembers(await getCompanyStaff(selectedCompany));
    if (staffRole !== 'all') {
        availableStaffMembers = availableStaffMembers.filter(x => x.role === staffRole)
    }
    if (task === 'transition (staff)') {
        availableStaffMembers = availableStaffMembers.filter(x => x.role !== 'doctor')
    }

    // Check if staff members present
    if (availableStaffMembers.length <= 0) {
        data['error'] = 'no-staff-member';
        data['role'] = staffRole;
        return data;
    }

    // Get data for sorted staff members
    availableStaffMembers.sort((a, b) => a.role.localeCompare(b.role) || b.level - a.level);
    data['availableStaffMembers'] = availableStaffMembers.map(x => getStaffMemberData(x));
    data['role'] = staffRole;

    // Get top role if transitioning superstar to staff
    if (task === 'transition (staff)') {
        const talent = Superstars.get(talentUid);
        if (talent) {
            data['topRolesData'] = getTransitionToStaffMemberTopRolesData(talent)
        }
    }

    return data;
}

function getTransitionToStaffMemberTopRolesData(superstar) {  // get_transition_to_staff_member_top_roles_data
    // Get available roles that have boosts
    const allRoles = ['trainer', 'scout', 'producer', 'talent_manager'];
    const availableRoles = allRoles.filter(x => !checkStaffRoleRequirement(superstar, x).requirementFailed);
    const boostsData = availableRoles.map(x => getTransitionToStaffMemberRoleBoostData(superstar, x));
    const topRolesData = boostsData.filter(x => x.xpBoost > 0);
    topRolesData.sort((a, b) => b.xpBoost - a.xpBoost);
    return topRolesData;
}

function getTransitionToStaffMemberRoleBoostData(superstar, role) {  // get_transition_to_staff_member_role_boost_data
    let boostData = {};
    let xpBoost = 0;
    let boostNames = [];

    if (['talent_manager', 'scout'].indexOf(role) >= 0) {
        if (superstar.hallOfFamer) {
            xpBoost += 20;
            boostNames.push('Hall of Famer');
        }
    }
    if (['trainer'].indexOf(role) >= 0) {
        if (superstar.traits.some(x => ['Ring General', 'Workhorse', 'Loves Training'].indexOf(x) >= 0)) {
            xpBoost += 25;
            boostNames.push(superstar.traits.find(x => ['Ring General', 'Workhorse', 'Loves Training'].indexOf(x) >= 0));
        }
        if (superstar.workrate >= 3) {
            xpBoost += 25;
            boostNames.push('High Workrate');
        }
    }
    if (['talent_manager'].indexOf(role) >= 0) {
        if (superstar.traits.some(x => ['Natural Charisma', 'Leader'].indexOf(x) >= 0)) {
            xpBoost += 25;
            boostNames.push(superstar.traits.find(x => ['Natural Charisma', 'Leader'].indexOf(x) >= 0));
        }
    }
    if (['producer'].indexOf(role) >= 0) {
        if (superstar.traits.some(x => ['Entertainer', 'Storyteller'].indexOf(x) >= 0)) {
            xpBoost += 25;
            boostNames.push(superstar.traits.find(x => ['Entertainer', 'Storyteller'].indexOf(x) >= 0));
        }
        if (superstar.charisma >= 3) {
            xpBoost += 25;
            boostNames.push('High Charisma');
        }
    }

    boostData['xpBoost'] = xpBoost;
    boostData['boostNames'] = boostNames;
    boostData['role'] = role;

    return boostData;
}

async function addStaffTask(talentUid, talentType, staffUid, taskName, skillName, traitName, roleName, replace) {  // add_staff_task
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const companyStaffMembers = (await getCompanyStaff(selectedCompany)).filter(x => !x.retired);
    const cost = taskName === 'transition (staff)' ? 50 : 10;

    // Check paid
    if (!globalUser.paid) {
        data['error'] = 'not-paid';
        return data;
    }

    // Check if enough points
    if (selectedCompany.points < cost) {
        data['error'] = 'not-enough-points';
        return data;
    }

    // Find staff member
    const staffMember = StaffMembers.get(staffUid);
    if (!staffMember) {
        data['error'] = 'staff-not-found';
        return data;
    }

    // Check if task exists
    if (!taskName) {
        data['error'] = 'no-task';
        return data;
    }

    // Find talent
    let talent;
    if (talentType === 'tagTeam') {
        talent = TagTeams.get(talentUid)
    }
    else if (talentType === 'staff') {
        talent = StaffMembers.get(talentUid)
    }
    else {
        talent = Superstars.get(talentUid)
    }
    if (!talent) {
        data['error'] = 'talent-not-found';
        return data;
    }

    data['staffMemberName'] = staffMember.name;
    data['talentName'] = talent.name;

    // Get task name and months to complete
    let monthsToComplete;
    let taskFormattedName;
    if (taskName === 'scout') {
        taskFormattedName = 'Scouting'
    }
    else if (taskName === 'recruit') {
        taskFormattedName = 'Recruiting'
    }
    else if (taskName === 'train') {
        taskFormattedName = `Training (${toTitleCase(skillName)})`;
        monthsToComplete = 3
    }
    else if (taskName === 'reassure') {
        taskFormattedName = 'Reassuring';
        monthsToComplete = 1;
        // Don't allow reassure on leaving or high morale talent
        if (talent.contractMonthsRemaining !== null) {
            data['error'] = 'leaving-talent';
            return data;
        }
        if (talent.morale >= 80) {
            data['error'] = 'high-morale-talent';
            return data;
        }
    }
    else if (taskName === 'prepare') {
        taskFormattedName = 'Preparing';
        monthsToComplete = staffMember.level < 3 ? 2 : 1;
        if (staffMember.level < 2) {
            data['error'] = 'trainer-level-2';
            return data;
        }
    }
    else if (taskName === 'transition') {
        taskFormattedName = 'Transitioning';
        monthsToComplete = 1
    }
    else if (taskName === 'rehab') {
        taskFormattedName = 'Rehabbing';
        // Don't allow rehab on short injury
        if (talent.injured < 3) {
            data['error'] = 'short-injury';
            return data;
        }
        // Don't allow rehab on non-injury
        if (!talent.injuryName) {
            data['error'] = 'non-injury';
            return data;
        }
        // Check doctor's level
        if (staffMember.level < 2) {
            data['error'] = 'doctor-level-2';
            return data;
        }
        // Check medical facility's level
        const medicalFacility = (await getCompanyFacilities(selectedCompany)).find(x => x.name === 'Medical');
        if (!medicalFacility || medicalFacility.level < 2) {
            data['error'] = 'medical-facility-level-2';
            return data;
        }
    }
    else if (taskName === 'unlearn trait') {
        taskFormattedName = `Unlearning Trait (${traitName}) For`;
        monthsToComplete = getMonthsToUnlearnTrait(talent);
        // Check if trait data present
        const traitData = traitsData[traitName];
        if (!traitData) {
            data['error'] = 'trait-not-found';
            return data;
        }
        // Check if trait can be unlearned
        if (!traitData['can_unlearn']) {
            data['error'] = 'cannot-unlearn-trait';
            return data;
        }
        // Check if correct staff role to unlearn trait
        const staffRoleToUnlearn = traitData['staff_role_to_unlearn'];
        if (staffMember.role !== staffRoleToUnlearn) {
            data['error'] = 'wrong-staff-role-to-unlearn';
            data['staffRoleToUnlearn'] = staffRoleToUnlearn;
            return data;
        }
    }
    else if (taskName === 'transition (staff)') {
        taskFormattedName = 'Transitioning (Staff)';
        monthsToComplete = 2;

        // Check for staff limit
        const facilityName = roleToFacilityData[roleName];
        const facility = (await getCompanyFacilities(selectedCompany)).find(x => x.name === facilityName);
        const numberOfRoles = getNumberOfStaffForFacility(facility);
        let numberOfCompanyRoles = companyStaffMembers.filter(x => x.role === roleName).length;
        for (const x of companyStaffMembers) {
            // Include superstars transitioning to staff
            if (x.taskData && x.taskData['role_name'] === roleName) {
                numberOfCompanyRoles += 1
            }
        }
        if (numberOfCompanyRoles >= numberOfRoles) {
            data['error'] = 'max-roles';
            data['facilityName'] = facilityName || '';
            data['numberOfRoles'] = numberOfRoles;
            return data;
        }

        // Check if on trade
        if (talent.activeEffect === 'traded') {
            data['error'] = 'trade-talent';
            return data;
        }

        // Check if leaving
        if (talent.contractMonthsRemaining !== null) {
            data['error'] = 'leaving-talent';
            return data;
        }

        // Check if correct staff role used
        if (staffMember.role !== roleName) {
            data['error'] = 'wrong-staff-role-to-transition';
            return data;
        }

        // Check if same existing role selected
        const talentStaffObject = await getSuperstarStaffObject(talent);
        if (talentStaffObject && talentStaffObject.role !== roleName) {
            data['error'] = 'different-existing-staff-role';
            data['existingRole'] = talentStaffObject.role;
            return data;
        }

        // Don't allow in stories
        if (selectedCompany.storyName === 'mars' || selectedCompany.storyName === 'passion') {
            data['error'] = selectedCompany.storyName;
            return data;
        }

        // Check role requirement first time
        const roleCheck = checkStaffRoleRequirement(talent, roleName);
        if (!talentStaffObject && roleCheck['requirementFailed']) {
            data['error'] = 'role-requirement-failed';
            data['requirementName'] = roleCheck['requirementName'];
            return data;
        }

        // Check decline
        const declineCheck = checkSuperstarTransitionDecline(talent);
        if (declineCheck['declined']) {
            data['error'] = 'transition-declined';
            data['declinedReason'] = declineCheck['declinedReason'];
            return data;
        }
    }
    else if (taskName === 'transition (talent)') {
        taskFormattedName = 'Transitioning (Talent)';
        monthsToComplete = 2;
        if (talent.$loki === staffMember.$loki) {
            data['error'] = 'task-assigned-to-self';
            return data;
        }
        const talentSuperstarObject = await getStaffSuperstarObject(talent);
        if (!talentSuperstarObject) {
            data['error'] = 'no-superstar-object-present';
            return data;
        }
    }

    let task = `${taskFormattedName} ${talent.name}`;

    // Check if any staff already working on same task
    for (const s of companyStaffMembers) {
        if (s.currentTask === task) {
            data['error'] = 'task-already-present';
            data['otherStaff'] = s.name;
            data['otherStaffTask'] = s.currentTask;
            return data;
        }
    }

    // Check for current task if not replacing
    if (staffMember.currentTask && !replace) {
        data['currentTask'] = staffMember.currentTask;
        // Check for buyout task
        if (staffMember.currentTask.indexOf('Negotiating') >= 0) {
            data['error'] = 'negotiating-buyout';
            return data;
        }
        data['error'] = 'task-present';
        return data;
    }

    // Add task and months for task to staff member
    staffMember.currentTask = task;
    if (monthsToComplete) {
        staffMember.monthsLeftForTask = monthsToComplete
    }

    // Add task data
    if (taskName === 'rehab') {
        staffMember.taskData = {'talent_id': talent.$loki}
    }
    else if (taskName === 'unlearn trait') {
        staffMember.taskData = {'trait_name': traitName}
    }
    else if (taskName === 'transition (staff)') {
        staffMember.taskData = {'role_name': roleName}
    }

    // Remove points
    selectedCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['points'] = selectedCompany.points;

    return data;
}

function getMonthsToUnlearnTrait(superstar) {  // get_months_to_unlearn_trait
    let months = 6;
    for (const trait of superstar.traits) {
        const traitData = traitsData[trait];
        if (traitData && traitData['months_to_unlearn_traits_boost']) {
            months -= traitData['months_to_unlearn_traits_boost']
        }
    }
    return months;
}

function checkStaffRoleRequirement(superstar, role) {  // check_staff_role_requirements
    let data = {};
    let requirementFailed = false;

    if (role === 'trainer') {
        if (superstar.workrate <= 1) {
            requirementFailed = true;
            data['requirementName'] = 'Low Workrate'
        }
    }
    if (role === 'producer') {
        if (superstar.charisma <= 1) {
            requirementFailed = true;
            data['requirementName'] = 'Low Charisma'
        }
    }

    data['requirementFailed'] = requirementFailed;
    return data;
}

function checkSuperstarTransitionDecline(superstar) {  // check_superstar_transition_decline
    let data = {};
    let declined = false;

    if (superstar.traits.indexOf('Dedicated Wrestler') >= 0 && superstar.age < 52) {
        declined = true;
        data['declinedReason'] = 'Dedicated Wrestler Trait'
    }
    if (superstar.traits.indexOf('Lifelong Wrestler') >= 0 && superstar.age < 60) {
        declined = true;
        data['declinedReason'] = 'Lifelong Wrestler Trait'
    }

    data['declined'] = declined;
    return data;
}

async function getAddManagerRelationshipData(checkBrandExclusivity) {  // get_add_manager_relationship_selections
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const rosterTagTeams = await getRosterTagTeams(mainRoster);
    const currentEvent = await getCompanyLatestEvent(selectedCompany);
    const companyChampionships = await getCompanyChampionships(selectedCompany);

    // Check for brand exclusive event
    let availableSuperstars = [...rosterSuperstars];
    if (checkBrandExclusivity) {
        availableSuperstars = availableSuperstars.filter(x => checkSuperstarBrandAvailability(currentEvent, x,
            getSuperstarChampionshipsFromCompanyChampionships(x, companyChampionships)));
    }

    // Get managers from available superstars, full-time managers first
    data['managerSelections'] = availableSuperstars.map(x => {
        return {'name': x.name, 'uid': x.$loki, 'fullTimeManager': x.fullTimeManager}
    });
    data['managerSelections'].sort((a, b) => a.name.localeCompare(b.name));

    // Get talent from all superstars and teams
    data['talentSelections'] = availableSuperstars.filter(x => !x.fullTimeManager).map(y => {
        return {'name': y.name, 'uid': y.$loki, 'type': 'superstar'}
    });
    data['talentSelections'].push(...rosterTagTeams.filter(x => !x.temporary).map(y => {
        return {'name': y.name, 'uid': y.$loki, 'type': 'team'}
    }));
    data['talentSelections'].sort((a, b) => a.name.localeCompare(b.name));

    return data;
}

async function getRemoveManagerRelationshipData() {  // get_remove_manager_relationship_selections
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);

    // Get managers using superstars who have manager_id set
    const managerIds = rosterSuperstars.filter(x => x.managerId).map(x => x.managerId);
    const managers = rosterSuperstars.filter(x => managerIds.indexOf(x.$loki) >= 0);

    // Get data for managers
    data['managerSelections'] = [];
    for (const x of managers) {
        let d = {};
        d['name'] = x.name;
        d['uid'] = x.$loki;
        // Add managed superstars
        const managedSuperstars = rosterSuperstars.filter(y => y.managerId === x.$loki);
        d['talentData'] = managedSuperstars.map(y => {
            return {'name': y.name, 'uid': y.$loki}
        });
        d['talentData'].sort((a, b) => a.name.localeCompare(b.name));
        data['managerSelections'].push(d);
    }
    data['managerSelections'].sort((a, b) => a.name.localeCompare(b.name));

    return data;
}

async function addManagerRelationship(managerUid, talentData) {  // add_manager_relationship
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);
    const rosterTagTeams = await getRosterTagTeams(mainRoster);
    const cost = 20;

    // Check if enough points
    if (selectedCompany.points < cost) {
        data['error'] = 'not-enough-points';
        return data;
    }

    // Get manager
    const manager = rosterSuperstars.find(x => x.$loki === managerUid);
    if (!manager) {
        data['error'] = 'manager-not-found';
        return data;
    }

    // Get superstars to manage
    let superstarsToManage = [];
    for (const d of talentData) {

        // Get talent
        let talent;
        if (d['type'] === 'superstar') {
            talent = rosterSuperstars.find(x => x.$loki === d['uid'])
        }
        else {
            talent = rosterTagTeams.find(x => x.$loki === d['uid']);
        }
        if (!talent) {
            data['error'] = 'talent-not-found';
            return data;
        }

        // Check talent superstars
        const talentSuperstars = await getRosterMemberSuperstars(talent);
        for (const s of talentSuperstars) {
            if (s.managerId) {
                data['error'] = 'manager-present';
                data['superstarName'] = s.name;
                return data;
            }
            if (s.$loki === manager.$loki) {
                data['error'] = 'managing-self';
                return data;
            }
            if (s.fullTimeManager) {
                data['error'] = 'managing-full-time-manager';
                return data;
            }
            superstarsToManage.push(s);
        }
    }

    // Remove duplicate superstars
    superstarsToManage = getUniqueObjects(superstarsToManage);

    // Check for maximum superstars
    let managedSuperstars = await getSuperstarManagedSuperstars(manager);
    if (managedSuperstars.length + superstarsToManage.length > 15) {
        data['error'] = 'maximum-superstars';
        return data;
    }

    // Add superstars to manager
    await addSuperstarsToManager(manager, superstarsToManage);

    // Check manager requests
    for (const superstarToManage of superstarsToManage) {
        await checkTalentRequestAction({company: selectedCompany, requestType: 'be_managed', talent: superstarToManage});
        let requestData = {'talentId': superstarToManage.$loki};
        await checkTalentRequestAction({company: selectedCompany, requestType: 'manage_x', talent: manager, data: requestData});
    }

    // Remove points
    selectedCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['managerName'] = manager.name;
    data['managedSuperstarsNames'] = superstarsToManage.map(x => x.name);
    data['points'] = selectedCompany.points;
    const unreadMessages = await getCompanyUnreadMessages(selectedCompany);
    data['unreadMessages'] = unreadMessages.length;

    return data;
}

async function removeManagerRelationship(managerUid, talentData) {  // remove_manager_relationship
    let data = {};
    const currentGame = await getCurrentGame();
    const selectedCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(selectedCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);

    // Get manager
    const manager = rosterSuperstars.find(x => x.$loki === managerUid);
    if (!manager) {
        data['error'] = 'manager-not-found';
        return data;
    }

    // Get superstars to remove
    let superstarsToRemove = [];
    for (const d of talentData) {
        const superstar = rosterSuperstars.find(x => x.$loki === d['uid']);
        if (!superstar) {
            data['error'] = 'talent-not-found';
            return data;
        }

        // Check superstar is managed by manager
        if (superstar.managerId !== manager.$loki) {
            data['error'] = 'not-manager';
            data['superstarName'] = superstar.name;
            return data;
        }

        superstarsToRemove.push(superstar)
    }

    // Remove duplicate superstars
    superstarsToRemove = getUniqueObjects(superstarsToRemove);

    // Remove superstars from manager
    await removeSuperstarsFromManager(manager, superstarsToRemove);

    db.saveDatabase();

    // Get data to return
    data['managerName'] = manager.name;
    data['removedSuperstarsNames'] = superstarsToRemove.map(x => x.name);

    return data;
}

async function getCpuControlledCompanies(company, game) {  // get_cpu_controlled_companies
    return (await getActiveCompetitorsForCompany(company, game)).filter(x => !x.userControlled)
}

async function getCompanyProducers() {  // get_company_producers
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const staffMembers = await getCompanyStaff(userCompany);

    const producers = await getAvailableStaffMembersByRole(staffMembers, 'producer');
    producers.sort((a, b) => b.level - a.level);
    data['producers'] = producers.map(x => getStaffMemberData(x));

    return data;
}

async function getBookingGimmickMatchesData({tagMatchOptionSelected, matchUid} = {}) {  // get_gimmick_matches
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    let latestEvent = await getCompanyLatestEvent(userCompany);
    let eventMatches = await getEventMatches(latestEvent);
    let parentEvents = await getCompanyParentEvents(userCompany);
    let mainRoster = await getCompanyRosterByType(userCompany, 'main');
    let rosterSuperstars = await getRosterSuperstars(mainRoster);
    let companyGimmickMatches = (await getCompanyGimmickMatches(userCompany)).reverse();
    let companyChampionships = await getCompanyChampionships(userCompany);
    let singlesTagMatch = ['2v2', '3v3', '4v4', '5v5', '1v2', '1v3', '2v3', '?v?'].indexOf(tagMatchOptionSelected) > -1;
    let tagMatch = !!tagMatchOptionSelected;

    // Find match, check if singles tag / tag match
    if (matchUid) {
        let match = Matches.get(matchUid);
        if (match) {
            tagMatch = match.type === 'tag';
            let matchParticipants = await getMatchParticipants(match);
            if (matchParticipants.length > 0 && matchParticipants[0].objectName === 'tagTeam') {
                if (matchParticipants.some(x => x.temporary)) {
                    singlesTagMatch = true;
                } else {
                    let firstTeamSuperstars = await getTagTeamSuperstars(matchParticipants[0]);
                    for (const matchParticipant of matchParticipants) {
                        if ((await getTagTeamSuperstars(matchParticipant)).length !== firstTeamSuperstars.length) {
                            singlesTagMatch = true;
                            break;
                        }
                    }
                }
            }
        }
    }

    // Filter gimmick matches
    let availableGimmickMatches = companyGimmickMatches.filter(x => x.available);
    let unavailableGimmickMatches = companyGimmickMatches.filter(x => !objectInArray(x, availableGimmickMatches));

    // Find gimmick matches to not show
    let gimmickMatchesToNotShow = [];
    for (const gimmickMatch of companyGimmickMatches) {

        // Remove match/championship contract if singles tag or already booked
        if (gimmickMatch.cashinContractName || gimmickMatch.matchContractName) {
            if (singlesTagMatch) {
                gimmickMatchesToNotShow.push(gimmickMatch)
            }
            for (const match of eventMatches) {
                let matchGimmick = await getMatchGimmickMatch(match);
                if (matchGimmick && matchGimmick.$loki === gimmickMatch.$loki) {
                    gimmickMatchesToNotShow.push(gimmickMatch)
                }
            }
        }

        // Don't add open challenge and battle royal if adding gimmick match to existing match
        if (matchUid && (gimmickMatch.consequence === 'random_opponent' || gimmickMatch.rules === 'battle_royal')) {
            gimmickMatchesToNotShow.push(gimmickMatch)
        }

        // Don't show story gimmick matches in tag match
        if (tagMatch) {
            if (gimmickMatch.name === 'Femme Fatale' && gimmickMatch.special) {
                gimmickMatchesToNotShow.push(gimmickMatch)
            }
            if (userCompany.storyName === 'mars' &&
                (gimmickMatch.name === 'Olympus Mons' || gimmickMatch.name === 'Hellas Impact')) {
                gimmickMatchesToNotShow.push(gimmickMatch)
            }
        }
    }

    // Remove availableGimmickMatches, sort
    availableGimmickMatches = availableGimmickMatches.filter(x => !objectInArray(x, gimmickMatchesToNotShow));
    availableGimmickMatches.sort((a, b) => a.cost - b.cost);
    unavailableGimmickMatches.sort((a, b) => a.cost - b.cost);

    // Get gimmick match names for 2/3 falls selection
    let multipleFallsGimmickMatches = availableGimmickMatches.filter(x => !x.matchContractName
        && !x.cashinContractName && !x.consequence && !x.rules);
    multipleFallsGimmickMatches.sort((a, b) => a.name.localeCompare(b.name));

    // Get superstars data for special referee match
    let specialRefereeSuperstars = rosterSuperstars.filter(x => checkSuperstarSegmentAvailability(x) &&
        checkSuperstarBrandAvailability(latestEvent, x,
            getSuperstarChampionshipsFromCompanyChampionships(x, companyChampionships)));
    specialRefereeSuperstars.sort((a, b) => a.name.localeCompare(b.name));

    // Get data to return
    data['availableGimmickMatches'] = availableGimmickMatches.map(x => getGimmickMatchData(x));
    data['unavailableGimmickMatches'] = unavailableGimmickMatches.map(x => getGimmickMatchData(x));
    data['parentEvents'] = parentEvents.map(x => {
        return {name: x.name, uid: x.$loki}
    });
    data['multipleFallsGimmickMatches'] = multipleFallsGimmickMatches.map(x => x.name);
    data['specialRefereeSuperstars'] = specialRefereeSuperstars.map(x => {
        return {'name': x.name, 'uid': x.$loki}
    });

    return data;
}

function generateGimmickMatchObject({participantNames, previousName} = {}) {
    let objectName = generateGimmickMatchObjectName(participantNames);
    while (objectName === previousName) {
        objectName = generateGimmickMatchObjectName(participantNames)
    }
    return objectName;
}

function generateGimmickMatchObjectName(participantNames) {
    let objects = ['Kendo Stick', 'Chair', '$10,000', 'Cucumber', 'Spider', 'Pole', 'Guitar', 'JoW Disc', 'Handcuffs',
        'Brass Knuckles', 'Chain', 'Pickle Jar', 'Banana', 'Deodorant', 'Baseball Bat', 'Teddy Bear', 'Pills',
        'Knife', 'Barbed Wire', 'Toilet Paper', 'Screwdriver', 'Water Gun', 'Steroids'];
    let superstarObjects = ['Action Figure', 'Son', 'Daughter', 'Mother', 'Child', 'Family Photo', 'Spouse', 'Trophies',
        'Secret Recipe', 'Divorce Papers', 'Pet Mouse', 'Shoes', 'Merch', 'Passport', 'Favorite CD',
        'Diary', 'Underwear', 'Soul', 'Home Key', 'Best Friend', 'DNA', 'Knitting Needles',
        'Stuffed Toy', 'Lunch', '$10', 'Pet Fish', 'Baby Oil'];
    if (participantNames.length > 0 && getRandomInt(0, 100) <= 50) {
        return `${getRandomChoice(superstarObjects)} of ${getRandomChoice(participantNames)}`
    }
    else {
        return getRandomChoice(objects)
    }
}

function generateGimmickMatchLocation({participantNames, previousName} = {}) {
    let locationName = generateGimmickMatchLocationName(participantNames);
    while (locationName === previousName) {
        locationName = generateGimmickMatchLocationName(participantNames)
    }
    return locationName;
}

function generateGimmickMatchLocationName(participantNames) {
    let locations = ['Parking Lot', 'Bar', 'Boiler Room', 'Locker Room', 'Gorilla Position', 'Rafters', 'Beach',
        'Grocery Store', 'Pool', 'Restaurant', 'Farmer\'s Market', 'Flea Market', 'Graveyard', 'Hospital',
        'Barn', 'Golf Course', 'Nightclub', 'Sewer', 'Library', 'Opera House', 'Alley', 'Zoo', 'Church'];
    let superstarLocations = ['Compound', 'Basement', 'Dungeon', 'Backyard', 'Bedroom', 'Favorite Club', 'House',
        'Beach House', 'Favorite Fast Food Joint', 'Barn', 'Underground Lair', 'Mansion', 'Ranch',
        'Cabin', 'Castle', 'Tree House', 'Bunker', 'Hotel Room', 'Shed', 'Greenhouse',
        'Private Island', 'Mind', 'Yacht'];
    if (participantNames.length > 0 && getRandomInt(0, 100) <= 50) {
        return `${getRandomChoice(participantNames)}'s ${getRandomChoice(superstarLocations)}`
    }
    else {
        return getRandomChoice(locations)
    }
}

function generateGimmickMatch() {  // generate_gimmick_match
    let gimmickMatch = GimmickMatch();
    gimmickMatch.name = generateGimmickMatchName();
    gimmickMatch.ratingBoost = myround(getRandomUniform(1.13, 1.3), 0.01);
    gimmickMatch.popularityIncrease = myround(getRandomUniform(1.6, 2.5), 0.01);
    gimmickMatch.popularityDecrease = myround(getRandomUniform(0.9, 0.4), 0.01);
    gimmickMatch.injuryRate = myround(getRandomUniform(1.1, 1.2), 0.01);
    gimmickMatch.available = true;
    gimmickMatch.cost = calculateGimmickMatchCost(gimmickMatch);
    return gimmickMatch;
}

function generateGimmickMatchName() {  // generate_gimmick_match_name
    let prefixes = ['Hell', 'Burning', 'Last', 'Nightmare', 'Punjabi', 'Insanity', 'Royal', 'Ultimate', 'Final',
                'Lunatic', 'Hardcore', 'Concrete', 'Titanium', 'Electric', 'Fire', 'Blood', 'Glass', 'Scaffold',
                'Ladder'];
    let suffixes = ['War', 'Cage', 'Cell', 'Chain', 'Battle', 'Cell', 'Asylum', 'Prison',
                'Horrors', 'Chamber', 'Brawl', 'Fight', 'Combat', 'Melee'];
    return `${getRandomChoice(prefixes)} ${getRandomChoice(suffixes)}`;
}

async function getCompanyUniqueTournaments({} = {}) {  // _get_company_tournaments_unique
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const tournaments = (await getCompanyTournaments(userCompany)).filter(x => !x.annualTournament);
    let uniqueTournaments = getUniqueObjectsByName(tournaments);

    // Get latest of each tournament by $loki
    let maxTournaments = [];
    for (const y of uniqueTournaments) {
        let maxTournament = getArrayMaxByProperty(tournaments.filter(x => x.name === y.name), '$loki');
        maxTournaments.push(maxTournament);
    }

    // Get data to return
    data['tournaments'] = await Promise.all(maxTournaments.map(x => getTournamentData(x)));
    data['events'] = (await getCompanyParentEvents(userCompany)).map(x => x.name);

    return data;
}

async function createCompanyAlert(type, name, description = null) {  // create_company_alert
    const companyAlert = CompanyAlert();
    companyAlert.type = type;
    companyAlert.name = name;
    companyAlert.description = description;
    CompanyAlerts.insert(companyAlert);
    return companyAlert;
}

async function updateStaffMemberXp(staffMember, xpGain, company, game) {  // update_staff_member_xp
    const xps = {2: 300, 1: 100};
    let levelIncrease = false;
    staffMember.xp += xpGain;

    if (staffMember.level < 3) {
        if (staffMember.xp >= (xps[staffMember.level] || 300)) {
            staffMember.level += 1;
            levelIncrease = true;

            // Add level up message
            if (company.userControlled) {
                const newMessage = await createStaffLevelUpMessage(staffMember, game.monthCount, game.year);
                await addCompanyMessages(company, [newMessage]);
            }

            // Unlock special segment
            if (staffMember.level === 3 && staffMember.role === 'doctor') {
                const user = loadUser();
                await unlockSpecialSegment(company, 'Timely Rescue', game.monthCount, game.year);
            }
        }
    }

    return levelIncrease;
}

function getStaffAgeMultiplier(staffMember) {  // get_staff_age_multiplier
    if (staffMember.age < 30) {
        return 1.5
    }
    else if (staffMember.age < 45) {
        return 1
    }
    else if (staffMember.age < 100) {
        return 0.75
    }
    else {
        return 0.75
    }
}

async function changeProperty({name, change, company, rating = null, superstarName = null, gimmickMatchName = null,
                               championship = null} = {}) {  // change_property
    let objectiveCompletedName = null;
    const objectives = (await getCompanyObjectives(company)).filter(x => !x.past && !x.completed);
    const properties = (await Promise.all(objectives.map(x => getObjectiveProperties(x)))).flat();

    // Find property and objective
    const p = properties.find(x => x.name === name);
    if (p) {
        if (p.rating) {
            if (gimmickMatchName) {
                const propertyGimmickMatches = await getPropertyGimmickMatches(p);
                let propertyGimmickMatchName;
                if (propertyGimmickMatches.length > 0) {
                    propertyGimmickMatchName = propertyGimmickMatches[0].name;
                } else {
                    propertyGimmickMatchName = p.gimmickMatchName;
                }
                if (gimmickMatchName === propertyGimmickMatchName && rating >= p.rating) {
                    p.value += change;
                }
            } else {
                if (rating >= p.rating) {
                    p.value += change;
                }
            }
        } else if (p.superstarName) {
            // If property superstars present, check superstarName against their names
            const propertySuperstars = await getPropertySuperstars(p);
            let propertySuperstarName;
            if (propertySuperstars.length > 0) {
                propertySuperstarName = commaSeparate(propertySuperstars.map(x => x.name)
                    .sort((a, b) => a.localeCompare(b)))
            }
            // Otherwise, check against superstarName of property (old games compatibility)
            else {
                propertySuperstarName = p.superstarName;
            }
            if (superstarName === propertySuperstarName) {
                p.value += change;
            }
        } else if (p.name === 'championship prestige') {
            const propertyChampionships = await getPropertyChampionships(p);
            let propertyChampionshipName;
            if (propertyChampionships.length > 0) {
                propertyChampionshipName = getChampionshipDisplayName(propertyChampionships[0]);
            }
            else {
                propertyChampionshipName = p.championshipName;
            }
            if (getChampionshipDisplayName(championship) === propertyChampionshipName &&
                championship.prestige === p.activationText) {
                p.value += change;
            }
        } else {
            p.value += change;
        }

        // Check for completion
        if (p.value >= p.activationValue) {
            const objective = await getPropertyObjective(p);
            objective.completed = true;
            objectiveCompletedName = objective.name;
        }
    }

    return objectiveCompletedName;
}

async function processObjectiveCompleted(objectiveName, company) {  // process_objective_completed
    // Add reward
    const reward = myround(getRandomInt(200, 320), 20);
    company.points += reward;

    // Add message
    const newMessage = await createObjectiveCompletedMessage(objectiveName, reward, company);
    await addCompanyMessages(company, [newMessage]);

    // Add company alert
    const newCompanyAlert = await createCompanyAlert('goalCompleted', objectiveName);
    await addCompanyCompanyAlerts(company, [newCompanyAlert]);

    return true;
}

async function checkCompetitorsAvailableForBuyout(company, month, year) {  // check_competitors_available_for_buyout
    const data = {};
    const game = await getCompanyGame(company);
    const activeCompetitors = (await getActiveCompetitorsForCompany(company, game)).filter(x => !x.userControlled);

    for (const competitor of activeCompetitors) {
        const availableForBuyoutCheck = checkBuyoutAvailability(competitor, game.marketSize, activeCompetitors);

        if (competitor.operatingStatus === 'Active') {

            // Chance to become available for buyout
            if (availableForBuyoutCheck && getRandomInt(0, 100) <= 30) {
                competitor.operatingStatus = 'Buyout Available';
                const talentManager = getRandomStaffMemberByRole((await getCompanyStaff(company)), 'talent_manager');
                const newMessage = await createCompetitorBuyoutAvailableMessage(competitor, month, year,
                    talentManager);
                await addCompanyMessages(company, [newMessage]);

                const newCompanyAlert = await createCompanyAlert('buyoutAvailable', competitor.name);
                await addCompanyCompanyAlerts(company, [newCompanyAlert]);

                let newsItem = await generateNewsItem({
                    company: competitor, month, year, newsType: 'buyout_available', headline: true
                });
                await addCompanyNewsItems(company, [newsItem]);
            }

        }
        else if (competitor.operatingStatus === 'Buyout Available') {

            // Become unavailable for buyout
            if (!availableForBuyoutCheck) {
                competitor.operatingStatus = 'Active';
                const talentManager = getRandomStaffMemberByRole((await getCompanyStaff(company)), 'talent_manager');
                const newMessage = await createCompetitorBuyoutNoLongerAvailableMessage(competitor, month, year, talentManager);
                await addCompanyMessages(company, [newMessage]);

                let newsItem = await generateNewsItem({
                    company: competitor, month, year, newsType: 'buyout_not_available', headline: true
                });
                await addCompanyNewsItems(company, [newsItem]);
            }

            // Chance to fold company
            if (availableForBuyoutCheck && getRandomInt(0, 100) <= 0) {

                // Get rosters
                let rosters = await getCompanyRosters(company);
                let indieRoster = await getCompanyRosterByType(company, 'indie', rosters);
                let indieAvailableRoster = await getCompanyRosterByType(company, 'indieAvailable', rosters);
                let indieFutureRoster = await getCompanyRosterByType(company, 'indieFuture', rosters);

                // Get superstars from main, training, and future rosters
                let competitorRosters = await getCompanyRosters(competitor);
                let competitorSuperstars = [];
                for (const x of ['main', 'training', 'trainingAvailable', 'trainingFuture']) {
                    let roster = await getCompanyRosterByType(competitor, x, competitorRosters);
                    if (roster) {
                        competitorSuperstars.push(...(await getRosterSuperstars(roster)))
                    }
                }

                // Transfer superstars on trade
                let onTradeSuperstars = competitorSuperstars.filter(x => x.activeEffect === 'traded');
                competitorSuperstars = competitorSuperstars.filter(x => x.activeEffect !== 'traded');
                for (let superstar of onTradeSuperstars) {
                    const originalRoster = await getSuperstarOriginalRoster(superstar);
                    await addRosterSuperstars(originalRoster, [superstar]);
                    await vacateChampionships({
                        superstar: superstar, championships: (await getCompanyChampionships(competitor)), month, year
                    });
                    await removeSuperstarFactionRelationships(superstar, month, year);
                    await removeSuperstarManagerRelationships(superstar);
                    superstar.brandName = null;
                    superstar.activeEffect = null;
                    if (!superstar.partTimer) {
                        superstar.appearances = null;
                    }
                }

                // Transfer superstars to indie rosters
                let numberForIndieUnavailableRoster = Math.round(competitorSuperstars.length * 0.6);
                let superstarsForIndieUnavailableRoster;
                if (game.settings['all_indies_available']) {
                    superstarsForIndieUnavailableRoster = [];
                } else {
                    superstarsForIndieUnavailableRoster = getRandomSample(competitorSuperstars,
                        numberForIndieUnavailableRoster);
                }
                let superstarsForIndieAvailableRoster = competitorSuperstars
                    .filter(x => !objectInArray(x, superstarsForIndieUnavailableRoster));

                for (let superstar of competitorSuperstars) {
                    if (superstar.monthToAppearIn) {
                        // Send future superstars to indie future roster
                        if (indieFutureRoster) {
                            await addRosterSuperstars(indieFutureRoster, [superstar])
                        }
                    } else {
                        if (objectInArray(superstar, superstarsForIndieUnavailableRoster)) {
                            await addRosterSuperstars(indieRoster, [superstar])
                        } else {
                            await addRosterSuperstars(indieAvailableRoster, [superstar])
                        }
                    }
                    superstar.brandName = null;
                }

                // Get tagTeams from main and training rosters
                let competitorTagTeams = [];
                for (const x of ['main', 'training', 'trainingAvailable']) {
                    let roster = await getCompanyRosterByType(competitor, x, competitorRosters);
                    if (roster) {
                        competitorTagTeams.push(...(await getRosterTagTeams(roster)))
                    }
                }

                // Move/remove teams if trade ending
                for (let superstar of onTradeSuperstars) {
                    for (let tagTeam of [...(await getSuperstarTagTeams(superstar))]) {
                        let ts = await getTagTeamSuperstars(tagTeam);
                        if (ts.every(s => objectInArray(s, onTradeSuperstars))) {
                            await addRosterTagTeams((await getSuperstarOriginalRoster(superstar)), [tagTeam]);
                        }
                        else {
                            await removeTagTeam(tagTeam);
                        }
                        competitorTagTeams = competitorTagTeams.filter(x => x !== tagTeam);
                    }
                }

                // Transfer teams to indie rosters if all members in same roster, otherwise remove tag team
                for (let tagTeam of competitorTagTeams) {
                    let foundInRoster = null;
                    let teamSuperstars = await getTagTeamSuperstars(tagTeam);
                    if (teamSuperstars.every(x => objectInArray(x, superstarsForIndieUnavailableRoster))) {
                        foundInRoster = indieRoster;
                    } else if (teamSuperstars.every(x => objectInArray(x, superstarsForIndieAvailableRoster))) {
                        foundInRoster = indieAvailableRoster;
                    }
                    if (foundInRoster) {
                        await addRosterTagTeams(foundInRoster, [tagTeam]);
                    } else {
                        tagTeam.rosterId = null;
                        await removeTagTeamSuperstars(tagTeam);
                    }
                }

                // Vacate competitor championships and remove from champions
                let competitorChampionships = await getCompanyChampionships(competitor);
                for (let championship of competitorChampionships) {
                    let s = await getChampionshipSuperstar(championship);
                    if (s) {
                        championship.vacated = true;
                        await removeSuperstarChampionships(s, [championship]);
                    }
                }

                // Mark competitor as inactive
                competitor.operatingStatus = 'Inactive';

                // Decrease market size (moves some fans to competitors in next market size process)
                if (game.marketSize !== null) {
                    let lostFans = Math.round(competitor.fans * 0.75);
                    game.marketSize -= lostFans;
                    competitor.fans = lostFans;
                }

                let newsItem = await generateNewsItem({
                    company, month, year, competitor, newsType: 'company_folds', headline: true
                });
                await addCompanyNewsItems(company, [newsItem]);

                const newCompanyAlert = await createCompanyAlert('companyFolded', competitor.name);
                await addCompanyCompanyAlerts(company, [newCompanyAlert]);
            }
        }
    }

    return data;
}

function checkBuyoutAvailability(company, marketSize, competitors) {  // check_buyout_availability
    const reputationDifference = company.highestReputation - company.reputation;
    if (marketSize) {
        let threshold = 0.0025;
        if (competitors.length >= 15) {
            threshold = 0.0015
        }
        if (company.fans < (threshold * marketSize)) {
            return true;
        } else if (company.fans < (threshold * 10 * marketSize) && reputationDifference >= 5) {
            return true;
        }
    } else {
        if (reputationDifference >= 5) {
            return true;
        }
    }
    return false;
}

async function addNewCompetitorCheck(company) {  // add_new_competitor_check
    const minimumSuperstars = 50;
    const game = await getCompanyGame(company);
    let indieRoster = await getCompanyRosterByType(company, 'indie');
    let indieAvailableRoster = await getCompanyRosterByType(company, 'indieAvailable');
    const indieRosterSuperstars = (await getRosterSuperstars(indieRoster)).concat(await getRosterSuperstars(indieAvailableRoster));
    const indieRosterTagTeams = (await getRosterTagTeams(indieRoster)).concat(await getRosterTagTeams(indieAvailableRoster));
    const companyLogs = (await getCompanyCompanyLogs(company)).reverse();

    if (company.storyName === 'mars' || company.storyName === 'passion') {
        return false;
    }

    if (!game.competitorsPresent) {
        return false;
    }

    // Check competitor limit
    const companies = await getGameActiveCompanies(game);
    if (companies.length >= gameLimits.maxCompetitors + 1) {
        return false;
    }

    // Check indie roster size
    if (indieRosterSuperstars.length < minimumSuperstars) {
        return false;
    }

    // Check for buyout
    let addBuyoutChance = false;
    const buyout = companyLogs.find(x => x.type === 'buyout'); // Get latest buyout
    if (buyout) {
        // Add higher chance after buyout
        const buyoutMonthsPassed = getMonthsDifference(game.monthCount, game.year, buyout.month, buyout.year);
        if (buyoutMonthsPassed === 9 || buyoutMonthsPassed === 15) {
            addBuyoutChance = true;
        }
    }

    const chance = addBuyoutChance ? 60 : 2;

    // Chance to generate competitor
    const pick = getRandomInt(0, 100);
    if (pick <= chance) {

        // Get starting event index and standard feud and segment items
        const parentEvents = await getCompanyParentEvents(company);
        const nextEvent = (await getCompanyEvents(company)).filter(x => !x.weeklyShow).reverse()[0];
        const parentEventsNames = parentEvents.map(x => x.name);
        const startingEventIndex = parentEventsNames.indexOf(nextEvent.name);

        // Get number of superstars to add to competitor
        const percentageToAdd = getRandomUniform(0.75, 0.8);
        let numberOfSuperstarsToAdd = Math.floor(percentageToAdd * indieRosterSuperstars.length);
        const maximumSuperstars = 80;
        if (numberOfSuperstarsToAdd > maximumSuperstars) {
            numberOfSuperstarsToAdd = maximumSuperstars + getRandomInt(-4, 4);
        }

        // Get superstars to add
        let superstars = getRandomSample(indieRosterSuperstars, numberOfSuperstarsToAdd);

        // Add top indie superstars
        const topIndieSuperstars = [...indieRosterSuperstars].sort((a, b) => b.popularity - a.popularity).slice(0, 8);
        if (topIndieSuperstars.length >= 5) {
            for (const superstar of getRandomSample(topIndieSuperstars, 5)) {
                if (!objectInArray(superstar, superstars)) {
                    superstars.push(superstar);
                }
            }
        }

        // Remove some stale superstars
        const staleSuperstars = superstars.filter(x => x.stale);
        for (const superstar of staleSuperstars.slice(0, 8)) {
            superstars.splice(superstars.indexOf(superstar), 1);
        }

        // Get owner, chance to make a veteran the owner
        const veterans = superstars.filter(x => x.age >= 35 && x.popularity >= 800 && (x.partTimer || x.retired || x.fullTimeManager));
        const owner = (veterans.length > 0 && getRandomInt(0, 100) <= 75) ? getRandomChoice(veterans) : await generateSuperstar();

        // Get tag teams of superstars added
        const tagTeams = [];
        for (const tagTeam of indieRosterTagTeams) {
            const teamSuperstars = await getTagTeamSuperstars(tagTeam);
            // If all team members selected, move team
            if (teamSuperstars.every(x => objectInArray(x, superstars))) {
                tagTeams.push(tagTeam);
            }
            // If any but not all team members selected, remove team
            else if (teamSuperstars.some(x => objectInArray(x, superstars))) {
                tagTeam.rosterId = null;
                await removeTagTeamSuperstars(tagTeam);
            }
        }

        // Generate competitor
        const newCompetitor = await generateCompany({startingEventIndex, existingCompanyNames: companies.map(x => x.name),
            superstars, tagTeams, ownerName: owner.name, month: game.monthCount, year: game.year, realYear: company.realYear, game});
        newCompetitor.activeEffect = 'good_booking';

        if (game.marketSize !== null) {
            // Add fans, percentage of market size
            newCompetitor.fans = (0.0125 * newCompetitor.reputation) * game.marketSize;
            newCompetitor.fans = myround(newCompetitor.fans, 10000);

            // Increase market size
            game.marketSize += newCompetitor.fans;

            // Add reputation xp
            newCompetitor.xp = reputationXpLevels[newCompetitor.reputation];
            newCompetitor.xp += (reputationXpLevels[newCompetitor.reputation + 1] - newCompetitor.xp) / 10.0;
        }

        const topSuperstars = [...superstars].sort((a, b) => b.popularity - a.popularity).slice(0, 3).map(x => x.name);

        // Add message from talent manager
        const talentManager = getRandomStaffMemberByRole((await getCompanyStaff(company)), 'talent_manager');
        const newMessage = await createNewCompetitorMessage(newCompetitor.name, owner.name, topSuperstars,
            game.monthCount, game.year, talentManager);
        await addCompanyMessages(company, [newMessage]);

        // Add company alert
        const newCompanyAlert = await createCompanyAlert('companyFormed', newCompetitor.name);
        await addCompanyCompanyAlerts(company, [newCompanyAlert]);

        // Add company log
        const newLog = CompanyLog(game.monthCount, game.year);
        CompanyLogs.insert(newLog);
        newLog.text = `New Company formed: ${newCompetitor.name}`;
        newLog.type = 'new_company';
        newLog.value = 8;
        await addCompanyCompanyLogs(company, [newLog]);

        // Add news
        let newsItem = await generateNewsItem({
            company: newCompetitor, month: game.newsMonth, year: game.newsYear, newsType: 'new_company', headline: true
        });
        await addCompanyNewsItems(company, [newsItem]);
    }

    return true;
}

async function getBuyoutInformation({uid} = {}) {  // get_buyout_information
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    // Get competitor
    const competitor = (await getActiveCompetitorsForCompany(userCompany, currentGame))
        .find(x => x.$loki === uid && x.operatingStatus === 'Buyout Available');
    if (!competitor) {
        data['error'] = 'competitor-not-found';
        return data;
    }

    // Get company data
    data = getViewCompanyData(competitor, userCompany);
    const facility = (await getCompanyFacilities(userCompany)).find(x => x.name === 'Talent Management');
    data['acquisitionFacilityPresent'] = facility ? facility.level >= 3 : false;
    data['cost'] = myround(3000 + (competitor.reputation * 200), 100);
    data['companyInformation'] = await getScenarioCompanyInformation(competitor, true);

    // Get available talent managers
    const talentManagers = getAvailableStaffMembersByRole((await getCompanyStaff(userCompany)), 'talent_manager');
    if (!talentManagers.length) {
        data['error'] = 'no-talent-manager-available';
        return data;
    }
    talentManagers.sort((a, b) => b.level - a.level);
    data['talentManagers'] = talentManagers.map(x => getStaffMemberData(x));

    return data;
}

async function makeBuyoutOffer({uid, talentManagerUid} = {}) {  // make_buyout_offer
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const competitor = (await getActiveCompetitorsForCompany(userCompany, currentGame))
        .find(x => x.$loki === uid && x.operatingStatus === 'Buyout Available');

    if (userCompany.storyName === 'mars') {
        data['error'] = 'mars';
        return data;
    }

    if (!competitor) {
        data['error'] = 'competitor-not-found';
        return data;
    }

    // Get talent manager
    const talentManager = StaffMembers.get(talentManagerUid);
    if (!talentManager) {
        data['error'] = 'talent-manager-not-found';
        return data;
    }
    if (talentManager.currentTask) {
        // Check if already negotiating buyout
        if (talentManager.currentTask.includes('Negotiating')) {
            data['error'] = 'negotiating-buyout';
            data['talentManager'] = talentManager.name;
            data['currentTask'] = talentManager.currentTask;
            return data;
        }
    }

    // Check facility level
    const talentManagementFacility = (await getCompanyFacilities(userCompany)).find(x => x.name === 'Talent Management');
    if (!talentManagementFacility || talentManagementFacility.level < 3) {
        data['error'] = 'talent-management-facility-level';
        return data;
    }

    // Check if buyout available
    if (competitor.operatingStatus !== 'Buyout Available') {
        data['error'] = 'not-available-for-buyout';
        return data;
    }

    // Get cost
    const cost = myround(3000 + competitor.reputation * 200, 100);
    if (userCompany.points < cost) {
        data['error'] = 'not-enough-points';
        return data;
    }

    // Add task
    talentManager.currentTask = `Negotiating ${competitor.name} Buyout`;
    talentManager.monthsLeftForTask = 2;

    // Change competitor's operating status
    competitor.operatingStatus = `Negotiating Buyout by ${userCompany.name}`;

    // Remove points
    userCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['points'] = userCompany.points;
    data['talentManager'] = talentManager.name;
    data['task'] = talentManager.currentTask;
    data['competitorName'] = competitor.name;

    return data;
}

async function confirmBuyoutSelections({superstarUids, championshipUids, companyUid, sendAllToMainRoster} = {}) {  // confirm_buyout
    let data = {};
    const game = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(game);
    const mainCompany = await getGameMainUserCompany(game);
    const user = loadUser();
    const competitor = (await getActiveCompetitorsForCompany(userCompany, game))
        .find(x => x.$loki === companyUid && x.operatingStatus !== 'Inactive');
    const competitorRosters = await getCompanyRosters(competitor);
    const competitorMainRoster = competitorRosters[0];
    let competitorSuperstars = await getRosterSuperstars(competitorMainRoster);
    const competitorTagTeams = await getRosterTagTeams(competitorMainRoster);
    const competitorFactions = await getRosterFactions(competitorMainRoster);
    let competitorChampionships = await getCompanyChampionships(competitor);
    const competitorActiveFeuds = (await getRosterFeuds(competitorMainRoster)).filter(x => x.ended === false);
    const [available] = await getBuyoutSuperstars(competitor, competitorSuperstars, userCompany);
    const month = game.monthCount;
    const year = game.year;

    // Add training roster superstars, teams, and future superstars, but don't include them in available to select
    for (const x of ['training', 'trainingAvailable', 'trainingFuture']) {
        let r = await getCompanyRosterByType(competitor, x, competitorRosters);
        if (r) {
            competitorSuperstars.push(...(await getRosterSuperstars(r)));
            competitorTagTeams.push(...(await getRosterTagTeams(r)));
        }
    }

    if (!competitor) {
        data['error'] = 'competitor-not-found';
        return data;
    }

    // If buyout not running, return error
    if (!competitor.operatingStatus.includes('Running Buyout')) {
        data['error'] = 'no-buyout-running';
        return data;
    }

    // Get superstars from available buyout superstars
    let superstars = await Promise.all(superstarUids.map(x => Superstars.get(x)));
    superstars = superstars.filter(x => objectInArray(x, available));
    let signingsAvailable = getNumberOfBuyoutSignings(competitor);
    if (!superstars.length) {
        // Auto add signings if none selected
        if (signingsAvailable > available.length) {
            signingsAvailable = available.length;
        }
        superstars = getRandomSample(available, signingsAvailable);
    }
    // Max superstars
    if (superstars.length > signingsAvailable) {
        superstars = superstars.slice(0, signingsAvailable);
    }

    // Get championships
    let championships = await Promise.all(championshipUids.map(x => Championships.get(x)));
    let championshipsAvailable = 3;
    if (!championships.length) {
        // Auto add championships if none selected
        const uniqueCompetitorChampionships = getUniqueChampionships(competitorChampionships);
        if (championshipsAvailable > uniqueCompetitorChampionships.length) {
            championshipsAvailable = uniqueCompetitorChampionships.length;
        }
        championships = getRandomSample(uniqueCompetitorChampionships, championshipsAvailable);
    }
    // Max championships
    if (championships.length > championshipsAvailable) {
        championships = championships.slice(0, championshipsAvailable);
    }

    // Transfer superstars. Send top 70% to main roster, rest to training roster
    const companyRosters = await getCompanyRosters(userCompany);
    const companyMainRoster = await getCompanyRosterByType(userCompany, 'main', companyRosters);
    const companyTrainingRoster = await getCompanyRosterByType(userCompany, 'training', companyRosters);
    let indieRoster = await getCompanyRosterByType(mainCompany, 'indie');
    let indieAvailableRoster = await getCompanyRosterByType(mainCompany, 'indieAvailable');
    let indieFutureRoster = await getCompanyRosterByType(mainCompany, 'indieFuture');
    let superstarsForMainRoster = [...superstars].sort((a, b) => b.popularity - a.popularity);
    if (!sendAllToMainRoster) {
        const numberForMainRoster = Math.round(superstars.length * 0.7);
        superstarsForMainRoster = superstarsForMainRoster.slice(0, numberForMainRoster);
    }

    // Add retired superstars to main roster, not training
    const retiredSuperstars = superstars.filter(x => x.retired && !objectInArray(x, superstarsForMainRoster));
    superstarsForMainRoster.push(...retiredSuperstars);
    const superstarsForTrainingRoster = superstars.filter(x => !objectInArray(x, superstarsForMainRoster));

    // Move superstars
    for (const superstar of superstars) {
        if (objectInArray(superstar, superstarsForMainRoster)) {
            await addRosterSuperstars(companyMainRoster, [superstar]);
        } else {
            await addRosterSuperstars(companyTrainingRoster, [superstar]);
        }
        superstar.brandName = null;
        await removeSuperstarManagerRelationships(superstar);
        // Remove from competitorSuperstars
        competitorSuperstars = competitorSuperstars.filter(x => x.$loki !== superstar.$loki);
    }

    // Add signing company log
    for (const superstar of superstarsForMainRoster) {
        let newLog = CompanyLog(month, mainCompany.realYear);
        CompanyLogs.insert(newLog);
        newLog.text = superstar.name;
        newLog.value = 0;
        newLog.type = 'signing';
        newLog.realYear = year;
        await addCompanyCompanyLogs(userCompany, [newLog]);
    }

    // Transfer championships
    const superstarsForMainRosterIds = superstarsForMainRoster.map(x => x.$loki);
    for (const championship of championships) {
        // Get tag, trio title sets
        const allFoundChampionships = competitorChampionships.filter(x => checkAreChampionshipsEqual(x, championship));
        // Check if all championship holders are transferred to the main roster
        const championFound = allFoundChampionships.every(x => superstarsForMainRosterIds.includes(x.superstarId));
        for (const c of allFoundChampionships) {
            await addCompanyChampionships(userCompany, [c]);
            // Vacate title if all championship holders not transferred
            if (!championFound) {
                c.vacated = true;
                const champion = await getChampionshipSuperstar(c);
                if (champion) {
                    await removeSuperstarChampionships(champion, [c]);
                }
            }
            c.booked = false;
            // Remove from competitorChampionships
            competitorChampionships = competitorChampionships.filter(x => x.$loki !== c.$loki);
        }
    }

    // Transfer remaining competitor superstars. Send 60% to indie unavailable, rest to indie available.
    const numberForIndieUnavailableRoster = Math.round(competitorSuperstars.length * 0.6);
    let superstarsForIndieUnavailableRoster = [];
    if (game.settings['all_indies_available']) {
        superstarsForIndieUnavailableRoster = [];
    } else {
        superstarsForIndieUnavailableRoster = getRandomSample(competitorSuperstars, numberForIndieUnavailableRoster);
    }
    const superstarsForIndieAvailableRoster = competitorSuperstars
        .filter(x => !objectInArray(x, superstarsForIndieUnavailableRoster));
    for (const superstar of competitorSuperstars) {
        if (superstar.monthToAppearIn) {
            // Send future superstars to indie future roster
            if (indieFutureRoster) {
                await addRosterSuperstars(indieFutureRoster, [superstar]);
            }
        } else {
            if (objectInArray(superstar, superstarsForIndieUnavailableRoster)) {
                await addRosterSuperstars(indieRoster, [superstar]);
            } else {
                await addRosterSuperstars(indieAvailableRoster, [superstar]);
            }
        }
        superstar.brandName = null;
        await removeSuperstarManagerRelationships(superstar);
    }

    // Vacate remaining competitor championships and remove from champions
    for (const c of competitorChampionships) {
        const champion = await getChampionshipSuperstar(c);
        if (champion) {
            await removeSuperstarChampionships(champion, [c]);
        }
    }

    // Transfer tag teams
    const tagTeamsForMainRoster = [];
    for (const tagTeam of competitorTagTeams) {
        // If all team superstars moved to one roster, move team
        let foundInRoster = null;
        const tagTeamSuperstars = await getTagTeamSuperstars(tagTeam);
        if (tagTeamSuperstars.every(x => objectInArray(x, superstarsForMainRoster))) {
            foundInRoster = companyMainRoster;
            tagTeamsForMainRoster.push(tagTeam);
            // Add signing company log
            let newLog = CompanyLog(month, mainCompany.realYear);
            CompanyLogs.insert(newLog);
            newLog.text = tagTeam.name;
            newLog.value = 0;
            newLog.type = 'signing';
            newLog.realYear = year;
            await addCompanyCompanyLogs(userCompany, [newLog]);
        } else if (tagTeamSuperstars.every(x => objectInArray(x, superstarsForTrainingRoster))) {
            foundInRoster = companyTrainingRoster;
        } else if (tagTeamSuperstars.every(x => objectInArray(x, superstarsForIndieUnavailableRoster))) {
            foundInRoster = indieRoster;
        } else if (tagTeamSuperstars.every(x => objectInArray(x, superstarsForIndieAvailableRoster))) {
            foundInRoster = indieAvailableRoster;
        }
        if (foundInRoster) {
            await addRosterTagTeams(foundInRoster, [tagTeam])
        } else {
            await removeTagTeamSuperstars(tagTeam)
        }
    }

    // Transfer factions
    const factionsForMainRoster = [];
    for (const faction of competitorFactions) {
        // If all faction superstars moved to one roster, move faction
        let foundInRoster = null;
        const factionSuperstars = await getFactionSuperstars(faction);
        if (factionSuperstars.every(x => objectInArray(x, superstarsForMainRoster))) {
            foundInRoster = companyMainRoster;
            factionsForMainRoster.push(faction);
        } else if (factionSuperstars.every(x => objectInArray(x, superstarsForTrainingRoster))) {
            foundInRoster = companyTrainingRoster;
        } else if (factionSuperstars.every(x => objectInArray(x, superstarsForIndieUnavailableRoster))) {
            foundInRoster = indieRoster;
        } else if (factionSuperstars.every(x => objectInArray(x, superstarsForIndieAvailableRoster))) {
            foundInRoster = indieAvailableRoster;
        }
        if (foundInRoster) {
            await addRosterFactions(foundInRoster, [faction])
        } else {
            await disbandFaction(faction, month, year);
        }
    }

    // Transfer roster feuds if all participants transferred
    const feudsTransferred = [];
    for (const feud of competitorActiveFeuds) {
        const feudParticipants = await getFeudParticipants(feud);
        if (feudParticipants[0].objectName === 'superstar') {
            if (feudParticipants.every(x => objectInArray(x, superstarsForMainRoster))) {
                await addRosterFeuds(companyMainRoster, [feud]);
                feudsTransferred.push(feud);
            }
        } else if (feudParticipants[0].objectName === 'tagTeam') {
            if (feudParticipants.every(x => objectInArray(x, tagTeamsForMainRoster))) {
                await addRosterFeuds(companyMainRoster, [feud]);
                feudsTransferred.push(feud);
            }
        } else if (feudParticipants[0].objectName === 'faction') {
            if (feudParticipants.every(x => objectInArray(x, factionsForMainRoster))) {
                await addRosterFeuds(companyMainRoster, [feud]);
                feudsTransferred.push(feud);
            }
        }
    }

    // Decrease market size, move some fans to competitors
    if (game.marketSize !== null) {
        const lostFans = competitor.fans * 0.50;
        game.marketSize -= lostFans;
        competitor.fans = lostFans;
    } else {
        // Add fans
        const fansToMove = myround(competitor.fans * getRandomUniform(0.5, 0.7), 1000);
        userCompany.fans += fansToMove;
        competitor.fans -= fansToMove;
    }

    // Change company to inactive
    competitor.operatingStatus = 'Inactive';

    // Add messages
    const companyStaffMembers = await getCompanyStaff(userCompany);
    const talentManager = getHighestLevelStaffMemberByRole(companyStaffMembers, 'talent_manager');
    const trainer = getHighestLevelStaffMemberByRole(companyStaffMembers, 'trainer');
    const doctor = getHighestLevelStaffMemberByRole(companyStaffMembers, 'doctor');

    // From doctor about any injured talent brought in
    const injuredSuperstars = superstars.filter(x => x.injured > 0);
    if (injuredSuperstars.length) {
        const newMessage = await createBuyoutCompleteDoctorMessage(competitor, month, year, doctor,
            injuredSuperstars);
        await addCompanyMessages(userCompany, [newMessage]);
    }

    // From one of the top signed superstars
    const sortedSuperstarsForMainRoster = [...superstarsForMainRoster].sort((a, b) => b.popularity - a.popularity);
    let newMessage = await createBuyoutJoinedCompanyMessage(getRandomChoice(sortedSuperstarsForMainRoster.slice(0, 3)),
        month, year);
    await addCompanyMessages(userCompany, [newMessage]);

    // From trainer about who was sent to the training roster
    if (superstarsForTrainingRoster.length) {
        const newMessage = await createBuyoutCompleteTrainer(competitor, month, year, trainer, superstarsForTrainingRoster);
        await addCompanyMessages(userCompany, [newMessage]);
    }

    // From talent manager about what assets were brought in
    newMessage = await createBuyoutCompleteMessage(competitor, month, year, talentManager, superstars,
        championships, tagTeamsForMainRoster, feudsTransferred, factionsForMainRoster);
    await addCompanyMessages(userCompany, [newMessage]);

    // Add userCompany log
    const newLog = CompanyLog(month, year);
    newLog.text = `${userCompany.name} bought out ${competitor.name}`;
    newLog.type = 'buyout';
    newLog.value = 10;
    await addCompanyCompanyLogs(userCompany, [newLog]);

    // Add competitor company log
    const newCompetitorLog = CompanyLog(month, year);
    newCompetitorLog.text = 'Inactive after buyout';
    newCompetitorLog.type = 'inactive';
    newCompetitorLog.value = 10;
    await addCompanyCompanyLogs(competitor, [newLog]);

    // Add news
    let newsItem = await generateNewsItem({
        company: userCompany, month: month, year: year, newsType: 'company_buyout', competitor,
        headline: true
    });
    await addCompanyNewsItems(mainCompany, [newsItem]);

    // Unlock special segment
    await unlockSpecialSegment(userCompany, 'Helicopter Raid', month, year);

    db.saveDatabase();

    // Get data to return
    const unreadMessages = await getCompanyUnreadMessages(userCompany);
    data['unreadMessages'] = unreadMessages.length;

    return data;
}

async function addNewCompanyStaffAndFacilities(company, mainRosterSuperstars, indieAvailableRoster,
                                               sandboxSettings = {}, month = 0, year = 0) {  // add_new_company_staff_and_facilities
    // Add staff
    let companyStaff = [];
    if (globalUser.paid || company.storyName === 'tutorial') {
        let level = 1;
        let numberOfStaffPerRole = 1;
        if (sandboxSettings['maximum_staff_and_facilities']) {
            level = 3;
            numberOfStaffPerRole = 2;
        }
        for (let role of staffRoles) {
            for (let y = 0; y < numberOfStaffPerRole; y++) {
                let staffMember = await generateStaffMember(role, level);
                await addCompanyStaff(company, [staffMember]);
                companyStaff.push(staffMember);
            }
        }
    }

    // Add facilities
    let facilityNames = ['Medical', 'Scouting', 'Production', 'Training', 'Talent Management'];
    let companyFacilities = [];
    for (let facility of facilityNames) {
        let newFacility = Facility();
        Facilities.insert(newFacility);
        newFacility.name = facility;
        if (globalUser.paid || company.storyName === 'tutorial') {
            // Set staffNeverHired to False, as new game messages will be added at the start
            newFacility.staffNeverHired = false;
        }
        await addCompanyFacilities(company, [newFacility]);
        companyFacilities.push(facility);

        // For sandbox, set facility level to 3, actions completed to those required for level 3
        if (sandboxSettings['maximum_staff_and_facilities']) {
            newFacility.level = 3;
            newFacility.actionsCompleted = facilitiesData[newFacility.name]['actionsToNextLevel'][3];
        }
    }

    // Add indie staff
    if (indieAvailableRoster) {
        for (let role of staffRoles) {
            for (let x = 0; x < getRandomInt(3, 4); x++) {
                let staffMember = await generateStaffMember(role);
                await addRosterStaff(indieAvailableRoster, [staffMember]);
            }
        }
    }

    // Add facilities introduction message
    let newMessage = await createIntroduceFacilitiesMessage(month, year, company.ownerName, sandboxSettings);
    await addCompanyMessages(company, [newMessage]);

    // Add staff members introduction message
    newMessage = await createIntroduceStaffMembersMessage(month, year, company.ownerName);
    await addCompanyMessages(company, [newMessage]);

    // Add staff new game messages
    if (globalUser.paid || company.storyName === 'tutorial') {
        let doctor = companyStaff.find(x => x.role === 'doctor');
        newMessage = await createNewCompanyDoctorMessage(mainRosterSuperstars.filter(x => x.injured), month, year, doctor,
            sandboxSettings);
        await addCompanyMessages(company, [newMessage]);

        let trainer = companyStaff.find(x => x.role === 'trainer');
        newMessage = await createNewCompanyTrainerMessage(month, year, trainer, sandboxSettings);
        await addCompanyMessages(company, [newMessage]);

        let scout = companyStaff.find(x => x.role === 'scout');
        newMessage = await createNewCompanyScoutMessage(month, year, scout, sandboxSettings);
        await addCompanyMessages(company, [newMessage]);

        let producer = companyStaff.find(x => x.role === 'producer');
        newMessage = await createNewCompanyProducerMessage(month, year, producer, sandboxSettings);
        await addCompanyMessages(company, [newMessage]);

        let talentManager = companyStaff.find(x => x.role === 'talent_manager');
        newMessage = await createNewCompanyTalentManagerMessage(month, year, talentManager, sandboxSettings);
        await addCompanyMessages(company, [newMessage]);
    }

    return [companyStaff, companyFacilities];
}

async function processSuperstarsYearlyChanges(company, simulating = false) {  // get_yearly_updates
    let data = {};
    let retired = [];
    let turnedPartTimers = [];
    let rosters = await getCompanyRosters(company);
    let mainRoster = await getCompanyRosterByType(company, 'main', rosters);
    let mainRosterSuperstars = await getCompanyMainRosterSuperstars(company);
    let companyChampionships = await getCompanyChampionships(company);
    let game = await getCompanyGame(company);
    let mainCompany = await getGameMainUserCompany(game);
    let draft = await getCompanyDraft(mainCompany);

    // Get ages, different for stories
    let partTimerAge = company.storyName !== 'mars' ? 38 : 45;
    let retirementAge = company.storyName !== 'mars' ? 45 : 55;

    // Runs every first month, don't run if draft running
    if (!company.yearlyCheckRun && (!draft || draft.postEndRun)) {
        company.yearlyCheckRun = true;

        let staffMembers = await getCompanyStaff(company);
        let talentManager = getHighestLevelStaffMemberByRole(staffMembers, 'talent_manager');
        let talentManagementFacility = (await getCompanyFacilities(company))
            .find(facility => facility.name === 'Talent Management');

        // Get minimum appearances for part timers
        let minimumAppearances = 1;
        let guaranteedAppearances = false;
        if (talentManager && talentManagementFacility) {
            if (talentManager.level >= 3 && talentManagementFacility.level >= 3) {
                minimumAppearances = 5;
                guaranteedAppearances = true;
            } else if (talentManager.level >= 2 && talentManagementFacility.level >= 2) {
                minimumAppearances = 3;
                guaranteedAppearances = true;
            }
        }

        setPartTimerAppearances(mainRosterSuperstars, minimumAppearances);

        // Process retirements, part timers, traits lost and age increases after first year
        if (getCompanyYear(company, game) > 0) {
            retired = await processRetired(mainRoster, mainRosterSuperstars, companyChampionships, game.monthCount,
                game.year, company, game, retirementAge);
            turnedPartTimers = await processPartTimers(mainRosterSuperstars, partTimerAge, game, minimumAppearances);
            let traitsLost = processTraitsLoss(mainRosterSuperstars);
            incrementAges(mainRosterSuperstars);

            // Add messages
            for (const s of retired) {
                let newMessage = await createRetirementMessage(s, game.monthCount, game.year, company, staffMembers);
                await addCompanyMessages(company, [newMessage]);
            }
            if (turnedPartTimers.length) {
                let newMessage = await createPartTimersMessage(turnedPartTimers, company, game, staffMembers);
                if (newMessage) {
                    await addCompanyMessages(company, [newMessage]);
                }
            }
            for (const traitLost of traitsLost) {
                let newMessage = await createTraitLostMessage(traitLost, company, game, staffMembers);
                await addCompanyMessages(company, [newMessage]);
            }

            // Process training/indie rosters (except future)
            let otherRosters = rosters.filter(x => x !== mainRoster && !['trainingFuture', 'indieFuture'].includes(x.type));
            for (const roster of otherRosters) {
                await processRosterYearlyChanges(roster, companyChampionships, game, company, retirementAge, partTimerAge)
            }

            // Process competitor rosters
            if (company === mainCompany) {
                for (const competitor of (await getCpuControlledCompanies(company, game))) {
                    const competitorRosters = await getCompanyRosters(competitor);
                    const competitorChampionships = await getCompanyChampionships(competitor);
                    for (const competitorRoster of competitorRosters
                        .filter(x => ['main', 'training', 'trainingAvailable'].includes(x.type))) {
                        await processRosterYearlyChanges(competitorRoster, competitorChampionships, game, competitor,
                            retirementAge, partTimerAge)
                    }
                }
            }
        }

        // Get potential part timers / retirements and add message
        const {partTimerChances, retirementChances} = getPotentialContractChanges(mainRosterSuperstars,
            game, partTimerAge, retirementAge);
        if (partTimerChances.length || retirementChances.length) {
            let newMessage = await createContractsChangeMessage(partTimerChances, retirementChances, company, game,
                staffMembers);
            await addCompanyMessages(company, [newMessage]);
        }

        // Add part timers appearances message
        let partTimers = mainRosterSuperstars.filter(x => x.partTimer && !x.retired && !x.dead
            && !['retirement_return', 'traded'].includes(x.activeEffect) && !x.fullTimeManager);
        if (partTimers.length) {
            let newMessage = await createPartTimersAppearancesSignedForMessage(company, game, partTimers, talentManager,
                guaranteedAppearances, minimumAppearances);
            await addCompanyMessages(company, [newMessage]);
        }

        if (!simulating) {
            db.saveDatabase();
        }
    }

    data['retired'] = retired;

    return data;
}

async function processRosterYearlyChanges(roster, companyChampionships, game, company, retirementAge, partTimerAge) {
    let rosterSuperstars = await getRosterSuperstars(roster);
    setPartTimerAppearances(rosterSuperstars);
    await processRetired(roster, rosterSuperstars, companyChampionships, game.monthCount, game.year, company,
        game, retirementAge);
    await processPartTimers(rosterSuperstars, partTimerAge, game);
    processTraitsLoss(rosterSuperstars);
    incrementAges(rosterSuperstars);
}

function setPartTimerAppearances(superstars, minimumAppearances = 1) {  // set_part_timer_appearances
    let filteredSuperstars = superstars.filter(x => !x.retired && !x.dead &&
        !['retirement_return', 'traded'].includes(x.activeEffect) && !x.fullTimeManager);
    for (const superstar of filteredSuperstars) {
        if (superstar.partTimer) {
            superstar.appearances = getRandomInt(minimumAppearances, 8);
        }
    }
    return true;
}

function getPotentialContractChanges(superstars, game, partTimerAge, retirementAge) {  // process_potential_contract_changes
    // Returns superstars that have a chance to be part timers or retired next year
    let partTimerChances = [];
    let retirementChances = [];
    let filteredSuperstars = superstars.filter(x => !x.retired && !x.dead &&
        !['retirement_return', 'traded'].includes(x.activeEffect) && !x.fullTimeManager);
    for (const superstar of filteredSuperstars) {
        if (superstar.age >= partTimerAge && !superstar.partTimer && !game['settings']['no_going_part_time']) {
            partTimerChances.push(superstar.name);
        }
        if (superstar.age >= retirementAge && !game.settings['no_retirements']) {
            retirementChances.push(superstar.name);
        }
    }
    return {partTimerChances, retirementChances};
}

async function processPartTimers(superstars, age, game, minimumAppearances = 1) {  // process_part_timers
    let turnedPartTimers = [];

    if (!game.settings['no_going_part_time']) {
        let filteredSuperstars = superstars.filter(x => !x.retired && !x.dead && !x.partTimer &&
            !['retirement_return', 'traded'].includes(x.activeEffect) && !x.fullTimeManager);

        for (const superstar of filteredSuperstars) {
            let pick = getRandomInt(0, 100);
            let turnPartTimerChance = 25;
            let superstarTurnPartTimerAge = age;

            // Check for turn part timer traits
            for (let trait of superstar.traits) {
                let traitData = traitsData[trait];
                if (traitData && traitData['part_timer_chance_multiplier']) {
                    turnPartTimerChance *= traitData['part_timer_chance_multiplier'];
                }
                if (traitData && traitData['turn_part_timer_age_change']) {
                    superstarTurnPartTimerAge += traitData['turn_part_timer_age_change'];
                }
            }

            // Turn part timer
            if (superstar.age >= superstarTurnPartTimerAge && pick <= turnPartTimerChance) {
                superstar.partTimer = true;
                superstar.appearances = getRandomInt(minimumAppearances, 8);
                turnedPartTimers.push(superstar.name);
                await checkAcquireTrait(superstar, 'Giving Veteran');
            }
        }
    }

    return turnedPartTimers;
}

async function processRetired(roster, superstars, championships, month, year, company, game, age) {  // process_retired
    let retired = [];

    if (!game.settings['no_retirements']) {
        let filteredSuperstars = superstars.filter(x => !x.retired && !x.dead &&
        !['retirement_return', 'traded'].includes(x.activeEffect) && !x.fullTimeManager);

        for (const superstar of filteredSuperstars) {
            let pick = getRandomInt(0, 100);
            let retirementChance = 25;
            let superstarRetirementAge = age;

            for (let trait of superstar.traits) {
                let traitData = traitsData[trait];
                if (traitData && traitData['retirement_chance_multiplier']) {
                    retirementChance *= traitData['retirement_chance_multiplier'];
                }
                if (traitData && traitData['retirement_age_change']) {
                    superstarRetirementAge += traitData['retirement_age_change'];
                }
            }

            if (superstar.age >= superstarRetirementAge && pick <= retirementChance) {
                let data = await retireSuperstar(superstar, roster, championships, month, year, company);
                retired.push(data);
            }
        }
    }

    return retired;
}

function incrementAges(superstars) {  // increment_ages
    for (const superstar of superstars) {
        superstar.age += 1;
    }
    return true;
}

function processTraitsLoss(superstars) {  // process_traits_loss
    let traitsLost = [];
    let filteredSuperstars = superstars.filter(x => !x.dead && x.traits.length && x.activeEffect !== 'traded');

    for (let superstar of filteredSuperstars) {
        // Check if over trait loss age, which is higher for managers
        let age = superstar.fullTimeManager ? 62 : 42;

        if (superstar.age >= age) {
            let pick = getRandomInt(0, 100);
            let loseTraitChance = 20;

            // Check for lose trait chance multiplier trait
            for (let trait of superstar.traits) {
                let traitData = traitsData[trait];
                if (traitData && traitData['lose_trait_chance_multiplier']) {
                    loseTraitChance *= traitData['lose_trait_chance_multiplier'];
                }
            }

            if (pick <= loseTraitChance) {
                // Don't pick trait that lowers lose trait chance
                let availableTraits = superstar.traits
                    .filter(x => !traitsData[formatSuperstarTrait(x)]['disable_lose_with_age']
                );
                if (availableTraits.length > 0) {
                    let traitToRemove = getRandomChoice(availableTraits);
                    removeTraitFromSuperstar(superstar, traitToRemove);
                    traitsLost.push({'superstar': superstar.name, 'pronoun': superstar.pronoun, 'trait': traitToRemove});
                }
            }
        }
    }

    return traitsLost;
}

async function getViewershipData(companies, game, latestMainCompanyEvent) {  // get_viewership_data
    let data = {};
    data['viewershipData'] = [];
    data['reputationData'] = [];
    let allEventsRan = [];

    // Increase monthlyEventFanChangeMultiplier if no weekly shows
    let monthlyEventFanChangeMultiplier = 5;
    if (game.numberOfWeeklyShows === 0) {
        monthlyEventFanChangeMultiplier = 15;
    }

    let startingFansData = {};
    for (let company of companies) {
        let events = (await getCompanyEvents(company)).filter(x => x.rating !== null).reverse();
        let mainRoster = await getCompanyRosterByType(company, 'main');
        let rosterBrands = await getRosterBrands(mainRoster);
        startingFansData[company.$loki] = company.fans;

        // Skip newly formed company as it will not have a held event
        if (!events.length) {
            continue;
        }

        let event = events[0];

        // Skip if not same event as game's latest event
        if (event.weeklyShow !== latestMainCompanyEvent.weeklyShow || event.weekNumber !== latestMainCompanyEvent.weekNumber) {
            continue;
        }

        // Get events that company ran
        let companyEventsRan = [event];

        // Get multiple shows if present (when competitor has more brands than user)
        let currentBrandIndex = getBrandIndexForWeeklyShow(event, rosterBrands);
        if (event.weeklyShow && currentBrandIndex > 0) {
            // Get brand weekly shows with same week number as last event
            let multipleEventsRan = events.slice(0, 3).filter(x => !x.viewership && x.weeklyShow &&
                rosterBrands.some(y => y.weeklyShowName === x.name) && x.weekNumber === event.weekNumber);
            if (multipleEventsRan.length) {
                companyEventsRan = [...multipleEventsRan].reverse();
            }
        }

        let totalFanChange = 0;
        for (let event of companyEventsRan) {
            // Check if viewership already gotten for event (when user has more brands), don't calculate viewership
            let pastEvent = !!event.viewership;
            let viewership = event.viewership;

            // Get viewership and fan change
            let highHype = 75;
            let fanChange;
            if (event.weeklyShow) {
                if (!viewership) {
                    // Get viewership multiplier based on brand index if present
                    let viewershipFanMultiplier = 0.75;
                    let eventBrandIndex = getBrandIndexForWeeklyShow(event, rosterBrands);
                    if (eventBrandIndex) {
                        if (eventBrandIndex === 1) {
                            viewershipFanMultiplier = 0.68;
                        } else if (eventBrandIndex === 2) {
                            viewershipFanMultiplier = 0.61;
                        }
                    }
                    viewership = company.fans * viewershipFanMultiplier + (event.hype / highHype * company.fans * 0.25);
                }
                fanChange = (event.rating - 3.5) / 30.0 * viewership;
            } else {
                // Get buys if monthly show
                if (!viewership) {
                    viewership = company.fans * 0.02 + (event.hype / highHype * company.fans * 0.06);
                }
                fanChange = (event.rating - 3.5) / 30.0 * viewership * monthlyEventFanChangeMultiplier;
            }

            // Fix low fan change
            if (0 <= fanChange && fanChange < 100) {
                if (fanChange < 10) {
                    fanChange += 10;
                }
                fanChange *= 10;
            }

            if (!event.viewership) {
                if (viewership < 1000) {
                    viewership = myround(viewership, 100);
                } else {
                    viewership = myround(viewership, 1000);
                }
                event.viewership = viewership;
            }

            totalFanChange += fanChange;

            let ratingData = {};
            ratingData['company'] = formatCompanyNameBackend(company.name);
            ratingData['viewership'] = viewership;
            ratingData['rating'] = event.rating;
            ratingData['event'] = event.name;
            ratingData['brandName'] = event.brandName;
            ratingData['brandColor'] = getBrandColorForEvent(event, rosterBrands);
            ratingData['weeklyShow'] = event.weeklyShow;
            ratingData['playerName'] = company.playerName;
            ratingData['isUserControlled'] = company.userControlled;
            ratingData['uid'] = company.$loki;
            if (event.weeklyShow) {
                ratingData['nielsenRating'] = getNielsenRatingFromViewership(viewership);
            }
            ratingData['pastEvent'] = pastEvent;  // If past event, show 'last weekly show' label on viewership page
            data['viewershipData'].push(ratingData);

            allEventsRan.push(event);
        }

        // Add fans to company
        company.fans += totalFanChange / companyEventsRan.length;
    }

    // Limit fans to market size
    let totalFans = companies.map(x => x.fans).reduce((acc, curr) => acc + curr, 0);
    let multiplyValue = game.marketSize / totalFans;
    for (let company of companies) {
        let events = (await getCompanyEvents(company)).filter(x => x.rating !== null).reverse().slice(0, 3);

        // Get total fan change for company
        company.fans = myround(company.fans * multiplyValue, 100);
        let totalFanChange = company.fans - startingFansData[company.$loki];

        // Add fans gained and total fans to events
        let companyEventsRan = events.filter(x => objectInArray(x, allEventsRan)).reverse();
        let eventStartingFans = startingFansData[company.$loki];  // Use to add totalFans to multiple events
        for (let event of companyEventsRan) {
            // Divide fan change between multiple events (when competitor has more brands than user)
            let eventFanChange = totalFanChange / companyEventsRan.length;
            if (event.fansGained) {
                // Add to existing fansGained if present (when user has more brands)
                event.fansGained += eventFanChange;
            } else {
                event.fansGained = eventFanChange;
            }
            event.totalFans = eventStartingFans + eventFanChange;
            eventStartingFans += eventFanChange;
        }

        // Add to data
        let ratingData = data['viewershipData'].find(x => x['uid'] === company.$loki);
        if (ratingData) {
            ratingData['fans'] = company.fans;
            ratingData['fanChange'] = totalFanChange;
            // If multiple company events ran (when competitor has more brands), show 'total' label on viewership page
            if (companyEventsRan.length > 1) {
                ratingData['multipleCompanyEvents'] = true;
            }
        }

        // Update reputation, add data if user controlled company
        let reputationData = updateCompanyReputation(company, totalFanChange, startingFansData, game);
        if (company.userControlled) {
            data['reputationData'].push(reputationData);
        }
    }

    // Sort by viewership
    data['viewershipData'].sort((a, b) => b['viewership'] - a['viewership']);

    return data;
}

function updateCompanyReputation(company, fanChange, startingFansData, game) {  // update_company_reputation
    let data = {};
    let xpToNextReputation = reputationXpLevels[company.reputation + 1];
    let xpToPreviousReputation = reputationXpLevels[company.reputation];

    let xpChange;
    try {
        xpChange = Math.round(fanChange / startingFansData[company.$loki] * 500.0);
    } catch (e) {
        xpChange = 0;
    }
    if (xpChange < 0) {
        xpChange = Math.round(xpChange / 2);
    }
    if (xpChange >= 50) {
        xpChange = 50;
    }
    company.xp += xpChange;
    company.xp = limitValueBetweenRange(company.xp, 0, 600);

    // Check for reputation change
    if (company.xp >= xpToNextReputation && company.reputation < 10) {
        company.reputation += 1;
        data['reputationIncrease'] = true;

        // Get xp levels again
        xpToNextReputation = reputationXpLevels[company.reputation + 1];
        xpToPreviousReputation = reputationXpLevels[company.reputation];

        // Update highestReputation
        if (company.reputation > company.highestReputation) {
            company.highestReputation = company.reputation;
        }

        data['rosterSize'] = getCompanyRosterCapacity(company, game);

    } else if (company.xp < xpToPreviousReputation && company.reputation > 1) {
        // Reputation decrease
        company.reputation -= 1;
        data['reputationDecrease'] = true;

        // Get xp levels again
        xpToNextReputation = reputationXpLevels[company.reputation + 1];
        xpToPreviousReputation = reputationXpLevels[company.reputation];

        data['rosterSize'] = getCompanyRosterCapacity(company, game);
    }

    data['xpToPreviousReputation'] = xpToPreviousReputation;
    data['reputation'] = company.reputation;
    data['reputationXpChange'] = xpChange;
    data['reputationXp'] = company.xp;
    data['xpToNextReputation'] = xpToNextReputation;
    data['companyName'] = company.name;

    return data;
}

async function changeCurrentCompany({uid} = {}) {  //_change_current_company / _switch_user_company
    let data = {};
    const game = await getCurrentGame();
    const userCompanies = await getUserControlledCompanies(game);

    // Get company to switch to
    let companyToSwitchTo;
    if (uid) {
        companyToSwitchTo = userCompanies.find(x => x.$loki === uid);
    }
    else {
        const currentCompany = await getGameCurrentUserCompany(game);
        companyToSwitchTo = userCompanies.find(x => x.$loki !== currentCompany.$loki);
    }
    if (!companyToSwitchTo) {
        data['error'] = 'company-not-found';
        return data;
    }

    // Check if turn not ended
    if (companyToSwitchTo.turnStatus === 'ended') {
        data['error'] = 'turn-ended';
        data['playerName'] = companyToSwitchTo.playerName;
        return data;
    }

    // Set current company
    setGameCurrentCompany(game, companyToSwitchTo);

    db.saveDatabase();

    return data;
}

async function getUserCompanies({} = {}) { // _get_user_companies
    let data = {};
    const game = await getCurrentGame();
    const userCompanies = await getUserControlledCompanies(game)

    // Get data for user companies
    data['companies'] = [];
    for (const userCompany of userCompanies) {
        let userCompanyData = {'name': userCompany.name, 'uid': userCompany.$loki,
            'playerName': userCompany.playerName, 'turnStatus': userCompany.turnStatus}
        data['companies'].push(userCompanyData);
    }

    // Get current company's name
    const currentCompany = await getGameCurrentUserCompany(game);
    data['currentCompanyName'] = currentCompany.name;

    return data;
}

async function getFormNewCompanyInformation() {
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);

    // Generate owner name
    data['ownerName'] = generateFormNewCompanyOwnerName(userCompany);

    // Check other requirements
    data['yearsAtCompanyFulfilled'] = getCompanyYear(userCompany, currentGame) >= 2;
    data['yearsAtCompany'] = getCompanyYear(userCompany, currentGame);
    data['points'] = userCompany.points;
    const companies = await getGameActiveCompanies(currentGame);
    data['companySpaceAvailable'] = companies.length < gameLimits.maxCompetitors + 1;

    return data;
}

function generateFormNewCompanyOwnerName(userCompany) {
    const companyRandom = new Math.seedrandom(userCompany.meta.created);
    let ownerGender = (getRandomInt(0, 100, companyRandom) <= 60) ? 'male' : 'female';
    return generateName(ownerGender, companyRandom());
}

async function startFormingNewCompany() {
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const cost = 5000;
    const companies = await getGameActiveCompanies(currentGame);

    // Check local multiplayer
    if (currentGame.settings['control_multiple_companies']) {
        data['error'] = 'local-multiplayer';
        return data;
    }

    // Check stories
    if (userCompany.storyName) {
        data['error'] = 'story';
        return data;
    }

    // Check paid
    if (!globalUser.paid) {
        data['error'] = 'paid-only';
        return data;
    }

    // Check if already forming
    if (userCompany.newCompanyData?.monthsToForm !== undefined) {
        data['error'] = 'already-forming';
        return data;
    }

    // Check cost
    if (userCompany.points < cost) {
        data['error'] = 'not-enough-points';
        return data;
    }

    // Check years
    if (getCompanyYear(userCompany, currentGame) < 2) {
        data['error'] = 'not-enough-years';
        return data;
    }

    // Check companies
    if (companies.length >= gameLimits.maxCompetitors + 1) {
        data['error'] = 'not-enough-space';
        return data;
    }

    const ownerName = generateFormNewCompanyOwnerName(userCompany);

    // Add new company data
    userCompany.newCompanyData = {monthsToForm: 3, ownerName};

    // Add message
    const currentOwnerMessage = await createFormingNewCompanyCurrentOwnerMessage(userCompany.ownerName,
        currentGame.monthCount, currentGame.year);
    await addCompanyMessages(userCompany, [currentOwnerMessage]);
    const newOwnerMessage = await createFormingNewCompanyNewOwnerMessage(ownerName, currentGame.monthCount,
        currentGame.year);
    await addCompanyMessages(userCompany, [newOwnerMessage]);

    // Remove points
    userCompany.points -= cost;

    db.saveDatabase();

    // Get data to return
    data['points'] = userCompany.points;
    const unreadMessages = (await getCompanyMessages(userCompany)).filter(x => !x.read);
    data['unreadMessages'] = unreadMessages.length;
    data['ownerName'] = ownerName;

    return data;
}

async function confirmNewCompanyDetails({companyDetails}) {
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const companies = await getGameActiveCompanies(currentGame);

    if (userCompany.newCompanyData.companyDetails) {
        data['error'] = 'already-done';
        return data;
    }

    // Check company name
    if (companies.map(x => x.name).includes(companyDetails.companyName)) {
        data['error'] = 'name-exists';
        return data;
    }

    // Add new company data
    userCompany.newCompanyData.companyDetails = companyDetails;

    // Add message
    const ownerName = userCompany.newCompanyData.ownerName;
    const newMessage = await createNewCompanyOwnerDetailsMessage(ownerName, companyDetails.companyName, userCompany.name,
        currentGame.monthCount, currentGame.year);
    await addCompanyMessages(userCompany, [newMessage]);

    db.saveDatabase();

    // Get data to return
    data['ownerName'] = ownerName;

    return data;
}

async function getNewCompanySelectionsData(company) {
    let data = {};
    const superstars = await getCompanyMainRosterSuperstars(company);
    const companyChampionships = await getCompanyChampionships(company);
    const interestedSuperstars = await getNewCompanyInterestedSuperstars(company, superstars);
    data['selectionsAvailable'] = 30;

    // Get superstars, sort by popularity
    data['superstars'] = superstars.map(x => ({
        'name': x.name, 'popularity': x.popularity, 'age': x.age,
        'uid': x.$loki, 'appearances': x.partTimer ? x.appearances : null,
        'retired': x.retired,
        'injured': x.injured > 0 ? x.injured : false,
        'championships': getSuperstarChampionshipsAll(x, companyChampionships),
        'interested': objectInArray(x, interestedSuperstars),
        'fullTimeManager': x.fullTimeManager
    }));
    data['superstars'].sort((a, b) => b.popularity - a.popularity);

    return data;
}

async function getNewCompanyInterestedSuperstars(company, rosterSuperstars) {
    const companyRandom = new Math.seedrandom(company.meta.created);
    let interestedSuperstars = [];

    // Get interested superstars based on morale
    for (let x of rosterSuperstars) {
        let chance;

        if (x.morale >= 100) {
            chance = 100
        }
        else if (x.morale >= 90) {
            chance = 70
        }
        else if (x.morale >= 80) {
            chance = 50
        }
        else if (x.morale >= 60) {
            chance = 15
        }
        else {
            chance = 2
        }

        if (x.unhappy) {
            chance = 0
        }

        if (getRandomInt(0, 100, companyRandom()) <= chance) {
            interestedSuperstars.push(x)
        }
    }

    return interestedSuperstars;
}

async function confirmNewCompanyTalent({superstarUids} = {}) {
    let data = {};
    const game = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(game);

    if (userCompany.newCompanyData.talentDetails) {
        data['error'] = 'already-done';
        return data;
    }

    // Add talent company data
    const superstars = await getCompanyMainRosterSuperstars(userCompany);
    const interestedSuperstars = await getNewCompanyInterestedSuperstars(userCompany, superstars);
    userCompany.newCompanyData.talentDetails = {interestedIds: interestedSuperstars.map(x => x.$loki),
        selectedIds: superstarUids};

    // Add message
    let interestedSelectedTalent = interestedSuperstars.find(x => superstarUids.includes(x.$loki));
    if (interestedSelectedTalent) {
        const interestedMessage = await createNewCompanyInterestedTalentMessage(interestedSelectedTalent,
            game.monthCount, game.year);
        await addCompanyMessages(userCompany, [interestedMessage]);
    }
    const currentOwnerMessage = await createNewCompanyCurrentOwnerTalentMessage(userCompany.ownerName,
        userCompany.newCompanyData.companyDetails.companyName, game.monthCount, game.year);
    await addCompanyMessages(userCompany, [currentOwnerMessage]);
    const ownerName = userCompany.newCompanyData.ownerName;
    const newMessage = await createNewCompanyOwnerTalentMessage(ownerName, superstarUids.length, game.monthCount,
        game.year);
    await addCompanyMessages(userCompany, [newMessage]);

    // Add news
    let newsItem = await generateNewsItem({
        company: userCompany, month: game.monthCount, year: game.year, newsType: 'new_user_company', headline: true,
        newOwnerName: ownerName, newCompanyName: userCompany.newCompanyData.companyDetails.companyName
    });
    await addCompanyNewsItems(userCompany, [newsItem]);

    db.saveDatabase();

    // Get data to return
    data['ownerName'] = ownerName;

    return data;
}

async function formNewCompany() {
    let data = {};
    const game = await getCurrentGame();
    const company = await getGameCurrentUserCompany(game);
    const indieRoster = await getCompanyRosterByType(company, 'indie');
    const indieAvailableRoster = await getCompanyRosterByType(company, 'indieAvailable');
    const indieFutureRoster = await getCompanyRosterByType(company, 'indieFuture');
    const newCompanyData = company.newCompanyData;
    const companyDetails = newCompanyData.companyDetails;

    // Get superstars selected from previous company
    const previousCompanySuperstars = await getCompanyMainRosterSuperstars(company);
    const interestedIds = newCompanyData.talentDetails.interestedIds;
    const selectedIds = newCompanyData.talentDetails.selectedIds;
    const selectedSuperstars = previousCompanySuperstars.filter(x => selectedIds.includes(x.$loki));
    let previousCompanySuperstarsToAdd = [];
    let newCompanySuperstars = [];
    for (let x of selectedSuperstars) {
        let joinChance = 20;
        if (interestedIds.includes(x.$loki)) {
            joinChance = 100;
        }
        else {
            if (x.morale >= 60) {
                joinChance += 30
            }
            if (x.unhappy) {
                joinChance -= 60
            }
            if (x.traits.includes('Rebel')) {
                joinChance += 40
            }
            if (x.traits.includes('Loyal')) {
                joinChance -= 40
            }
        }
        if (getRandomInt(0, 100) <= joinChance) {
            previousCompanySuperstarsToAdd.push(x);
        }
    }
    newCompanySuperstars.push(...previousCompanySuperstarsToAdd);

    // Get superstars from indies and competitors
    const indieSuperstars = await getRosterSuperstars(indieRoster).concat(await getRosterSuperstars(indieAvailableRoster));
    const indieSuperstarsToAdd = getRandomSample(indieSuperstars, getRandomInt(24, 26));
    newCompanySuperstars.push(...indieSuperstarsToAdd);
    let competitorSuperstars = [];
    for (let x of await getGameActiveCompanies(game)) {
        if (x.$loki !== company.$loki) {
            competitorSuperstars.push(...await getCompanyMainRosterSuperstars(x));
        }
    }
    const competitorSuperstarsToAdd = getRandomSample(competitorSuperstars, getRandomInt(4, 6));
    newCompanySuperstars.push(...competitorSuperstarsToAdd);

    // Generate superstars if not enough
    while (newCompanySuperstars.length < 20) {
        let newSuperstar = await generateSuperstar({generateGimmick: false});
        newCompanySuperstars.push(newSuperstar);
    }

    // Get starting event index
    const parentEvents = await getCompanyParentEvents(company);
    const nextEvent = (await getCompanyEvents(company)).filter(x => !x.weeklyShow && !x.temporaryEvent).reverse()[0];
    const parentEventsNames = parentEvents.map(x => x.name);
    const startingEventIndex = parentEventsNames.indexOf(nextEvent.name);

    // Create company
    const newCompany = await createCompany(companyDetails, newCompanySuperstars, newCompanyData.ownerName,
        startingEventIndex, company, game);
    newCompany.introducedPowerups = true;
    newCompany.userControlled = true;
    newCompany.newUserCompany = true;
    newCompany.month = 0;
    newCompany.year = 0;

    // Add company log
    const newLog = CompanyLog(game.monthCount, game.year);
    CompanyLogs.insert(newLog);
    newLog.text = `New Company formed: ${companyDetails.companyName}`;
    newLog.type = 'new_company';
    newLog.value = 8;
    await addCompanyCompanyLogs(newCompany, [newLog]);

    // Add message from top superstar
    let topSuperstars = [...newCompanySuperstars].sort((a, b) => b.popularity - a.popularity).slice(0, 3);
    let newMessage = await createJoinedCompanySuperstarMessage(getRandomChoice(topSuperstars),
        game.monthCount, game.year);
    await addCompanyMessages(newCompany, [newMessage]);

    // Add message from competitor
    let competitors = await getCpuControlledCompanies(company, game);
    if (competitors.length) {
        let competitorMessage = await createCustomStartingCompanyCompetitorMessage(getRandomChoice(competitors),
            game.monthCount, game.year);
        await addCompanyMessages(newCompany, [competitorMessage]);
    }

    // Add message from owner about talent
    if (previousCompanySuperstarsToAdd.length || competitorSuperstarsToAdd.length) {
        let ownerMessage = await createNewCompanyJoinedTalentMessage(newCompanyData.ownerName, company.name,
            previousCompanySuperstarsToAdd, competitorSuperstarsToAdd, game.monthCount, game.year);
        await addCompanyMessages(newCompany, [ownerMessage]);
    }

    // Reset newCompanyData for previous company, set as cpu
    company.newCompanyData = {};
    company.userControlled = false;
    if (game.settings['unlimited_creative_points']) {
        company.points = 10000;
    }

    // Undo running buyouts
    for (let x of await getGameActiveCompanies(game)) {
        if (x.operatingStatus.includes('Negotiating Buyout') || x.operatingStatus.includes('Running Buyout')) {
            x.operatingStatus = 'Buyout Available'
        }
    }

    // Transfer indie roster, annual tournaments and news to new user company (as its not main user company)
    await addCompanyRosters(newCompany, [indieRoster, indieAvailableRoster, indieFutureRoster]);
    const annualTournaments = (await getCompanyTournaments(company)).filter(y => y.annualTournament);
    await addCompanyTournaments(newCompany, annualTournaments);
    const allNewsItems = await getCompanyNewsItems(company);
    await addCompanyNewsItems(newCompany, allNewsItems);

    // Set competitors present and market size, fans
    game.competitorsPresent = true;
    if (game.marketSize === null && globalUser.paid) {
        game.marketSize = 4000000;
        const gameCompanies = await getGameCompanies(game);
        const reputationXpLevels = {
            1: 0, 2: 10, 3: 30, 4: 60, 5: 100, 6: 150, 7: 210, 8: 280, 9: 360, 10: 450, 11: 550
        };
        let totalFans = gameCompanies.reduce((n, {fans}) => n + fans, 0);
        for (const company of gameCompanies) {
            company.fans = (company.fans / totalFans) * game.marketSize;
            company.fans = myround(company.fans, 1000);
            if (company.fans < 20000) {
                company.fans = 20000
            }
            company.xp = reputationXpLevels[company.reputation];
            company.xp += (reputationXpLevels[company.reputation + 1] - company.xp) / 10.0;
        }
    }

    return data;
}

async function createCompany(companyDetails, superstars, ownerName, startingEventIndex, previousCompany, game) {

    // Add company
    let company = Company();
    await Companies.insert(company);
    await addGameCompanies(game, [company]);

    // Add details
    company.name = companyDetails.companyName;
    company.style = companyDetails.companyStyle;
    company.ownerName = ownerName;
    company.realYear = previousCompany.realYear;
    company.reputation = 5;
    company.highestReputation = 5;
    company.weeklyShowName = companyDetails.weeklyShowName;
    company.fans = fanLevels[company.reputation - 1];
    company.points = 2000;
    if (game.settings['unlimited_creative_points']) {
        company.points = 1000000;
    }
    company.overness = 45 + getRandomInt(-3, 5);

    // Add fans/xp
    if (game.marketSize !== null) {
        // Add fans, percentage of market size
        company.fans = 0.0125 * company.reputation * game.marketSize;
        company.fans = myround(company.fans, 10000);

        // Increase market size
        game.marketSize += company.fans;

        // Add reputation xp
        company.xp = reputationXpLevels[company.reputation];
        company.xp += (reputationXpLevels[company.reputation + 1] - company.xp) / 10.0;
    }

    // Add events
    for (let eventData of companyDetails.companyMonthlyEventsData) {
        let newEvent = Event(eventData.name);
        await Events.insert(newEvent);
        newEvent.prestige = eventData.prestige;
        newEvent.xp = eventPrestigeXps[eventData.prestige] || 0;
        await addCompanyEvents(company, [newEvent]);
    }

    // Add starting event with prestige
    let events = await getCompanyEvents(company);
    let topEvent = getArrayMaxByProperty(events, 'xp')
    let parentEvent = events[startingEventIndex];
    let prestige = parentEvent.prestige;
    let startingEventIsTop = parentEvent.$loki === topEvent.$loki;
    let hype = await getEventHype(parentEvent, startingEventIsTop);
    let startingEvent = Event(parentEvent.name);
    await Events.insert(startingEvent);
    startingEvent.prestige = prestige;
    startingEvent.hype = hype;
    await addCompanyEvents(company, [startingEvent]);
    await addChildEvent(parentEvent, startingEvent);

    // Set top event xp
    let topXps = {'A': 160, 'B': 80, 'C': 25};
    topEvent.xp = topXps[topEvent.prestige] || 0;

    // Add main roster
    let mainRoster = Roster('main');
    await Rosters.insert(mainRoster);
    await addCompanyRosters(company, [mainRoster]);

    // Move superstars
    for (const superstar of superstars) {
        let superstarCompany = await getTalentCompany(superstar);
        if (!superstarCompany) {
            superstarCompany = previousCompany
        }
        await processSuperstarLeavingCompany(superstar, superstarCompany, false, false, false);
        superstar.faceOfTheCompanyCounter = 0;
        superstar.suspensionMonths = 0;
        superstar.winsTemporary = 0;
        superstar.lossesTemporary = 0;
        for (const negotiation of (await getSuperstarNegotiations(superstar))) {
            await Negotiations.remove(negotiation);
        }
        // Process tag teams
        const superstarTagTeams = await getSuperstarTagTeams(superstar);
        for (let tagTeam of superstarTagTeams) {
            const tagTeamSuperstars = await getTagTeamSuperstars(tagTeam);
            if (tagTeamSuperstars.every(x => objectInArray(x, superstars))) {
                await addRosterTagTeams(mainRoster, [tagTeam]);
                // Add company log
                const newLog = CompanyLog(game.monthCount, company.realYear);
                CompanyLogs.insert(newLog);
                newLog.text = tagTeam.name;
                newLog.value = 0;
                newLog.type = 'signing';
                newLog.realYear = game.year;
                await addCompanyCompanyLogs(company, [newLog]);
            }
            else {
                await removeTagTeam(tagTeam)
            }
        }
        // Add company log
        const newLog = CompanyLog(game.monthCount, company.realYear);
        CompanyLogs.insert(newLog);
        newLog.text = superstar.name;
        newLog.value = 0;
        newLog.type = 'signing';
        newLog.realYear = game.year;
        await addCompanyCompanyLogs(company, [newLog]);
    }
    await addRosterSuperstars(mainRoster, superstars);

    // Add training roster
    let trainingRoster = Roster('training');
    await Rosters.insert(trainingRoster);
    await addCompanyRosters(company, [trainingRoster]);
    let companyTrainingSuperstars = [];
    if (companyDetails.trainingRosterOption === 'generate') {
        for (let x of Array(getRandomInt(10, 15)).keys()) {
            let newSuperstar = await generateSuperstar({generateGimmick: false});
            companyTrainingSuperstars.push(newSuperstar);
        }
    }
    await addRosterSuperstars(trainingRoster, companyTrainingSuperstars);

    // Add training available and future rosters
    let trainingAvailableRoster = Roster('trainingAvailable');
    await Rosters.insert(trainingAvailableRoster);
    await addCompanyRosters(company, [trainingAvailableRoster]);
    let trainingFutureRoster = Roster('trainingFuture');
    await Rosters.insert(trainingFutureRoster);
    await addCompanyRosters(company, [trainingFutureRoster]);

    // Add championships
    const divisionChampionshipsData = {'singles': 1, 'tag-team': 2, 'trio': 3};
    for (let [i, championshipData] of companyDetails.companyChampionshipsData.entries()) {
        // Get number of championships
        let divisionChampionships = divisionChampionshipsData[championshipData['division']] || 1;

        // Get graphic if present
        let graphic = null;
        if (championshipData.graphic) {
            graphic = JSON.parse(championshipData.graphic);
        }

        // Get rank
        let rankName;
        if (i === 0) {
            rankName = 'Main Eventer';
        } else {
            rankName = 'Upper Midcarder';
        }

        // Create championships and add to company
        for (let z of Array(divisionChampionships).keys()) {
            let newChampionship = Championship(championshipData.name);
            await Championships.insert(newChampionship);

            if (graphic) {
                newChampionship.graphic = graphic;
            }
            newChampionship.rank = rankName;
            newChampionship.vacated = true;
            if (championshipData.division === 'tag-team') {
                newChampionship.tagTeam = true;
            } else if (championshipData.division === 'trio') {
                newChampionship.trio = true;
            }
            newChampionship.prestige = championshipData.prestige;
            newChampionship.highestPrestige = championshipData.prestige;
            newChampionship.xp = championshipPrestigeXps[championshipData.prestige] || 0;
            if (newChampionship.prestige !== 'C') {
                newChampionship.xp += 10;  // Add xp over prestige base value
            }

            await addCompanyChampionships(company, [newChampionship]);
        }
    }

    // Add standard gimmick matches
    for (let x of await getCompanyGimmickMatches(previousCompany)) {
        let newGimmickMatch = {...GimmickMatch(), ...JSON.parse(JSON.stringify(x))}
        delete newGimmickMatch.$loki;
        await GimmickMatches.insert(newGimmickMatch);
        await addCompanyGimmickMatches(company, [newGimmickMatch]);
    }

    // Add previous segment and feud items, powerups
    for (let x of await getCompanySegmentItems(previousCompany)) {
        let newSegmentItem = {...SegmentItem(), ...JSON.parse(JSON.stringify(x))};
        delete newSegmentItem.$loki;
        await SegmentItems.insert(newSegmentItem);
        await addCompanySegmentItems(company, [newSegmentItem]);
    }
    for (let x of await getCompanyFeudItems(previousCompany)) {
        let newFeudItem = {...FeudItem(), ...JSON.parse(JSON.stringify(x))};
        delete newFeudItem.$loki;
        await FeudItems.insert(newFeudItem);
        await addCompanyFeudItems(company, [newFeudItem]);
    }
    for (const x of await getCompanyPowerups(previousCompany)) {
        let newPowerup = {...Powerup(), ...JSON.parse(JSON.stringify(x))};
        delete newPowerup.$loki;
        await Powerups.insert(newPowerup);
        await addCompanyPowerups(company, [newPowerup]);
    }

    // Add staff and facilities
    let mainRosterSuperstars = await getRosterSuperstars(mainRoster);
    await addNewCompanyStaffAndFacilities(company, mainRosterSuperstars, null, game.settings, game.monthCount, game.year);

    // Add objectives
    let objectives = await generateCompanyObjectives(company, game);
    await addCompanyObjectives(company, objectives);

    return company
}

function getCompanyMonth(company, game) {
    if (company.newUserCompany) {
        return company.month;
    }
    return game.monthCount;
}

function getCompanyYear(company, game) {
    if (company.newUserCompany) {
        return company.year;
    }
    return game.year;
}

export {getCurrentMonth, getCompanyLatestEvent, getCompanyMainRosterSuperstars,
    getCompanyParentEvents, getBuyoutSuperstars, getNumberOfBuyoutSignings, getBuyoutData,
    runningBuyoutCheck, getViewCompaniesData, getCompanyRosterByType, getActiveCompetitorsForCompany,
    getCompanyRosterCapacity, getCompanySelectData, getMakeTradeOfferData, getHighestLevelStaffMemberByRole,
    getViewObjectivesData, getViewManagementActivityData, getFanHistoryData, getViewCompanyStaffData,
    getViewCompanyFacilitiesData, upgradeCompanyFacility, getViewIndieStaffData, hireStaffMember, fireStaffMember,
    getEditStaffMemberData, changeStaffMemberGraphic, changeStaffMemberName, changeStaffMemberPronoun,
    cancelStaffMemberTask, getYearlyRankingsHistoryData, getAnnualTournamentHistoryData, getAnnualTournamentStatsData,
    getViewStatsData, getViewTournamentsData, getViewGimmickMatchesData, getRemoveGimmickMatchesData,
    removeGimmickMatch, addGimmickMatch, getViewSegmentsData, getEditSegmentsData, removeSegmentItem,
    getEditSegmentData, addCustomSegmentItem, editCustomSegmentItem, getViewTitlesData, getCompanyBrandNames,
    getCompanyGimmickMatchesForChampionshipGimmick, getCompanyChampionshipsData, vacateChampionship,
    retireChampionship, addChampionship, rebrandChampionship, rebrandCompany, updateObjectOverness,
    getCompanyUnreadMessages, getCompanyOwnerName, getRandomStaffMemberByRole, addFormerCompanyRelationship,
    getAddStaffTaskData, addStaffTask, getAddManagerRelationshipData, getRemoveManagerRelationshipData,
    addManagerRelationship, removeManagerRelationship, getTutorialStateName, getCompanyStartingMonth,
    getCompanySuperstarsData, updateCompanyLogsForChampionshipNameChange, getAvailableStaffMembers,
    getStaffMemberGraphic, getCpuControlledCompanies, getBuyoutInformation, confirmBuyoutSelections,
    getAvailableStaffMembersByRole, getChampionshipReignLength, getCompanyProducers, removeStaffTaskData,
    getBookingGimmickMatchesData, generateGimmickMatchObject, generateGimmickMatchLocation, generateGimmickMatch,
    generateGimmickMatchObjectName, generateGimmickMatchLocationName, getCompanyUniqueTournaments,
    getTournamentDisplayData, changeProperty, processChampionshipXpChange, createCompanyAlert, updateStaffMemberXp,
    getStaffAgeMultiplier, updateCompanyLogsForTalentNameChange, checkObjectHot, checkObjectStale,
    getMatchGimmickFatigueIncrease, getChampionshipPopularityIncrease, getChampionshipPopularityDecrease,
    processObjectiveCompleted, checkFacilityUpgrade, reviewObjectives, makeBuyoutOffer,
    getChampionshipCost, getTransitionToStaffMemberRoleBoostData, addNewCompetitorCheck, checkCompetitorsAvailableForBuyout,
    addNewCompanyStaffAndFacilities, processSuperstarsYearlyChanges, getViewershipData,
    getUserCompanies, changeCurrentCompany, createCustomSegmentItem, getFormNewCompanyInformation, startFormingNewCompany,
    confirmNewCompanyDetails, getNewCompanySelectionsData, confirmNewCompanyTalent, formNewCompany, getCompanyMonth,
    getCompanyYear, generateFormNewCompanyOwnerName}